export const de = {
    addDatabase: {
        addDatabase: "Datenbank hinzufÃ¼gen",
        addFromFile: "Aus Datei hinzufÃ¼gen",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Alle GebindegrÃ¶Ãen",
        onePackage: "Eine GebindegrÃ¶Ãe",
        priceType: "Preis Typ",
        setPriceVatVisibility: "MwSt anzeigen",
        setVisibilityAndOrder: "Anzeige und Reihenfolge der Preistypen festlegen",
        withAndWithoutVat: "Preis mit und ohne MwSt anzeigen",
        withVat: "Anzeige mit MwSt",
        withoutVat: "Anzeige ohne MwSt"
    },
    barvis: {
        base: "Name der Base",
        bigCanSize: "GroÃe GebindegrÃ¶Ãe",
        coating: "Anstrich",
        identifier: "Idenfitier",
        laboratory: "Labor",
        orderOverview: "BestellÃ¼bersicht",
        rank: "Rang",
        smallCanSize: "Kleine GebindegrÃ¶Ãen"
    },
    basicSetup: {
        alreadyLoggedIn: "Sie sind als %{login} angemeldet",
        askSupplier: "Bitten Sie Ihren Softwarelieferanten, Ihnen mehr Lizenzen zuzuweisen.",
        asterisk: "Die mit einem Sternchen gekennzeichneten Felder mÃ¼ssen ausgefÃ¼llt werden.",
        identificationKeys: "IdentifikationsschlÃ¼ssel",
        importCustomData:
            "Falls zutreffend, importieren Sie Ihre kundenspezifischen Daten aus der vorherigen Dosiersoftware.",
        learnIdentification: "Sie erhalten die IdentifikationsschlÃ¼ssel von Ihrem Softwarelieferanten.",
        login: "Die folgenden Schritte der Ersteinrichtung erfordern Admin-Rechte.",
        noDatabase: "Es wurde noch keine Datenbank hinzugefÃ¼gt ! Es muss mindestens eine Datenbank hinzugefÃ¼gt werden.",
        offlineLicensing: "Offline-Lizenzierung",
        productSelection: "Produktauswahl",
        registrationForm: "Registrierungsformular",
        seeQuestionMark:
            "Fahren Sie mit der Maus Ã¼ber die kleinen Fragezeichen, dann erscheint ein Baloon-Fenster mit einer entsprechenden ErklÃ¤rung.",
        selectDefaultPrinter: "WÃ¤hlen Sie den Standarddrucker aus und legen Sie zusÃ¤tzliche Einstellungen fest. ",
        selectDefaultTemplate:
            "WÃ¤hlen Sie die Standardvorlage aus den bereits vorhandenen aus, erstellen Sie eine neue Vorlage oder laden Sie Ihre eigene.",
        selectDispenser: "WÃ¤hlen Sie den von Ihnen verwendeten Dispensertyp aus.",
        selectLanguage: "WÃ¤hlen Sie Ihre Sprache.",
        selectProducts: "WÃ¤hlen Sie eines der verfÃ¼gbaren Produkte aus, welches Sie aktivieren mÃ¶chten.",
        selectSpectroType: "WÃ¤hlen Sie das von Ihnen verwendete Spektro aus.",
        setAdditionalPrinterOptions: "ZusÃ¤tzliche Druckeroptionen einstellen.",
        setAutomaticUpdates: "Optionen fÃ¼r automatische Updates einstellen.",
        setCustomItems:
            "Benutzerdefinierte Elemente und die Ansicht der Daten einstellen. Scrollen Sie nach unten, um weitere Optionen zu sehen.",
        setEnvironment:
            "Allgemeine Umgebungseinstellungen der Software einstellen. Scrollen Sie nach unten, um weitere Optionen zu sehen.",
        setFormulaRepresentation:
            "Rezepturdarstellung einstellen. Scrollen Sie nach unten, um weitere Optionen zu sehen.",
        summary:
            "Sie kÃ¶nnen diese Einstellungen jederzeit Ã¤ndern und weitere KonfigurationsmÃ¶glichkeiten einstellen. Viel SpaÃ mit %{name}!",
        summarySuccess: "Sie sind startklar!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batchnummer: %{batchNumber}",
        colorantIsDefective:
            "Der Kanister ist mit einer fehlerhaften Charge des Pigmentkonzentrats gefÃ¼llt. Verwenden Sie diese Charge nicht.",
        defectiveInfoLine1: "Bitte keine Pigmentkonzentrate",
        defectiveInfoLine2: "mit dieser Batch-Nummer verwenden.",
        emptyQuickTint: "Leeren Sie den Kanister mit der Quick-Tint-Funktion",
        warningInfoLine1: "Pigmentpastenkonzentrat(e)",
        warningInfoLine2: "mit dieser Chargennummer kÃ¶nnen beschÃ¤digt sein."
    },
    canisterLevel: {
        canisterLevel: "KanisterfÃ¼llstand einstellen",
        criticalLevelCanister: "Kritische KanisterfÃ¼llstÃ¤nde",
        fillToMax: "FÃ¼llen bis max",
        maxDispenseLevel: "Maximale Dosierung",
        otherCanisters: "Andere KanisterfÃ¼llstÃ¤nde",
        warningLevelCanister: "Warnungs- KanisterfÃ¼llstÃ¤nde"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Chargennummer der FÃ¼llung",
        ufiCodeStatus: "UFI Code status"
    },
    canistersTab: {
        availableServiceActions: "VerfÃ¼gbare Serviceaktionen",
        canisterInformation: "Kanister Information",
        canisterPreview: "Kanister Vorschau",
        currentLevel: "Aktueller FÃ¼llstand",
        errors: "Fehler",
        fillState: "Minimal FÃ¼llstand",
        fillToMax: "FÃ¼llen bis maximalem FÃ¼llstand",
        fillingAmount: "FÃ¼llmenge",
        finalLevel: "Finaler FÃ¼llstand",
        minimumAmount: "MindestfÃ¼llstand",
        minimumLevel: "MinimumfÃ¼llstand",
        moveTableToRefill: "Kanister in die BefÃ¼llposition bringen",
        refillNoAmount: "Es wurde keine Menge eingegeben",
        refillOverLimit: "Die eingegebene Menge Ã¼berschreitet die maximale KanisterkapazitÃ¤t.",
        refillSummary: "%{amount} %{unit} des Pigments %{colorant} wird zum Kanister %{canisterId} hinzugefÃ¼gt.",
        systemWarningAmount: "System Warnlevel",
        warningAmount: "Warnlevel (ReservefÃ¼llstand)"
    },
    changeDatabase: {
        changeDatabase: "Datenbank Ã¤ndern",
        databaseWarning: "Datenbank %{databaseName} kann nicht verwendet werden aufgrund von"
    },
    changelog: {
        allVersion: "Alle Versionen",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Versionsinformationen"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal:
            "Es ist nicht genug Pigmentkonzentrat in den Kanistern um %{numOfPackages} Gebinde zu dosieren.",
        fillAdditionally: "FÃ¼llen Sie zusÃ¤tzlich",
        refillToMax: "Kanister komplett befÃ¼llen"
    },
    cleanChannels: {
        cleanAllChannels: "Alle Kanister reinigen",
        cleanChannels: "Kanister reinigen",
        cleaningTime: "Reinigungszeit",
        selectChannels: "Kanister auswÃ¤hlen",
        startCleaning: "Reinigung starten"
    },
    clientServerSettings: {
        activeServer: "Aktiver Server",
        addNewServer: "Neuen Server hinzufÃ¼gen",
        availableServers: "Weitere verfÃ¼gbare Server",
        clientIdentifier: "Client Identifikation",
        clientServerSettings: "Client/Server-Einstellungen",
        disabledStatus: "deaktiviert",
        editServer: "Server bearbeiten",
        fillRequiredFields: "Alle gekennzeichneten Felder mÃ¼ssen ausgefÃ¼llt werden",
        noOtherServers: "Es sind keine anderen Server verfÃ¼gbar",
        offlineStatus: "offline",
        onlineStatus: "online",
        port: "Port",
        serverName: "Servername",
        serverNameMissing: "Der Servername muss eingegeben werden",
        stabileConnection:
            "Um eine stabile Verbindung zu gewÃ¤hrleisten, verwenden Sie bitte eine statische IP-Adresse.",
        wrongFormatIp: "Falsches Format der IP-Adresse"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Farbton",
        fandeckPosition: "Position der Kollektion",
        moreInfoIcons: "Symbole fÃ¼r mehr Info",
        notExistingFormula: "Keine Rezeptur vorhanden.",
        orderBy: "Sortieren nach",
        selectYourGrid: "WÃ¤hlen Sie das gewÃ¼nschte Raster aus",
        showInPanel: "Im Programmfenster anzeigen",
        warningIcon: "Warnsymbol fÃ¼r nicht existierenden Rezepturen"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Chargennummern prozentual verwenden",
        batchNumberFromLastFilling: "Chargennummern der letzten BefÃ¼llung verwenden",
        defectiveBatchOfColorant: "Defekte Charge vom Pigmentkonzentrat",
        enableBatchNumber: "Chargennummern fÃ¼r Pigmentkonzentrate aktivieren",
        possibleDamagedBatchOfColorant: "MÃ¶glicherweise beschÃ¤digte Pigmentkonzentrat-Charge",
        scanOrTypeBatchNumber: "Chargennummer scannen oder eingeben"
    },
    colorantPanel: {
        manualMachine: "Maschine"
    },
    colorantsTable: {
        numberOfColorants: "Anzahl der Pigmentkonzentrate:",
        preview: "Vorschau",
        prices: "Pigmentpreis pro Liter"
    },
    currencySettings: {
        addNewCurrency: "Neue WÃ¤hrung hinzufÃ¼gen",
        codePlaceholder: "Code",
        currencySettings: "WÃ¤hrungseinstellungen",
        namePlaceholder: "Name",
        ratePlaceholder: "MwSt.-Satz",
        setDecimalPlaces: "Anzahl der Dezimalstellen",
        setMainCurrency: "HauptwÃ¤hrung einstellen",
        setRounding: "Rundung",
        symbolPlaceholder: "Symbol"
    },
    customFandecks: {
        customFandecks: "Kundenspezifische Kollektionen",
        deleteButtonWarning: "Alle Rezepturen in dieser Kollektion werden gelÃ¶scht !",
        deleteCustomFandeck:
            "Wollen Sie diese Kundenspezifische Kollektion wirklich lÃ¶schen - Alle Rezepturen in dieser Kollektion werden gelÃ¶scht !",
        disableStandardFandecks: "Nur benutzerdefinierte FarbtonfÃ¤cher anzeigen",
        enableStandardFandecks: "Standard-FarbtonfÃ¤cher anzeigen",
        fandeckName: "Kollektion"
    },
    customRedlike: {
        addColorantFromBrand: "Pigmentkonzentrat der Marke %{brandName} hinzufÃ¼gen",
        addNewCustomer: "Einen neuen Kunden hinzufÃ¼gen",
        addNewNote: "Eine neue Anmerkung hinzufÃ¼gen",
        addedDate: "Datum hinzugefÃ¼gt",
        addedQuantity: "Menge hinzugefÃ¼gt",
        availableMachine: "Maschine verfÃ¼gbar",
        brand: "Marke",
        brandPlease: "Bitte wÃ¤hlen Sie eine Marke aus",
        cancelCustomer: "Kunde abbrechen",
        colorPlease: "Bitte Farbe auswÃ¤hlen",
        confirmCustomerData: "Kundendaten bestÃ¤tigen",
        confirmNoteData: "Anmerkungen bestÃ¤tigen",
        confirmSelectedUser: "MÃ¶chten Sie den Kunden %{customerName} zu dieser Bestellung hinzufÃ¼gen?",
        confirmed: "BestÃ¤tigt",
        controlData: "EndgÃ¼ltige Datenkontrolle",
        customerCellNumber: "Mobiltelefonnummer des Kunden",
        customerFilter: "Kundenfilter",
        customerName: "Name des Kunden",
        customerPhone: "Telefonnummer des Kunden",
        customerPlease: "Bitte wÃ¤hlen Sie einen Kunden aus",
        dateFilter: "Filter Datum",
        enterPin: "Geben Sie Ihren PIN-Code ein",
        enterTheNumberOfPackages: "Geben Sie die Anzahl der Gebinde ein",
        existingCustomer: "Dieser Kunde existiert bereits",
        fandeckPlease: "Bitte Kollektion auswÃ¤hlen",
        fillCanisterHistory: "Kanisterhistorie des NachfÃ¼llens",
        findCustomer:
            "Um die Kundenkarte diesem Auftrag zuzuordnen, scannen Sie bitte den Barcode oder suchen Sie nach der E-Mail-Adresse.",
        findCustomerByEmail: "Kunden per E-Mail oder Barcode filtern",
        finishPreviousStep: "(Bitte beenden Sie den vorherigen Schritt)",
        formulaUnit: "Rezeptureinheit",
        getBackToList: "ZurÃ¼ck zur Kundenliste",
        historyOfOrders: "Auftragshistorie",
        insertNote: "Weiter zu Notiz einfÃ¼gen",
        loadHistoryOrder: "MÃ¶chten Sie den ausgewÃ¤hlten Auftrag laden?",
        loyaltyCards: "Kundenkarten",
        machineIsAvailable: "MASCHINE IST VERFÃGBAR",
        machineIsUnavailable: "MASCHINE IST NICHT VERFÃGBAR",
        newLoyaltyCard: "Neue Kundenkarte",
        noAvailableMachine: "Maschine ist nicht verfÃ¼gbar",
        noCustomerSelected: "Es wurde kein Kunde ausgewÃ¤hlt. MÃ¶chten Sie fortfahren?",
        notePlease: "Bitte Anmerkung hinzufÃ¼gen",
        openHistory: "Historie Ã¶ffnen",
        orAdd: "oder Kunde hinzufÃ¼gen",
        orSelect: "oder Kunde auswÃ¤hlen",
        orderModification: "Der ursprÃ¼ngliche Auftrag wird geÃ¤ndert. MÃ¶chten Sie fortfahren?",
        orderOverview: "AuftragsÃ¼bersicht",
        orderToMachine: "AUFTRAG WIRD AN DIE MASCHINE GESENDET",
        ordersHistory: "Auftragshistorie",
        packagePlease: "Bitte wÃ¤hlen Sie ein Gebinde aus",
        pleaseSelectBrand: "Bitte wÃ¤hlen Sie eine Marke aus",
        previewImage: "Bildvorschau",
        previewPackage: "Produktbild",
        productPlease: "Bitte wÃ¤hlen Sie ein Produkt aus",
        resetFilters: "Alle Filter zurÃ¼cksetzen",
        searchForHistoricalOrders: "Oder in der Historie nach AuftrÃ¤gen suchen",
        selectBrand: "Bitte eine Marke auswÃ¤hlen",
        selectColor: "Farbton auswÃ¤hlen",
        selectCustomer: "Kunde auswÃ¤hlen",
        selectExistingCustomer: "Vorhandenen Kunde auswÃ¤hlen",
        selectFandeck: "Kollektion auswÃ¤hlen",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Gebinde auswÃ¤hlen",
        selectProduct: "Produktauswahl",
        shotsCoefficient: "Shot-Faktor",
        showDetail: "Detail zeigen",
        showHideEshopName: "Ein-/Ausblenden des eshop-Namens des Farbtons in einer separaten Spalte",
        showKeyboard: "Tastatur anzeigen",
        skipCustomerButton: "Kundenauswahl Ã¼berspringen",
        skipCustomerText: "Ãberspringen, wenn Sie keinen Kunden eingeben mÃ¶chten",
        skipNote: "Anmerkung Ã¼berspringen und Zusammenfassung anzeigen",
        spectroBrand: "Suche in der Marke %{brandName}",
        statusAccepted: "Akzeptiert",
        statusCanceled: "Abgebrochen",
        statusCreated: "Angelegt",
        statusDone: "Fertig",
        statusPartlyDone: "Teilweise fertig",
        statusPreparing: "Vorbereiten",
        summaryChosenBase: "Base",
        summaryChosenBrand: "Marke",
        summaryChosenCanSize: "GebindegrÃ¶Ãe",
        summaryChosenColor: "Farbton",
        summaryChosenColorCard: "Farbkarte",
        summaryChosenProduct: "Produkt",
        summaryChosenQuantity: "Menge",
        summaryColorPreview: "Farbvorschau",
        summaryCustomNote: "Benutzerdefinierte Anmerkung",
        summaryCustomerNumber: "Kundennummer",
        summaryFormula: "Rezeptur",
        summaryFormulaNote: "Anmerkung zur Rezeptur",
        summaryNote: "Anmerkung",
        sureAboutSend: "MÃ¶chten Sie wirklich einen Auftrag senden?",
        useCustomerInOrder: "MÃ¶chten Sie %{customerName} in diesem Auftrag verwenden?",
        uuid: "UUID",
        viewSummary: "Zusammenfassung anzeigen",
        volume: "Volumen"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Pin-AuftragsbestÃ¤tigung",
        pinScreenSaverConfirmation: "Pin-Bildschirmschoner-BestÃ¤tigung",
        pinSettingsConfirmation: "BestÃ¤tigung der Pin-Einstellungen",
        printAuto: "Automatisches Drucken zulassen",
        printerSettings: "Druckereinstellung",
        selectColorWithFandeck: "Farbton- und Kollektion auswÃ¤hlen",
        setKeyboard: "Tastaturlayout einstellen",
        setKioskMode: "Vollbildmodus einstellen",
        setLanguage: "Sprache einstellen",
        setModule: "Module einstellen",
        setQuickSelect: "Schnellauswahl (Quick-Select) einstellen",
        setScreensaverTimeout: "Bildschirmschoner-Timeout einstellen",
        setUnit: "Einheit einstellen"
    },
    customRedlikeMachine: {
        action: "Aktion",
        additionalPrint: "zusÃ¤tzliches Etikett drucken",
        brand: "Marke (Brand)",
        brandAccess: "Der Benutzer '%{userName}' kann nicht auf Daten der Marke '%{brandName}' zugreifen.",
        can: "Gebinde ist in Position",
        canistersLevel: "KanisterfÃ¼llstands-Ãbersicht",
        closeDetailInformation: "Detailinformation schlieÃen",
        colorantsAmount: "Pigmentmenge",
        confirmRefill: "NachfÃ¼llen der Pigmente bestÃ¤tigen",
        deleteOrder: "Auftrag lÃ¶schen",
        dialogNoMachine: "Mischanlage ist nicht verbunden",
        dialogNoRcc: "RCC ist nicht verfÃ¼gbar",
        dispense: "Dosieren",
        dispenserInErrorState: "Mischanlage im Fehlerzustand",
        dispensingIsOk: "Mischanlage OK",
        emergencyButtonPressed: "Notausschalter gedrÃ¼ckt",
        errorCode: "Fehlercode",
        errorEvents: "Machinenfehler",
        errorReset: "Machinenfehler zurÃ¼cksetzen",
        explanation: "ErklÃ¤rung",
        imageNotAvailable: "Bild ist nicht verfÃ¼gbar",
        incorrectCanister: "Falschen BehÃ¤lter gescannt!",
        incorrectColorant: "Falsches Pigment gescannt ! Bitte scannen Sie das richtigen Pigment",
        lastEvents: "Letzte Ereignisse",
        machineActions: "Dispenser- Sensoren",
        machineConfiguration: "Dispenser- Konfiguration",
        machineError: "Dispenser- Fehlermeldung",
        machineIsBusy: "Der Dispenser ist gerade am Dosieren / beschÃ¤ftigt / oder reagiert nicht",
        machineNotAvailable: "Mischanlage nicht verfÃ¼gbar - Bitte RCC oder AnschlÃ¼sse prÃ¼fen",
        machineTinting: "Die Mischmaschine dosiert gerade...",
        manualScan: "Manueller Scan",
        notEnoughSpace: "FEHLER: FÃ¼r dieses Pigmentpaket ist nicht genÃ¼gend Platz vorhanden",
        numberOfCanistersUnderCriticalLevel: "Anzahl der Kanister unter dem kritischen FÃ¼llstand ist %{0}",
        numberOfCanistersUnderWarningLevel: "Anzahl der Kanister unter WarnungsfÃ¼llstand ist %{0}",
        offlinePressed: "Notaus gedrÃ¼ckt !",
        orderSettings: "Auftragseinstellungen",
        otherOrderInformation: "Auftragsdetails",
        packageCount: "Gebindeanzahl",
        packageWithSeparator: "Gebinde",
        received: "Erhalten",
        receivedOrders: "Erhaltene DosierauftrÃ¤ge",
        receivedTime: "Erhaltene Zeit",
        recirculation: "Rezirkulation",
        refillInformation: "Pigment: %{0}, FÃ¼llstand: %{1}, Kanister: %{2}",
        resetErrors: "Fehlermeldungen zurÃ¼cksetzen",
        scanCanister: "Bitte diesen Kanister scannen",
        scanColorantPackage: "Bitte die korrekte Pigmentverpackung scannen",
        selectedOrder: "AusgewÃ¤hlter Auftrag",
        shelfMovingDown: "Gebindetisch fÃ¤hrt herunter",
        shelfMovingUp: "Gebindetisch fÃ¤hrt nach oben",
        solution: "LÃ¶sung",
        startDispensing: "Mit der Dosierung beginnen",
        stirring: "RÃ¼hren",
        touchToStartFilling: "DrÃ¼cken Sie bitte hier um um mit der BefÃ¼llung zu beginnen",
        unknownBrand: "Unbekannte Marke"
    },
    customRedlikeSettings: {
        addPos: "POS Information",
        addServer: "Server hinzufÃ¼gen",
        adminOperations: "Administrator-Aufgaben",
        adminSettings: "Administrator-Einstellungen",
        another: "Andere Einstellungen",
        aslOrService: "ASL oder Dienst",
        availableMachines: "VerfÃ¼gbare Maschinen",
        barcode: "Barcode",
        basicOperations: "Grundfunktionen",
        canisterBarcodes: "Kanister-Barcodes",
        canisterLevels: "KanisterfÃ¼llstand",
        closeConnection: "Verbindung beenden",
        closeRedlike: "%{name} schlieÃen",
        databaseList: "Datenbanken",
        disabledStatus: "deaktiviert",
        dispenseLogicType: "Art der Dosierunglogik",
        dropServers: "Server verwerfen",
        editServer: "Server bearbeiten",
        lastEvent: "Letztes Ereignis",
        logOut: "Log out",
        machineConfiguration: "Konfiguration",
        maxDispenseAmount: "Maximale Dosiermenge",
        offlineStatus: "offline",
        onlineStatus: "online",
        openFrondesk: "Frontdesk Ã¶ffnen",
        print: "Druckeinstellungen",
        rebootPC: "PC neu starten",
        restartRedlike: "%{name} neu starten",
        restoreConnection: "Die Verbindung wiederherstellen",
        scanCanisterBarcode: "Scannen Sie den Barcode des Kanisters",
        scanOrDeleteCanisterBarcode: "Barcode scannen oder lÃ¶schen",
        setCanisterBarcode: "Kanister-Barcode einstellen",
        swVersion: "Softwareversion",
        systemFunctions: "Systemfunktionen",
        userSettings: "Benutzereinstellungen"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Farbton bearbeiten",
        editColorant: "Pigmentkonzentrat bearbeiten",
        emptyColorant: "Es gibt ein Pigmentkonzentrat mit leerer Menge.",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Rezeptur fÃ¼r Masterprodukt",
        formulaForMasterProductWithParam: "Rezeptur fÃ¼r Masterprodukt %{productName}",
        isNotAvailable: "Ist nicht verfÃ¼gbar",
        noBaseSelected: "Keine Base ausgewÃ¤hlt",
        noColorantsSelected: "Keine Pigmente ausgewÃ¤hlt",
        noFandeckSelected: "Keine Kollektion ausgewÃ¤hlt",
        noNameOrCode: "Farbtonname und -nummer sind erforderlich",
        noProductSelected: "Kein Produkt ausgewÃ¤hlt",
        productPreview: "Produktvorschau",
        saveCustomRecipe: "Eigenrezeptur speichern",
        saveIsNotAvailable: "Speichern ist nicht mÃ¶glich",
        showSiblingProducts: "Verwandte Produkte anzeigen",
        siblingProducts: "Verwandte Produkte nach Masterprodukt"
    },
    customersTab: {
        addCustomer: "Kunde hinzufÃ¼gen",
        additionalSettings: "ZusÃ¤tzliche Einstellungen",
        adress: "Adresse",
        createAndSelect: "Erstellen und auswÃ¤hlen",
        createNewCustomer: "Neuen Kunden anlegen",
        editCustomer: "Kunden bearbeiten",
        expiration: "Kunde %{name} wird in %{dayCount} Tagen ablaufen",
        identificationNumber: "Ident-Nr.",
        information: "Kontaktinformationen",
        listOfCustomers: "Kundenliste",
        rabat: "Rabatt",
        selectCustomer: "Kunde auswÃ¤hlen",
        spentLastMonth: "Verbrauch im letzten Monat",
        spentMoney: "Kosten",
        typeOfMargin: "Art der Marge",
        zipCode: "Postleitzahl"
    },
    dialog: {
        cheaperColorSearch: "Suche nach billigeren FarbtÃ¶nen lÃ¤uftâ¦",
        competitiveColorSearch: "Suche nach Ã¤hnlichen FarbtÃ¶nen lÃ¤uft",
        reallyChangeModule: "MÃ¶chten Sie das Modul wirklich Ã¤ndern?",
        reallyCloseRedlike:
            "MÃ¶chten Sie %{name} wirklich ausschalten? Alle %{name}-Fenster werden geschlossen, nicht gespeicherte Ãnderungen gehen verloren.",
        reallyDeleteOrder:
            "MÃ¶chten Sie diesen Auftrag wirklich lÃ¶schen? Alle mit diesem Auftrag verbundenen Daten gehen verloren.",
        reallyRebootPC:
            "MÃ¶chten Sie diesen PC wirklich neu starten? Alle Fenster werden geschlossen, nicht gespeicherte Ãnderungen gehen verloren.",
        reallyRestartRedlike:
            "MÃ¶chten Sie %{name} wirklich neu starten? Alle Fenster werden geschlossen, nicht gespeicherte Ãnderungen gehen verloren.",
        reallyShutdownPc:
            "MÃ¶chten Sie diesen PC wirklich ausschalten? Alle %{name}-Fenster werden geschlossen, nicht gespeicherte Ãnderungen gehen verloren.",
        unlockComputer: "Der Computer wird entsperrt."
    },
    dispenseLogicTypes: {
        1: "Nur maximal tÃ¶nbare Menge dosieren",
        2: "Die manuelle Dosierung mit Hilfe einer Skala fÃ¼r Mengen Ã¼ber der maximal fÃ¤rbbaren Menge ermÃ¶glichen.",
        3: "NachfÃ¼llen wÃ¤hrend der Dosierung erlauben",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Kollektionsname"
    },
    editFormulaRgbModal: {
        apply: "Anwenden",
        blue: "Blau",
        green: "GrÃ¼n",
        modalLabel: "Farbton bearbeiten",
        red: "Rot",
        tryGenerateRgb: "Versuchen den RGB anhand der Pastenmengen zu erzeugen"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Registerkarte der Rezeptur automatisch schlieÃen",
        allowBarcodes: "Barcodes erlauben",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Kunden zulassen",
        allowDeleteConfirmation: "LÃ¶schbestÃ¤tigung zulassen",
        allowDiskSpaceNotification: "Benachrichtigung Ã¼ber Speicherplatz zulassen",
        allowDispensing: "Dosierung zulassen",
        allowFileTransfer: "Automatische DatenÃ¼bertragung zulassen",
        allowFormulaModificationPanel: "Bedienfeld fÃ¼r RezepturÃ¤nderungen zulassen",
        allowFormulaStatusPanel: "Rezeptur-Statusanzeige zulassen",
        allowInternalNotes: "Interne Notizen zulassen",
        allowLight: "%{name} zulassen",
        allowOrderNotificationModal: "Benachrichtigungen Ã¼ber einen neuen Auftrag zulassen",
        allowOrdering: "AuftrÃ¤ge zulassen",
        allowPricing: "Preisebearbeitung erlauben",
        allowPrint: "Drucken zulassen",
        allowProductPreviewImage: "Produktvorschau-Bild wÃ¤hrend der Dosierung erlauben",
        allowQualityControl: "QualitÃ¤tskontrolle erlauben",
        allowSearchCheaperColors: "Suche nach gÃ¼nstigeren FarbtÃ¶nen erlauben",
        allowSound: "Tonbenachrichtigung zulassen",
        allowSpectro: "Spectro zulassen",
        allowTabs: "Tabs zulassen",
        applyZoom: "Zoom anwenden",
        automaticLogout: "Automatischer Logout",
        barcodeScan: "Barcode-Scan",
        canisterBarcode: "Kanisterbarcodes",
        canisterLevel: "KanisterfÃ¼llstÃ¤nde",
        changelog: "Changelog",
        closeTab: "Tab schlieÃen",
        colorDifference: "Farbtonunterschied",
        colorPanelNavItem: "Farbtonpalette",
        competitiveColorSearch: "Suche nach Ã¤hnlichen FarbtÃ¶nen",
        customBanner: "Benutzerdefinierter Banner",
        customCurrencyFormat: "WÃ¤hrungsformat",
        customDateFormat: "Datumsformat",
        customNumberFormat: "Zahlenformat",
        customTimeFormat: "Zeitformat",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta Metamerie",
        discount: "Rabatt anzeigen",
        dispensingHistory: "Dispenshistorie",
        dispensingNotes: "Anmerkungen zur Dosierung erlauben",
        enableCustomers: "Kunden erlauben",
        enableDeleteConfirmation: "LÃ¶schbestÃ¤tigung erlauben",
        enableDispensing: "Dosieren erlauben",
        enableLight: "%{name} erlauben",
        enableMarginMarkup: "Marge oder Preisaufschlag erlauben",
        enableNotes: "Anmerkungen erlauben",
        enableOrdering: "Bestellsystem erlauben",
        enableProductPreviewImage: "Produktvorschau-Bild erlauben",
        enableSpectro: "Spectro erlauben",
        enableVirtualKeyboard: "Virtuelle Tastatur erlauben",
        environmentsSettings: "Systemeinstellungen",
        exportTranslationKeys: "ÃbersetzungsschlÃ¼ssel exportieren",
        formulaNotes: "Rezepturanmerkungen erlauben",
        hintTooltips: "Tooltips verbergen",
        image: "Farbton + Bild/zusÃ¤tzliche Informationen",
        keyboardShortcuts: "Tastenkombinationen",
        languageBased: "Sprachbasierend",
        lockYourComputer: "Computer sperren",
        machineReset: "Machinenreset",
        manageTranslations: "Ãbersetzungen verwalten",
        margin: "Nur Marge",
        markup: "Nur Preisaufschlag",
        matchingRowCount: "Anzahl der gefundenen FarbtÃ¶ne festlegen",
        maxNumberTabs: "Maximale Anzahl der Tabs",
        memoryTabs: "Zuletzt geÃ¶ffnete Tabs speichern",
        moreInfo: "Farbton + Gebindefoto + zusÃ¤tzliche Informationen",
        navigationItems: "Einstellungen der Navigationselemente",
        newTab: "Neuer Tab",
        numberOfPriceGroups: "Anzahl der Preisgruppen",
        order: "Auftrag",
        orderId: "Auftrags-ID",
        ordersHistory: "Auftragshistorie",
        overwriteLastTab: "letzten Tab Ã¼berschreiben",
        priceCalculation: "Preiskalkulation",
        priceDefBothPurchasePrimary: "Beide, Kaufpreis primÃ¤r",
        priceDefBothSellPrimary: "Beide, Verkaufspreis primÃ¤r",
        priceDefPurchaseOnly: "Nur Kaufpreis",
        priceDefSellOnly: "Nur Verkaufspreis",
        priceDefinition: "Preisdefinition",
        priceGroupsEnabled: "Preisgruppen erlauben",
        runLightAtStartUp: "%{light} beim Start Ã¶ffnen",
        screenSaverTimeout: "Bildschirmschoner-Timeout",
        selectedSpectro: "AusgewÃ¤hltes %{spectro} MessgerÃ¤t.",
        selectedSpectroNone: "Kein MessgerÃ¤t ausgewÃ¤hlt.",
        setAutomaticClientStart: "%{name} beim Start des Computers Ã¶ffnen",
        setCustomHomeButton: "Aktion beim DrÃ¼cken des Home-Buttons",
        setDecimalPlaces: "Anzahl der Dezimalstellen",
        setFormulaPreview: "Rezepturvorschau",
        setFormulaUnit: "Rezeptureinheit",
        setFts: "Volltextsuche benutzen",
        setInfoItemInRgb: "Information in der Farbenvorschau",
        setKeyboardShortcuts: "Tastenkombinationen einstellen",
        setKioskMode: "Kioskmodus/Vollbild einstellen",
        setKioskModeOff: "Kioskmodus/Vollbild ausschalten",
        setKioskModeOn: "Kioskmodus/Vollbild einschalten",
        setNavigationItems: "Navigationselemente festlegen",
        setNavigationItemsList: "Sichtbarkeit und Reihenfolge der Navigationselemente festlegen",
        setOrderSearchItems: "Auftragssuchparameter",
        setRounding: "Rundung",
        setSearchParameters: "Rezeptursuche-Parameter",
        setTabLimit: "Tab-Limit setzen",
        setYourLanguage: "Sprache",
        setZoom: "Zoom",
        showLocalPrices: "Lokale Preise anzeigen",
        skipPlaceCanDialogEnabled:
            "Diese Einstellung kann nicht geÃ¤ndert werden, da der Dialog fÃ¼r die Dosenstellung in den Maschineneinstellungen deaktiviert wurde.",
        sortItems: "Navigationselemente sortieren",
        startDispensing: "Dosierung beginnen",
        stir: "RÃ¼hren"
    },
    error: {
        errorDetail: "Genaue Beschreibung des Fehlers",
        errorOccurred:
            "Es ist ein unerwarteter Fehler aufgetreten. Wenden Sie sich bitte unter %{0} an unseren Support. Wir melden uns bei Ihnen so schnell wie mÃ¶glich.",
        hideDetail: "Details des Fehlers ausblenden"
    },
    favoritesTab: {
        addFolder: "Ordner hinzufÃ¼gen",
        closeTabToLoadFormula:
            "Um eine neue Registerkarte zu Ã¶ffnen, schlieÃen Sie bitte zuerst eine andere. Sie haben die maximale Anzahl von Registerkarten erreicht.",
        deleteFolder: "Ordner lÃ¶schen",
        editFolder: "Ordner bearbeiten",
        favoriteFormulas: "Favoriten",
        formulaNotes: "Rezeptur-Notizen",
        message: {
            formulasFromFolder: "Rezepturen aus Ordner",
            moveAllFormulas: "Verschieben Sie alle Rezepturen aus diesem Ordner in den Ã¼bergeordneten Ordner",
            removeAllFormulas: "Entfernen Sie alle Rezepturen aus diesem Ordner",
            wantToDeleteFolder: "MÃ¶chten Sie diesen Ordner wirklich lÃ¶schen?"
        },
        newFolder: "Neuer Ordner",
        packages: "Gebinde",
        pricePerPackage: "Preis pro Gebinde",
        regularPrice: "RegulÃ¤rer Preis",
        removeFromFavorites: "Von Favoriten entfernen",
        specialPriceOff: "Sonderpreis %{number}% off",
        specialPriceVIP: "Sonderpreis VIP"
    },
    fileTransfer: {
        afterImport: "Nach dem Import",
        alreadyExists: "Aufgabe fÃ¼r gegebenen Typ und Format existiert bereits",
        customFormulaSimple: "Einfache Eigenrezeptur",
        direction: "Richtung",
        exportTask: "Aufgabe Dateiexport",
        fileTransferNotification: "Benachrichtigung bei DateiÃ¼bertragung",
        flashMessage: "Blitzmeldung",
        importTask: "Dateiimport-Aufgabe",
        noInformation: "Keine Informationen",
        protocol: {
            folder: "Ordner",
            ftp: "FTP-Protokoll",
            ftps: "FTPS-Protokoll",
            redlikeStorage: "%{softwareName} FTP-Speicherprotokoll",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "ProtokollprÃ¼fungsdateien im definierten lokalen Ordner.",
            ftp: "Protokoll zur ÃberprÃ¼fung von Dateien in einem entfernten FTP-Ordner Ã¼ber eine Standard-FTP-Verbindung.",
            ftps: "Protokoll zur ÃberprÃ¼fung von Dateien auf einem entfernten FTPS-Server (FTP-SSL / FTP Secure) Ã¼ber eine Standard-FTP-Verbindung.",
            redlikeStorage: "ProtokollprÃ¼fung von Dateien im %{softwareName}-Speicher."
        },
        remoteFolder: "Remote-Verzeichnis",
        startType: "Startart",
        statusbar: "Statusbar Information",
        testConnection: "Test Connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Verbrauchsart",
        filter: "Filter",
        from: "Von",
        to: "Bis"
    },
    findText: {
        findTextTitle: "Text finden",
        removeMarks: "Markierungen entfernen",
        search: "Wort suchen"
    },
    flashMessage: {
        VMNotAllowed: "Virtuelle Maschine ist nicht erlaubt",
        addedToStock: "Artikel erfolgreich zum Bestand hinzugefÃ¼gt",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Datenbank-Autologin fehlgeschlagen.",
        autotaskDuplicateName:
            "DatenbankintegritÃ¤tsfehler: %{0} Element mit %{1} %{2} existiert bereits, bitte verwenden Sie andere %{3}.",
        barcodeIsUsed: "Dieser Barcode wird bereits benutzt",
        barcodeNotFound: "Der Barcode wurde nicht gefunden",
        bugReportSent: "Ein Fehlerbericht wurde erfolgreich gesendet.",
        cannoctConnectToServer: "Verbindung zum Server nicht mÃ¶glich",
        cannotWriteLicense: "Die Lizenz kann nicht gespeichert werden",
        clientConnectionRejected: "Die Verbindung wurde abgelehnt.",
        clientNotLoggedIn: "Der Client ist nicht angemeldet",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Pigmentkonzentrat erfolgreich aus dem Lagerbestand entfernt.",
        competitiveSearchEmpty:
            "Es konnten keine Ã¤hnlichen FarbtÃ¶ne gefunden werden. Bitte Ã¤ndern Sie die Suchparameter oder wÃ¤hlen Sie eine andere Farbe.",
        competitiveSearchSelectProduct:
            "Bitte wÃ¤hlen Sie ein Produkt aus, um die Suche nach VergleichsfarbtÃ¶nen zu starten.",
        computerBackdated: "Das Datum des Computer wurde zurÃ¼ckgesetzt",
        connectionFailed: "Verbindungstest fehlgeschlagen: %{0}",
        connectionSuccess: "Test der Verbindung war erfolgreich",
        corruptedLicenseFile: "Die Lizenzdatei ist beschÃ¤digt",
        customFormulaCreated: "Eigene Rezeptur erfolgreich erstellt.",
        customFormulaCreationError: "Fehler beim Erstellen der eigenen Rezeptur.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Der Kunde wurde nicht gefunden",
        dataNotAvailable: "Der Server kann keine Verbindung zur Datenbank herstellen",
        datacolorMatching: {
            couldNotConnect:
                "Es konnte keine Verbindung zu Datacolor Matching hergestellt werden, entweder ist der Server ausgefallen oder der PC ist offline.",
            disabled: "Datacolor Matching deaktiviert.",
            internalError: "Datacolor Matching interner Fehler: '%{0}'",
            invalidCredentials:
                "Keine oder ungÃ¼ltige Anmeldeinformationen fÃ¼r Datacolor Matching bereitgestellt, kontaktieren Sie den Datenbankanbieter.",
            noCansAvailable:
                "FÃ¼r die ausgewÃ¤hlte Farbdatei (Produktlinie) sind keine Gebinde verfÃ¼gbar, wenden Sie sich an den Datenbankanbieter."
        },
        defaultMessage: "Bei der letzten Serveraktion ist ein unerwarteter Fehler aufgetreten",
        deleteAll: "Alles lÃ¶schen",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "Ãber die Dropdown-Liste auf der rechten Seite der Kartennavigation kÃ¶nnen Sie das Winter-Plugin deaktivieren",
        duplicateBarcode: "Dieser Barcode ist bereits vorhanden",
        duplicateName: "Dieser Name ist bereits vorhanden",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "FÃ¼r den von Ihnen verwendeten Artikel ist kein Bestand auf Lager.",
        expiredLicense: "Die Lizenz ist abgelaufen",
        exportSuccess: "Daten wurden erfolgreich exportiert",
        fandeckExist: "Diese benutzerdefinierte Kollektion existiert bereits",
        featureNotAutorized: "Die Funktion wurde nicht autorisiert.",
        fileExportComplete: "Die Datei wurde erfolgreich exportiert.",
        fileExportError: "Beim Dateiexport ist ein Fehler aufgetreten.",
        fileSaveComplete: "Die Datei wurde erfolgreich gespeichert.",
        fileSaveError: "Beim Speichern der Datei ist ein Fehler aufgetreten.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Die Datei ist nicht verfÃ¼gbar oder ist leer.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Die Daten in der Datei konnten nicht verarbeitet werden, die Datei ist ungÃ¼ltig.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Die Dateiversion konnte nicht ermittelt werden.",
        filetransferNoData: "Keine Datenbankverbindung, bitte Ã¼berprÃ¼fen Sie die Einstellungen",
        formulaDataUnavailable: "Rezepturdaten nicht verfÃ¼gbar",
        helperDefaultMessage: "Ein unerwarteter Fehler ist wÃ¤hrend der letzten Helper-Server-Aktion aufgetreten.",
        helperServerError: "Helper-Server-Fehler",
        importAborted: "Der Importvorgang wurde abgebrochen",
        importSuccess: "Die Daten wurden erfolgreich importiert",
        incompatibleBaseCan:
            "Dieses Basengebinde ist nicht mit dem angegebenen Produkt, der Base und dem Gebinde kompatibel.",
        incorrectPassword: "Ihr altes Passwort ist falsch. Bitte geben Sie das korrekte Passwort ein.",
        invalidCurrency: "Der WÃ¤hrungscode ist nicht gÃ¼ltig. Euro ist als StandardwÃ¤hrung eingestellt.",
        invalidDatabaseName: "Der Datenbankname ist ungÃ¼ltig.",
        invalidEmail: "Die eingegebene E-Mail-Adresse ist ungÃ¼ltig",
        invalidFormulaColorants:
            "ACHTUNG!!! Es gibt ein Softwareproblem in der Rezeptur. Die Rezeptur kÃ¶nnte falsch sein! Kontaktieren Sie Ihren Support!",
        invalidLicenseCompanyUserKey: "UngÃ¼ltiger Company-User-Key",
        invalidLicenseFile: "UngÃ¼ltige Lizenzdatei",
        invalidLicenseIdentificationKeys: "Ihre LizenzidentifikationsschlÃ¼ssel sind ungÃ¼ltig.",
        invalidLicenseKey: "Ihre Lizenz ist ungÃ¼ltig",
        invalidLicenseProduct: "Die Lizenzdatei passt nicht zu der installierten Produktversion.",
        invalidRccResponse: "Bei der Verarbeitung der letzten RCC-Antwort ist ein unerwarteter Fehler aufgetreten.",
        invalidServerResponse: "Bei der Verarbeitung der letzten Serverantwort ist ein unerwarteter Fehler aufgetreten",
        invalidUrl: "Die URL ist ungÃ¼ltig",
        itemNotFound: "Der Artikel wurde nicht gefunden",
        keyboardShortcutUsedInModal:
            "Dieses TastaturkÃ¼rzel kann nicht in Pop-up-Fenstern verwendet werden. Bitte schlieÃen Sie das Pop-up-Fenster und versuchen Sie es dann erneut.",
        keyboardShortcutValidation:
            "Dieselbe Tastenkombination kann nicht fÃ¼r zwei verschiedene Aktionen verwendet werden.",
        licenseHasBeenRevoked:
            "Ihre Lizenz wurde widerrufen. Um sie zu erneuern, wenden Sie sich bitte an Ihren Softwareanbieter.",
        licenseProlongationNeeded:
            "LizenzverlÃ¤ngerung erforderlich (Bitte den PC mit dem Internet verbinden, um neue Lizenz zu erhalten)",
        licenseUpToDate: "Ihre Lizenz ist auf dem neuesten Stand. Keine Aktualisierung erforderlich.",
        licenseUpdateUnsuccessful: "Die Lizenz konnte nicht aktualisiert werden.",
        licenseUpdated: "Die Lizenz wurde erfolgreich aktualisiert.",
        licensedOnDifferentComputer: "Das Produkt wurde ursprÃ¼nglich fÃ¼r einen anderen Computer lizenziert.",
        logFileArchiveDownloadComplete: "Das Herunterladen des Protokollarchivs wurde erfolgreich abgeschlossen.",
        loginError: "Beim Anmelden ist ein unerwarteter Fehler aufgetreten",
        logoutError: "Beim Abmelden ist ein unerwarteter Fehler aufgetreten",
        machineIsConnecting: "Maschine wird verbunden, bitte warten.",
        machineIsNotConnected:
            "Ihre Mischanlage ist NICHT mit dem RCC verbunden. Bitte Ã¼berprÃ¼fen Sie die RCC-Konfiguration.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Eine Korrektur ist nicht mÃ¶glich, bitte rezeptieren Sie neu.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "UngÃ¼ltige Base fÃ¼r dieses Produkt.",
            invalidBipp: "UngÃ¼ltige Base fÃ¼r dieses Produktgebinde.",
            invalidColorantId: "UngÃ¼ltiges Pigmentkonzentrat fÃ¼r ID: %{0}.",
            invalidColorantName: "UngÃ¼ltiges Pigmentkonzentrat mit dem Namen: %{0}.",
            invalidColorfile: "UngÃ¼ltige Farbtondatei ID: %{0} fÃ¼r das Produkt mit der ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "UngÃ¼ltiges Produkt mit der ID: %{0}.",
            invalidSpectralCurve: "UngÃ¼ltige Spectralkurve.",
            noColorfiles: "Keine Farbtondatei definiert fÃ¼r das Produkt mit der ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unbekannter Fehler.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Die maximale Anzahl der Tabs wurde erreicht, bitte schlieÃen Sie einen Tab.",
        noTemplate: "Der Druck kann nicht durchgefÃ¼hrt werden, da keine Vorlagen vorhanden sind.",
        openNewTab: "Bitte Ã¶ffnen Sie einen neue Tab, um die Rezeptur mit Barcode zu laden",
        orderAlreadyAcquired: "Der Auftrag ist bereits eingegangen, muss aber erst freigegeben werden.",
        orderCreated: "Der Auftrag wurde erfolgreich versendet",
        passwordIsNotUnique: "Das neue Passwort muss sich von dem alten unterscheiden.",
        printCannotBeCarriedOut: "Der Druck kann nicht durchgefÃ¼hrt werden, da der Druckername ungÃ¼ltig ist.",
        problemWithFileExport: "Beim Speichern der Datei ein Problem aufgetreten.",
        productFileWarning: "Die Datei mit den Produktinformationen ist nur online verfÃ¼gbar.",
        productNotLicensed: "Das Produkt ist nicht lizenziert.",
        rccDefaultMessage: "Bei der letzten Aktion des RCC ist ein unerwarteter Fehler aufgetreten",
        rccError: "RCC-Fehler",
        rccNeedRestart: "Bitte RCC neustarten",
        restoredSettings: "Die Einstellungen wurden wiederhergestellt",
        revokedLicense: "Die Lizenz wurde widerrufen",
        runningOutOfSpace: "Auf dem PC ist kein freien Speicherplatz mehr verfÃ¼gbar.",
        savedFormulaToHistory: "Die Rezeptur wurde erfolgreich in der Dispense-Historie gespeichert.",
        savedLogArchive:
            "Das Protokollarchiv-File wurde erfolgreich in dem von Ihnen ausgewÃ¤hltem Verzeichnis gespeichert.",
        scanning: "Scannen in Bearbeitung",
        serverError: "Serverfehler",
        setClientIdentifier: "Bitte stellen Sie zunÃ¤chst Ihre Kundenkennung ein.",
        showLess: "Weniger anzeigen",
        showMore: "Mehr anzeigen",
        spectroIsDisconnecting: "Verbindung mit dem Spectro wird getrennt, bitte warten.",
        spectroIsNotConnected: "Ihr Spectro ist momentan NICHT VERBUNDEN. Bitte Ã¼berprÃ¼fen Sie die RCC-Konfiguration.",
        spectroIsNotSelected: "Ihr Spectro ist momentan NICHT AUSGEWÃHLT Bitte Ã¼berprÃ¼fen Sie die RCC-Konfiguration.",
        tmcNotAvailable: "%{tmc} ist nicht erreichbar. Bitte prÃ¼fen Sie den %{collector}.",
        tmcNotConnected: "%{tmc} ist nicht verbunden. Bitte starten Sie den %{collector} und den Server neu.",
        unknownError: "Unbekannter Fehler: %{0}",
        userAlreadyLoggedIn: "Sie sind bereits eingeloggt!",
        versionNotAllowedByLicense: "Diese neue Softwareversion ist fÃ¼r Ihre Lizenz nicht zulÃ¤ssig.",
        webApiConnectionError: "Die Verbindung zum Web-Api-Server konnte nicht hergestellt werden.",
        webApiInternalError: "Web Api Server - Interner Fehler",
        webApiInvalidUser: "Web Api Server - UngÃ¼ltiger Benutzer",
        webApiNoLicenseAvailable: "Web Api Server - Keine Lizenz verfÃ¼gbar",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Falsches Eingabeformat %{0}.",
        wrongRccVersion:
            "Bitte Ã¼berprÃ¼fen Sie die Version des installierten RCC. Ihre Clientversion ist nur mit der RCC-Version %{0} kompatibel."
    },
    footer: {
        aboutApplication: "Ãber die Anwendung...",
        activeUser: "Aktiver Benutzer",
        logOut: "Log out",
        machineErrors: "Maschinenfehler"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "UngÃ¼ltig",
        solvent: "Auf LÃ¶semittelbasis",
        universal: "Universal",
        water: "Wasser basierend"
    },
    formulaSettings: {
        allUnits: "Alle in der Datenbank verfÃ¼gbaren Einheiten",
        allowCustomFormulas: "Eigenrezepturen erlauben",
        allowCustomPackageSize: "Benutzerdefinierte GebindegrÃ¶Ãen erlauben",
        allowFormulaAutomaticNaming: "Automatische Benennung zulassen",
        automaticNaming: "Automatische Benennung der Rezeptur",
        basePanelSize: "GrÃ¶Ãe der Anzeige der Produktbase einstellen",
        bippPanelSize: "GrÃ¶Ãe der Base in der Produktanzeige festlegen",
        blendColorNameAndCode: "Farbtonname und Farbtonnummer zusammenfÃ¼gen und zusammen anzeigen",
        buttonBellowMoreInfo: "SchaltflÃ¤che unter den Rezeptnotizen anzeigen",
        buttonInColorantPanel: "SchaltflÃ¤che unter den Pigmentkonzentraten anzeigen",
        colorCodePrimary: "Farbtonnummer als primÃ¤re Anzeige festlegen",
        colorPanel: "Farbpalette",
        colorPreviewAsImage: "Farbansicht als Bild",
        colorPreviewResizable: "GrÃ¶ÃenverÃ¤nderbare Farbtonvorschau",
        competitiveColorSearch: "Nach Ã¤hnlichen FarbtÃ¶nen suchen",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Kundenspezifische Rezepturen",
        customPackageSettingsUnitGrav: "Kundenspezifische Verpackungseinstellungen in gravimetrischen Einheiten",
        customPackageSettingsUnitVol: "Kundenspezifische Verpackungseinstellungen in volumetrischen Einheiten",
        customPackageSize: "Kundenspezifische GebindegrÃ¶Ãen",
        customUnits: "Kundenspezifische Einheiten wÃ¤hlen",
        dropDownCalculate: "Erweitern des Dropdown-MenÃ¼ auf die HÃ¶he des Fensters",
        editColorants: "Pigmentkonzentrate bearbeiten",
        editColorantsAllowed: "Bearbeitung der Pigmentkonzentrate zulassen",
        fandeckPanelSize: "GrÃ¶Ãe der Anzeige des FarbtonfÃ¤chers auf dem Bildschirm einstellen",
        favoriteFormulas: "Bevorzugte Rezepturen (Favoriten)",
        formulaColorPreview: "Vorschau der Farbe dieser Rezeptur",
        formulaDataSettings: "Rezepturdaten-Einstellungen",
        formulaPanel: "Rezepturfenster",
        formulaPanelSize: "GrÃ¶Ãe der Rezepturanzeige einstellen",
        formulaSettings: "Rezepturanzeige",
        generateColorPreview: "Vorschau des Farbtons erzeugen",
        gravimetricOnly: "Nur gravimetrische Einheiten",
        hideAlternativeFormulas: "Alternative Rezepturen ausblenden",
        hideFormulaProperties: "Rezeptureigenschaften ausblenden",
        hideHistoricalFormulas: "Historische Rezepturen ausblenden",
        imagesLocal: "Nur Bilder aus der lokalen Datenbank verwenden",
        imagesOnline:
            "PrimÃ¤r das Online-Produktbild anzeigen, wenn dies nicht gelingt, das lokale Produktbild anzeigen.",
        infoPanelResizable: "GrÃ¶ÃenverÃ¤nderbares More-Info-Panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Reihenfolge der Suchergebnisse nach dem Abstand",
        productDependent: "Die Einheit hÃ¤ngt vom gewÃ¤hlten Produkt ab",
        productFilesDialog: "Dialogfenster zum Ãffnen einer lokalen Datei oder einer Online-Datei anzeigen",
        productFilesLocal: "Nur Produktdateien aus der lokalen Datenbank verwenden",
        productFilesOnline:
            "Versuchen die Online-Produktdatei Ã¶ffnen, wenn dies nicht gelingt wird die lokale Produktdatei verwendet.",
        productPanelSize: "GrÃ¶Ãe der Produktanzeige festlegen",
        searchPanelQuickSelect: "Schnellauswahl",
        setAdditionalFormulaPanel: "ZusÃ¤tzliche Rezeptur-Fenster einstellen",
        setCompetitiveColorSearch: "Suche nach Ã¤hnlichen FarbtÃ¶nen erlauben",
        setInitialFormulaPanel: "UrsprÃ¼ngliche Rezepturanzeige verwenden",
        setMaxToleranceForCompetitiveColors: "Maximale Toleranz fÃ¼r die Suche nach Ã¤hnlichen FarbtÃ¶nen einstellen",
        setNumberOfCompetitiveColors: "Anzahl der Ã¤hnlichen MasterfarbtÃ¶ne einstellen",
        setSearchPanel: "Suchfenster einstellen",
        setVisibilityAndOrder: "Sichtbarkeit und Reihenfolge der verschiedenen Rezepturdaten festlegen",
        setVisibleUnit: "Sichtbare Einheiten einstellen",
        showColorPreview: "Farbvorschau anzeigen",
        showInFormulaStatusPanel: "Im Statusbereich der der Rezeptur anzeigen",
        showInMoreInfoPanel: "In Rezeptnotizen anzeigen",
        sorting: "Sortierung der Pigmentkonzentrate",
        useBase: "Auswahl der Base ermÃ¶glichen",
        useBaseInProductPackage: "Auswahl der Base im Gebinde ermÃ¶glichen",
        useColorCode: "Farbtonnummer verwenden",
        useColorName: "Farbtonname verwenden",
        useFandeckGroups: "FarbtonfÃ¤cher-Gruppen verwenden",
        useProduct: "Auswahl der Produkte ermÃ¶glichen",
        useProductCode: "Produktcode verwenden",
        useProductGroups: "Produktgruppen benutzen",
        volumetricOnly: "Nur volumetrische Einheiten"
    },
    general: {
        accepted: "Akzeptiert",
        active: "Letzte AktivitÃ¤t",
        actual: "Aktuell",
        actualLevel: "Aktueller FÃ¼llstand",
        add: "HinzufÃ¼gen",
        addColorant: "Pigmentkonzentrat hinzufÃ¼gen",
        addColorantForPackage: "Pigmentkonzentrat zum Gebinde hinzufÃ¼gen",
        addFile: "Datei hinzufÃ¼gen",
        all: "Alles",
        amount: "Menge",
        applyNow: "Apply now",
        attachments: "Anlagen",
        automaticCorrection: "Automatische Korrektur",
        automatically: "Automatisch",
        available: "VerfÃ¼gbar",
        back: "ZurÃ¼ck",
        base: "Base",
        baseInProductPackage: "Base in Produkt und Gebinde",
        batchNumber: "Batchnummer",
        bottom: "Unten",
        buildingSite: "Building site",
        calculate: "Berechnen",
        can: "Gebinde",
        canSize: "GebindegrÃ¶Ãe",
        cancel: "Abbrechen",
        canister: "Kanister",
        canisterId: "Kanister-ID",
        canisterIndex: "Kanister Index",
        canisters: "Kanister",
        cap: "Deckel",
        capacity: "BehÃ¤ltergrÃ¶Ãe",
        channels: "KanÃ¤le",
        choose: "WÃ¤hlen",
        city: "Stadt",
        clean: "Reinigen",
        clear: "lÃ¶schen",
        client: "Klient",
        close: "SchlieÃen",
        closeAll: "Alle schlieÃen",
        collapseAll: "Alle zusammenklappen",
        color: "Farbton",
        colorCode: "Farbtonnummer",
        colorFile: "Farbdatei",
        colorName: "Farbtonname",
        colorPreview: "Farbvorschau",
        colorant: "Pigmentkonzentrat",
        colorantBatchNumber: "Batchnummer des Pigmentkonzentrats",
        colorantPackage: "Pigmentgebinde",
        colorants: "Pigmente",
        colors: "Colors",
        company: "Firma",
        competitiveColor: "Competitive color",
        confirm: "BestÃ¤tigen",
        confirmDeletion: "MÃ¶chten Sie diesen Artikel wirklich endgÃ¼ltig lÃ¶schen?",
        confirmHelpSettings: "Wollen Sie das Formular wirklich mit leeren Feldern speichern?",
        connect: "Verbinden",
        continue: "Fortsetzen",
        correction: "Korrektur",
        country: "Land",
        created: "Erstellt",
        creationDateOf: "Produktionsdatum",
        criticalLevel: "Kritischer FÃ¼llstand",
        currency: "WÃ¤hrung",
        currentBatchNumber: "Aktuelle Chargennummer",
        currentUfiCode: "Aktueller UFI code",
        custom: "Eigene Rezepturen",
        customData: "Kundendaten bestÃ¤tigen",
        customFandeck: "Benutzerdefinierte Kollektionen",
        customFormula: "Eigenrezeptur",
        customPackage: "Benutzerdefiniertes Gebinde",
        customPackageSettings: "Benutzerdefinierte Gebinde-Einstellungen",
        customer: "Kunde",
        customerVersion: "Kundenversion",
        customers: "Kunden",
        database: "Datenbank",
        date: "Datum",
        default: "Standard",
        delete: "LÃ¶schen",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Beschreibung",
        disconnect: "Verbindung trennen",
        discount: "Rabatt",
        discover: "Entdecken",
        dispense: "Dosierung",
        dispensing: "Dosieren",
        doNotShowAgain: "Diese Meldung nicht mehr anzeigen",
        downloadingFile: "Daten werden heruntergeladen",
        edit: "Bearbeiten",
        email: "E-Mail",
        enabled: "Aktiviert",
        error: "Fehler",
        expandAll: "Alle erweitern",
        exportData: "Daten exportieren",
        exportPdf: "PDF exportieren",
        fan: "FÃ¤cher",
        fandeck: "Kollektion",
        fandeckCode: "Code der Kollektion / des FarbtonfÃ¤chers",
        fandeckName: "Kollektions-Name",
        fandecks: "FarbtonfÃ¤cher",
        favorite: "Favoriten",
        fileTransfer: "DateiÃ¼bertragung",
        filling: "NachfÃ¼llung",
        fillingDate: "NachfÃ¼lldatum",
        find: "Finden",
        finish: "Beenden",
        finishedCorrection: "Korrektur abgeschlossen",
        formula: "Rezeptur",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "QR-Code abrufen",
        gravimetric: "Gravimetrisch",
        historical: "Historisch",
        history: "Historie",
        hours: "Stunden",
        id: "ID",
        images: "Bilder",
        in: "In",
        index: "Index",
        insertBarcode: "Bitte den Barcode eingeben",
        install: "Installieren",
        installed: "Installiert",
        instructions: "Anweisungen",
        internalNote: "Interne Anmerkung",
        interval: "Intervall",
        ip: "IP-Adresse",
        itemNumber: "Art.-Nr.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Anzahl der Posten",
        later: "Later",
        limit: "Limit",
        load: "Laden",
        loadFormula: "Rezeptur des Farbtons laden",
        localVersion: "Lokale Version",
        machine: "Maschine",
        manualCorrection: "Manuelle Korrektur",
        manually: "Manuell",
        margin: "Marge",
        markup: "Preisaufschlag",
        matching: "Farbtonmessung/Korrektur",
        matchingFormula: "Matching formula",
        maxLevel: "MaximalfÃ¼llstand",
        maxValue: "Maximalwert",
        maximum: "Maximal",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamerie",
        minimum: "Minimal",
        minutes: "Min.",
        missingItem: "Fehlendes Element",
        missingRequiredItems:
            "Alle erforderlichen Felder (mit einem Sternchen gekennzeichnet) mÃ¼ssen ausgefÃ¼llt werden",
        modified: "GeÃ¤ndert",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Benutzerdefinierte Rezeptur geÃ¤ndert",
        modifiedStandardFormula: "Standardrezeptur geÃ¤ndert",
        moduleChange: "Modul-Wechsel",
        more: "Mehr",
        moreInfo: "Mehr Informationen",
        moveDown: "Nach unten bewegen",
        moveUp: "Nach oben bewegen",
        myOrders: "DosierauftrÃ¤ge",
        name: "Name",
        nameTitle: "Name",
        new: "Neu",
        next: "NÃ¤chste",
        no: "Nein",
        noColorantsAvailable: "Keine Pigmente verfÃ¼gbar",
        noFormulas: "Keine Rezepturen verfÃ¼gbar",
        noPricesAvailable: "Keine Preise verfÃ¼gbar",
        nominalAmount: "Minimale Menge",
        notAvailable: "Nicht verfÃ¼gbar",
        note: "Anmerkung",
        numberOfCanisters: "Anzahl der Kanister",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Anzahl der Etiketten",
        numberOfPackages: "Anzahl der Gebinde",
        off: "Aus",
        ok: "OK",
        on: "Auf",
        onFocus: "Im Fokus",
        open: "Ãffnen",
        operator: "Benutzer",
        options: "Optionen",
        order: "Order",
        other: "Andere",
        otherError: "Anderer Fehler",
        out: "Aus",
        overwrite: "Overwrite",
        package: "GebindegrÃ¶Ãe",
        packagePreview: "Gebindevorschau",
        partialUpdates: "Teil- Updates (Partial Updates)",
        phone: "Telefon",
        pleaseWait: "Bitte warten",
        previous: "Vorherige",
        price: "Preis",
        priceGroup: "Preisgruppe",
        print: "Drucken",
        printTask: "Task drucken",
        processingStep: "Processing %{step}",
        product: "Produkt",
        productCode: "Produktcode",
        productName: "Produktname",
        products: "Produkte",
        pump1: "Pumpe 1",
        pump2: "Pumpe 2",
        purchasePrice: "Einkaufpreis",
        purge: "DÃ¼sen reinigen",
        qualityControl: "QualitÃ¤tskontrolle",
        quantity: "Menge",
        quantityQty: "QTY",
        quickTint: "Manuelle Dosierung",
        rccIsNotAvailable: "RCC ist nicht verfÃ¼gbar",
        rccIsNotConnected: "RCC ist nicht verbunden",
        rccNotLicensed: "RCC ist nicht lizenziert",
        reconnect: "Erneut verbinden",
        refill: "NachfÃ¼llen",
        refillManualLevelCorrection: "Manuelle Korrektur",
        reformulation: "Reformulierung",
        reloadTab: "Reload Tab",
        reset: "Reset",
        restart: "Neustart",
        restore: "Wiederherstellen",
        retint: "Erneut dosieren",
        revision: "Revision",
        safetySheet: "Sicherheitsdatenblatt",
        save: "Speichern",
        saveAs: "Speichern unter",
        saveToDispensingHistory: "In der Historie speichern",
        searchResult: "Search result",
        searching: "Duchsuchen",
        seconds: "Sek.",
        select: "Select",
        selectAll: "Alle auswÃ¤hlen",
        selectChannels: "Kanister auswÃ¤hlen",
        selectColumns: "Select columns to work with",
        selectXFirst: "Zuerst %{item} auswÃ¤hlen",
        sellPrice: "Verkaufspreis",
        settings: "Einstellungen",
        shelf: "Gebindetisch",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "GrÃ¶Ãe",
        skip: "Ãberspringen",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Resultate sortieren",
        spectro: "Spectro",
        standardFormula: "Standardrezeptur",
        status: "Status",
        street: "StraÃe",
        sum: "Summe",
        summary: "Zusammenfassung",
        sync: "Sync",
        technicalSheet: "Technisches Datenblatt",
        templates: "Vorlagen",
        threshold: "Schwellenwert",
        ticketing: "Ticketsystem",
        tintometricSystem: "TÃ¶nsystem",
        toDispenseOrders: "DosierauftrÃ¤ge",
        top: "Oben",
        total: "Gesamt",
        totalAmount: "Gesamtmenge",
        totalBaseAmount: "Gesamtmenge der Base",
        totalColorantAmount: "Gesamtmenge der Pigmente",
        type: "Type",
        ufiCode: "UFI-Code",
        ufiThreshold: "UFI-Schwellenwert",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefiniert",
        unit: "Einheit",
        units: "Einheiten",
        unknown: "Unknown",
        update: "Update",
        updated: "Updated",
        user: "Benutzer",
        value: "Wert",
        vat: "MwSt",
        verified: "GeprÃ¼ft",
        version: "Version",
        versionId: "Version ID",
        versionStructure: "Versionstruktur",
        volumetric: "Volumetrisch",
        warning: "Warnung",
        warningLevel: "WarnungsfÃ¼llstand",
        withoutName: "(ohne Name)",
        workingProperly: "Working properly",
        yes: "Ja",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Stellen Sie mit diesen Autotask ein, dass %{name} die Aktion zur Reinigung des BÃ¼rstenbehÃ¤lters automatisch zum festgelegten Zeitpunkt anfordert. Der Bediener des Dosieres muss den BÃ¼rstenbehÃ¤lter manuell entnehmen, reinigen und dann wieder einsetzen.",
            capMaintenance:
                "Stellen Sie mit diesen Autotask ein, dass %{name} die Aktion zur Reinigung des Verschlusses automatisch zum festgelegten Zeitpunkt anfordert. Der Bediener des Dispensers muss den Autocap nach dem Herausfahren manuell reinigen.",
            cleanAll:
                "Stellen Sie mit diesen Autotask ein, dass der Dispenser die Aktion zur Reinigung aller DÃ¼sen automatisch zum festgelegten Zeitpunkt durchfÃ¼hrt.",
            cleanChannels:
                "Stellen Sie mit diesen Autotask ein, dass der Dispenser die Aktion zur Reinigung bestimmter DÃ¼sen automatisch zum festgelegten Zeitpunkt durchfÃ¼hrt.",
            computerReboot:
                "Stellen Sie mit diesen Autotask ein, dass der Computer zur festgelegten Zeit automatisch neu gestartet wird.",
            computerShutdown:
                "Stellen Sie mit diesen Autotask ein, dass der Computer zur festgelegten Zeit automatisch heruntergefahren wird.",
            dispenserCleaning:
                "Stellen Sie mit diesen Autotask %{name} ein, dass der Computer zur festgelegten Zeit automatisch ausgeschaltet wird.",
            humidifierWaterLevelMaintenance:
                "Stellen Sie mit diesen Autotask ein, dass %{name} die Aktion zum NachfÃ¼llen des Befeuchters automatisch zum festgelegten Zeitpunkt anfordert. Der Bediener des Dispensers muss das Wasser im Befeuchter manuell Ã¼berprÃ¼fen und nachfÃ¼llen.",
            purgeAll:
                "Stellen Sie mit diesen Autotask ein, dass der Dispenser die Aktion zum SpÃ¼len aller Kanister automatisch zum festgelegten Zeitpunkt ausfÃ¼hrt.",
            purgeChannels:
                "Stellen Sie mit diesen Autotask ein, dass der Dispenser die Aktion zur SpÃ¼lung bestimmter Kanister automatisch zum festgelegten Zeitpunkt ausfÃ¼hrt.",
            recirculateAll:
                "Stellen Sie mit diesen Autotask ein, dass der Dispenser die Aktion zur Rezirkulation aller KanÃ¤le automatisch zum festgelegten Zeitpunkt durchfÃ¼hrt.",
            recirculateChannels:
                "Stellen Sie mit diesen Autotask ein, dass der Dispenser die Aktion zur Rezirkulation bestimmter KanÃ¤le automatisch zum festgelegten Zeitpunkt durchfÃ¼hrt.",
            refillAll:
                "Stellen Sie mit diesen Autotask ein, dass %{name} die Aktion zum NachfÃ¼llen aller KanÃ¤le automatisch zum festgelegten Zeitpunkt anfordert. Der Bediener der Dosieranlage muss die Farbstoffe manuell in alle Kanister nachfÃ¼llen.",
            refillCanisters:
                "Stellen Sie mit diesen Autotask ein, dass %{name} die Aktion zum NachfÃ¼llen bestimmter Kanister automatisch zum festgelegten Zeitpunkt anfordert. Der Bediener des Dispensers muss Farbstoffe manuell in Kanister nachfÃ¼llen, die das NachfÃ¼llkriterium nicht erfÃ¼llen.",
            smartPurgeAll:
                "Stellen Sie mit diesen Autotask ein, dass die Dosieranlage die Aktion zur intelligenten Reinigung aller Kanister automatisch zum festgelegten Zeitpunkt durchfÃ¼hrt. Die SpÃ¼lung wird durchgefÃ¼hrt, wenn die Regeln fÃ¼r die intelligente SpÃ¼lung nicht erfÃ¼llt sind.",
            smartPurgeChannels:
                "Stellen Sie mit diesen Autotask ein, dass die Dosieranlage die Aktion zur intelligenten Reinigung bestimmter Kanister automatisch zum festgelegten Zeitpunkt ausfÃ¼hrt. Die SpÃ¼lung wird durchgefÃ¼hrt, wenn die Regeln fÃ¼r die intelligente SpÃ¼lung nicht erfÃ¼llt sind.",
            stirAll:
                "Stellen Sie mit diesen Autotask ein, dass die Dosieranlage die Aktion zum RÃ¼hren aller Kanister automatisch zum festgelegten Zeitpunkt ausfÃ¼hrt.",
            stirCanisters:
                "Stellen Sie mit diesen Autotask ein, dass die Dosieranlage die Aktion zum RÃ¼hren bestimmter Kanister automatisch zum festgelegten Zeitpunkt ausfÃ¼hrt.",
            switchPlateMaintenance:
                "Stellen Sie mit diesen Autotask ein, dass %{name} die Aktion zur Reinigung der 'Switch Plate' automatisch zum festgelegten Zeitpunkt anfordert. Der Bediener der Dosieranlage muss die 'Switch Plate' manuell herausnehmen, reinigen und wieder einsetzen."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "Die vorherrschende Chargennummer wird fÃ¼r den Druck verwendet, wobei die tatsÃ¤chliche Menge im Kanister berÃ¼cksichtigt wird. Navigieren Sie zu Kanistereinstellungen, um den Schwellenwert fÃ¼r jeden Kanister festzulegen.",
            batchNumberFromLastFilling:
                "Die vom Bediener angegebene Charge der letzten NachfÃ¼llung wird fÃ¼r den Druck verwendet, unabhÃ¤ngig von der nachgefÃ¼llten Menge.",
            enableBatchNumber:
                "Wenn diese Einstellung aktiviert ist, werden nachgefÃ¼llte Farbstoffchargen nachverfolgt."
        },
        connection: {
            add: "ErmÃ¶glicht das manuelle HinzufÃ¼gen eines neuen Servers, wenn dieser nicht automatisch erkannt wurde.",
            clientIdentifier:
                "Die Einstellung ermÃ¶glicht es, diesen Client zu identifizieren, wenn mehrere Clients mit einem Server verbunden sind.",
            disconnect:
                "Informationen Ã¼ber den aktuell verwendeten Server. Die SchaltflÃ¤che 'Trennen' ermÃ¶glicht es, diesen Server zu trennen und einen anderen verfÃ¼gbaren Server zu verbinden.",
            discover: "Ermitteln, ob weitere Server im Netz verfÃ¼gbar sind.",
            dropServers: "Alle zuvor erkannten Server aus der Liste lÃ¶schen.",
            dropServersNotAvailable: "Kein Server verfÃ¼gbar",
            edit: "Manuelle Bearbeitung eines bereits gefundenen Servers.",
            editDisabled: "Kein Server ausgewÃ¤hlt"
        },
        continue: "Wollen Sie wirklich weitermachen?",
        driverSettings: {
            alfaRestApi: {
                host: "Name oder IP-Adresse des Computers eingeben",
                machineType: "GÃ¼ltig fÃ¼r alle Alfa-Maschinen. Sowohl fÃ¼r Windows als auch fÃ¼r Linux."
            },
            corobDsProxy: {
                machineType:
                    "GÃ¼ltig fÃ¼r Maschinen-Typ (D200, D600..), 4G (First One) und 5G (EvoFlx). DspProxy muss installiert sein. Nur fÃ¼r Windows."
            },
            corobEvoDriver: {
                machineType:
                    "GÃ¼ltig fÃ¼r Maschinen-Typ 5G (EvoFlx). EVOservice muss installiert sein. Sowohl fÃ¼r Windows als auch fÃ¼r Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Konfigurationsdatei der Maschine auswÃ¤hlen. Default ist voreingestellt.",
                hldRootDir: "Hauptverzeichnis des HLD auswÃ¤hlen. Default ist voreingestellt.",
                machineType:
                    "GÃ¼ltig fÃ¼r Corob Flex (500, 520, 540) = frÃ¼her Lenteq. HLD muss installiert sein. Nur fÃ¼r Windows."
            },
            corobNextDriver: {
                machineType:
                    "GÃ¼ltig fÃ¼r Maschinen-Typ Slave (D200, D600..), 4G (First One) and 5G (EvoFlx). NextDriver muss installiert. Nur fÃ¼r Linux."
            },
            dromontDDrv: {
                databasePath: "Pfad zur Datei mit den Kalibrierungsdaten. Default ist voreingestellt.",
                driverPath: "Pfad zum Treiber (D_DRV.exe). Default ist voreingestellt.",
                machineType:
                    "Indirekte Kommunikation mit dem Dispenser Ã¼ber eingestellte Pfade. GÃ¼ltig fÃ¼r die Generationen V1 und V2. D_SET muss installiert sein. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
                resultPath:
                    "Pfad zur Ergebnisdatei, die nach Abschluss des Auftrags erstellt wird. Default ist voreingestellt.",
                serviceSoftwarePath: "Pfad zur Dromont-Service-Software (D_SET.exe). Defalut voreingestellt."
            },
            dromontDirect: {
                machineType:
                    "Direkte Kommunikation mit der Dosieranlage. GÃ¼ltig fÃ¼r die Generationen V1 und V2. D_SET muss installiert sein. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
                rootDir: "WÃ¤hlen Sie den Dromont-Hauptordner, der standardmÃ¤Ãig voreingestellt ist."
            },
            dromontMisura: {
                driverPath:
                    "Der Pfad zum Treiber (MisuraRetail.exe) kann sich je nach Misura Retail Version Ã¤ndern. StandardmÃ¤Ãig voreingestellt.",
                extensionPath: "Pfad zur Kommunikationsdatei fÃ¼r Serviceaktionen.",
                formulaPath: "Pfad zur Kommunikationsdatei fÃ¼r die Dosierung.",
                machineType: "GÃ¼ltig fÃ¼r die Generation V3. Dromont Misura muss installiert sein. Nur fÃ¼r Windows."
            },
            fastAndFluidIDD: {
                machineType: "GÃ¼ltig fÃ¼r alle F&F-Anlagen. Nur fÃ¼r Windows.",
                path: "UnterstÃ¼tzt werden IDD2 (HA 450, HA 650, X-smart, usw.) - dieser muss jedoch lizenziert werden, IDD3 (HP 500, usw.), IDD4 (HA 180, HA 480, HA 680, X-ProTint, usw.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "GÃ¼ltig fÃ¼r alle F&F-Anlagen. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "GÃ¼ltig fÃ¼r alle Hero-Anlagen. Nur fÃ¼r Windows."
            },
            italtinto: {
                machineType:
                    "GÃ¼ltig fÃ¼r alle Italtinto-Anlagen. Wcal oder ItaltintoCal muss installiert sein. Nur fÃ¼r Windows.",
                path: "Pfad zur angepassten Italtinto-Konfigurationsdatei."
            },
            manualAdvanced: {
                machineType:
                    "GÃ¼ltig fÃ¼r alle manuellen Anlagen, inklusive KanisterunterstÃ¼tzung. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
                path: "Pfad zur Konfigurationsdatei mit Daten des Dispensers und der Kanister."
            },
            manualSimple: {
                machineType: "GÃ¼ltig fÃ¼r alle manuellen Anlagen. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
                path: "Pfad zur Konfigurationsdatei mit Daten Ã¼ber den Dispenser."
            },
            none: {
                machineType: "Es wurde keine Dosieranlage ausgewÃ¤hlt."
            },
            santintColorLink3: {
                machineType: "GÃ¼ltig fÃ¼r alle Santint-Anlagen. Nur fÃ¼r Windows."
            },
            simulation: {
                machineType:
                    "Gilt fÃ¼r Simulationsanlagen, wenn keine echte Dosieranlage an den Computer angeschlossen ist.",
                path: "Pfad zur Simulationskonfigurationsdatei, die mit der eingefÃ¼gten Datenbank Ã¼bereinstimmen muss."
            },
            udcp: {
                machineType: "UDCP Dosieranlage"
            }
        },
        environment: {
            activeServerPlugins: "Ãbersicht der zusÃ¤tzlichen Software-Plugins.",
            allowAutoCloseTab:
                "Ist diese Einstellung aktiviert, wird jedes Rezepturfenster nach Beendigung des Dosiervorgangs automatisch geschlossen.",
            allowAutomaticClientStart:
                "Mit dieser Einstellung auf, %{name} wird automatisch nach dem Start des Computers gestartet.",
            allowAutomaticPrint: "Automatisches Drucken erlauben",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Kundenauswahl erlauben",
            allowDispensing: "Dosierung erlauben",
            allowFileTransfer:
                "Ist diese Einstellung aktiviert, ist ein automatischer Datenimport und -export per Dateitransfer mÃ¶glich.",
            allowFormulaModificationPanel: "Im Rezepturfenster wird die Ãnderungsanzeige aktiviert.",
            allowFormulaStatusPanel: "Auf dem Rezepturfenster wird das Status-Panel aktiviert.",
            allowLight: "%{name} erlauben",
            allowOrdering: "Bestellung erlauben",
            allowPricing:
                "Im Rezepturfenster werden die Preise angezeigt. Welche Preise angezeigt werden, wird unter VerfÃ¼gbare Preise festgelegt. Die Preise selbst werden in den Preiseinstellungen festgelegt.",
            allowProductPreviewImage: "Das Produktvorschau wird wÃ¤hrend der Dosierung angezeigt.",
            allowQualityControl: "QualitÃ¤tskontrolle aktivieren",
            allowSearchCheaperColors:
                "Im Rezepturfenster wird die Funktion zur Suche nach gÃ¼nstigeren Farben angezeigt.",
            allowSoundNotification: "Bei Auftragempfang wird die musikalische Melodie abgespielt.",
            allowSpectro: "Spectrosektion anzeigen.",
            allowTabs:
                "Wenn diese Einstellung aktiviert ist, kÃ¶nnen Sie mit mehreren Registerkarten gleichzeitig arbeiten.",
            applyZoom:
                "Der Zoom vergrÃ¶Ãert oder verkleinert die AuflÃ¶sung. Die Tastenkombinationen CTRL + und CTRL - sind ebenfalls anwendbar.",
            automaticLogout: "Festlegen, nach wie vielen Minuten die automatische Abmeldung aktiviert wird.",
            availableDatabases:
                "Diese Einstellung ermÃ¶glicht, zwischen den Datenbanken zu wechseln, wenn mehr als eine vorhanden ist.",
            backupLocalDB:
                "Exportiert die lokale Datenbank. Die exportierte Datei kann als Datenbanksicherung verwendet werden.",
            barcodeTesting:
                "Die Barcode-Testumgebung ermÃ¶glicht die ÃberprÃ¼fung der Korrektheit des gescannten Barcodes durch direkten Vergleich mit den in der Datenbank hinterlegten Barcodes.",
            customBanner: "Eigenes Logo oder Banner und dessen Position festlegen.",
            customCurrencyFormat:
                "Das benutzerdefinierte WÃ¤hrungsformat kann das Standard-WÃ¤hrungsformat je nach ausgewÃ¤hlter Sprache Ã¼berschreiben. ",
            customDateFormat:
                "Das benutzerdefinierte Datumsformat kann das Standard-Datumsformat je nach gewÃ¤hlter Sprache Ã¼berschreiben.",
            customNumberFormat:
                "Das benutzerdefinierte Zahlenformat kann das Standardzahlenformat je nach gewÃ¤hlter Sprache Ã¼berschreiben.",
            customTimeFormat:
                "Das benutzerdefinierte Zeitformat kann das Standardzeitformat je nach gewÃ¤hlter Sprache Ã¼berschreiben.",
            defaultPrinter:
                "Der ausgewÃ¤hlte Drucker wird beim Drucken von Etiketten verwendet, sofern er nicht im Fenster Druckeroptionen geÃ¤ndert wurde.",
            defaultTemplate:
                "Die ausgewÃ¤hlte Ettikete wird beim Drucken verwendet, sofern er nicht im Fenster Druckeroptionen geÃ¤ndert wurde.",
            deleteImportedData:
                "LÃ¶scht die zuvor importierten benutzerdefinierten Daten. Die Daten kÃ¶nnen nach dem LÃ¶schen erneut importiert werden.",
            diskSpaceNotification:
                "PrÃ¼ft den verfÃ¼gbaren Speicherplatz und benachrichtigt, wenn der Speicherplatz nicht ausreicht.",
            dispensingNotes: "Auf der Rezepturkarte werden die Dosieranmerkungen zugÃ¤nglich.",
            downloadListEmpty: "Keine Downloads in Bearbeitung",
            enableVirtualKeyboard: "In %{name} kann die Virtualle Tastatur angezeigt werden.",
            exportLocalSettings:
                "Exportiert die lokalen Einstellungen dieses Computers. Die Datei kann auf einem anderen Computer importiert werden, um identische lokale Einstellungen anzuwenden.",
            exportStaticSql:
                "Exportiert die lokalen Einstellungen dieses Computers. Die exportierte Datei kann verwendet werden, um eine neue Datenbank mit diesen Einstellungen zu erstellen.",
            exportTranslationKeys:
                "Exportieren Sie die neuesten noch nicht Ã¼bersetzten Programmpunkte und senden Sie diese nach der Ãbersetzung per E-Mail an Ihren Softwareanbieter, damit dieser sie fÃ¼r zukÃ¼nftige Programmversionen importieren kann.",
            favoriteButton: "Hier klicken , um diese Rezeptur als Favorit hinzuzufÃ¼gen",
            formulaNotes: "Auf der Rezepturkarte werden die Rezepturanmerkungen zugÃ¤nglich.",
            helpSettings: "Die Informationen sind im Abschnitt Hilfe auf dem Schnellzugriffsmenu sichtbar.",
            importCustomData: "Importiert die lokalen benutzerdefinierten Daten basierend auf dem ausgewÃ¤hlten Format.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "Im Rezeptufenster wird die interne Notiz angezeigt.",
            lockComputer:
                "Mit dieser Einstellung an kann man %{name} nicht verlassen - es ermÃ¶glicht die ultimative Erfahrung im Kiosk-Modus. Nur fÃ¼r Windows anwendbar.",
            maxNumberTabs: "Die Kartengrenze legt fest, wie viele Rezepturkarten gleichzeitig geÃ¶ffnet werden kÃ¶nnen.",
            memoryTabs: "Erneutes Ãffnen der zuletzt geÃ¶ffneten Registerkarten nach dem Start der Software erlauben.",
            printAfterDispensing:
                "Die Einstellung erfordert Informationen darÃ¼ber, wie viele Etikettenkopien nach dem Dosierungsprozess gedruckt werden sollen.",
            printAsImage:
                "Drucken als Bild hilft die Probleme zu lÃ¶sen, die beim Standarddruck vortreten. Wenn der Standarddruck korrekt funktioniert, verwenden Sie es nicht. Kompatibel nur mit Linux.",
            printBeforeDispensing:
                "Die Einstellung erfordert Informationen darÃ¼ber, wie viele Etikettenkopien vor dem Dosierungsprozess gedruckt werden sollen.",
            printEnabled:
                "Diese Einstellung ermÃ¶glicht die Verwendung der Druckersoftware. Weitere Einstellungen finden Sie unter Druckeinstellungen.",
            printOnRequest: "Drucken erlauben",
            printTaskVariable:
                "Der Ausdruck wird nur bearbeitet, wenn die angegebene Druckvariable in den Druckdaten vorhanden ist",
            quickTintTemplate:
                "Die ausgewÃ¤hlte Schablone wird beim Drucken von Ettiketen der manuallen Eingabe verwendet.",
            restoreLocalSettings: "Stellt die lokalen Einstellungen dieses Computers wieder her.",
            runLightAtStartUp: "%{light} wird anstelle von %{name} gestartet sein.",
            screenSaverTimeout:
                "Hier wird eingestellt, nach wie vielen Minuten der Bildschirmschoner aktiviert werden soll.",
            selectCustomDataFormat:
                "Format der zu importierenden Originaldaten aswÃ¤hlen. Jedes Format kann unterschiedliche zusÃ¤tzliche Dateien und Einstellungen erfordern.",
            setCustomHomeButton: "Der Home-Knopf in %{name} wird auf das ausgewÃ¤hlte Panel umleiten.",
            setFts: "Die Volltextsuche ermÃ¶glicht die Volltext-Rezeptursuche (auch von der Mitte des Wortes aus, usw.).",
            setKeyboardShortcuts:
                "Es ist nicht mÃ¶glich, dieselbe Tastenkombination fÃ¼r zwei verschiedene Aktionen einzustellen.",
            setNumberOfDecimalPlaces:
                "Rundung legt fest, wie viele Dezimalstellen von Pigmentenmengen werden angezeigt.",
            setOrderSearchParameters:
                "Die Auftragssuche definiert, welche Parameter bei der Suche unter den AuftrÃ¤gen verwendet werden. Nur zugÃ¤nglich in %{name}.",
            setOverwriteLastTab:
                "Bei der Auswahl einer neuen Rezeptur Ã¼ber die globale Suche wird bei Erreichen der Rezepturfenstergrenze das zuletzt geladene Rezepturfenster durch die neue Rezepturauswahl Ã¼berschrieben.",
            setSearchPanel:
                "Legen Sie die Ansicht und die Reihenfolge der Elemente, die bei der Suche nach einer neuen Rezeptur verwendet werden, selbst fest.",
            setVisibilityAndOrder:
                "Die ausgewÃ¤hlten Navigationselemente sind im Schnellzugriffsmenu sichtbar. Die hÃ¶chste Position definiert hier ist die linke Position im Panel. Die maximal zulÃ¤ssige Anzahl von Navigationselementen ist 6.",
            setYourLanguage: "Eine SprachÃ¤nderung erfordert einen Neustart der Software.",
            settingsSearch:
                "Schlagen Sie verschiedene Einstellungen nach, wenn Sie nicht wissen, wo sie zu finden sind.",
            showNewOrderNotifications:
                "Die Auftragsbenachrichtigung ist ein Popup-Fenster, das den Empfang einer neuen Bestellung meldet.",
            sorting: "Die Kanister kÃ¶nnen nach den Namen der Pigmente oder nach Kanister-IDs sortiert werden.",
            turnOnKioskMode: "Kioskmodus Ã¼berdeckt die Taskbar.",
            windowClosingRules:
                "Die Einstellung entscheidet, ob sich das Fenster Manuelle Dosierung  vor oder nach Beginn des Dosiervorgangs schlieÃt."
        },
        formulaSettings: {
            additionalFormulaTab:
                "Diese Einstellung legt fest, welches Fenster beim Ãffnen eines neuen Rezepturfensters angezeigt wird.",
            allowCustomFormulas: "Die Erstellung und Suche nach eigenen Rezepture wird aktiviert.",
            allowCustomPackageSize: "Auf der Rezepturkarte wird die MÃ¶glichkeit fÃ¼r eigene GebindegrÃ¶Ãe aktiviert.",
            allowEditingColorants:
                "Auf der Rezepturkarte wird der Knopf Rezeptbearbeitung aktiviert (sichtbar nach Auswahl einer Farbe).",
            alternativeFormulasPosition: "Legt fest, wie auf alternative Formeln zugegriffen werden kann.",
            basePanelSize: "GrÃ¶Ãe der Base im Rezepturfenster einstellen",
            bippPanelSize: "GrÃ¶Ãe der Base in der Anzeige der GebindegrÃ¶Ãe im Rezepturfenster einstellen",
            blendColorNameAndCode:
                "Mit dieser Einstellung werden die Suchfelder fÃ¼r Farbtonname und Farbtonnummer zu einem einzigen Suchfeld zusammengefÃ¼gt.",
            color: "Auf der Rezepturkarte wird die einzige sichtbare Information der Farbvorschau.",
            colorCodePrimary: "Die Farbtonnummer wird im Suchfeld zuerst angezeigt.",
            colorPreviewAsImage: "Im Rezepturfenster wird die Farbvorschau als Bild dargestellt.",
            colorPreviewResizable: "ErmÃ¶glicht die Ãnderung der GrÃ¶Ãe der Farbvorschau.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Im Rezeptfenster kÃ¶nnen die Pigmente nach Namen oder nach Mengen angeordnet werden.",
            customCanOption:
                "WÃ¤hlen Sie, welche MaÃeinheiten fÃ¼r die benutzerdefinierte VerpackungsgrÃ¶Ãe im Rezepturfenster verwendet werden kÃ¶nnen.",
            customCanSettingsUnit:
                "WÃ¤hlen Sie, welche MaÃeinheit als Standard fÃ¼r die benutzerdefinierte VerpackungsgrÃ¶Ãe im Rezepturfenster verwendet werden kÃ¶nnen.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "Mit dieser Einstellung auf werden beim ArtikelnlÃ¶schen BestÃ¤tigungsfenster aktiviert.",
            dropDownCalculate:
                "Das Dropdown-MenÃ¼ zur Auswahl der gesuchten Rezeptur erstreckt sich bis zum unteren Rand des Fensters.",
            fandeckGroups:
                "Diese Einstellung aktiviert die Ansicht von FarbtonfÃ¤cher-Gruppen, sofern in der Datenbank vorhanden.",
            fandeckPanelSize: "GrÃ¶Ãe der Anzeige des FarbtonfÃ¤chers im Rezepturfenster einstellen",
            favoriteFormulasInitial: "Favoritenfenster beim Start von %{name} anzeigen.",
            formulaAutomaticNaming:
                "Eine geÃ¤nderte Rezeptur wird automatisch auf Grund der durchgefÃ¼hrten Pigmentenmodifikationen benannt.",
            formulaPanel: "Beim Ãffnen einer neuen Karte wird der Rezeptur-Fenster angezeigt.",
            formulaPanelInitial: "Rezeptur-Fenster beim Start von %{name} anzeigen.",
            formulaPanelSize: "GrÃ¶Ãe der Rezeptur im Rezepturfenster festlegen",
            formulaPropertiesPosition: "Legt fest, wie auf die Eigenschaften der Rezeptur zugegriffen werden kann.",
            generateColorPreview:
                "Wenn diese Einstellung aktiviert ist, wird die Farbvorschau automatisch erstellt. Die resultierende Vorschau ist nicht genau.",
            historicalFormulasPosition: "Legt fest, wie auf historische Rezepturen zugegriffen werden kann.",
            image: "Auf der Rezepturkarte wird das Produktvorschau-Bild neben der Farbvorschau sichtbar sein, auch mit der MÃ¶glichkeit, mehrere Informationen zu Ã¶ffnen.",
            images: "Mit dieser Einstellung wird die Quelle der Bilddateien festgelegt.",
            infoPanelResizable: "GrÃ¶Ãe des Info-Panels Ã¤ndern.",
            initialFormulaTab: "Hier wird festgelegt, welches Fenster nach dem Start von %{0} angezeigt wird.",
            moreInfo:
                "Auf der Rezepturkarte wird der Informationenpanel neben dem Farbvorschau und dem Produktvorschau-Bild sichtbar sein.",
            orderByDistance:
                "Wenn diese Einstellung aktiviert ist, wird das Ergebnis der Farbsuche nach einer speziellen Abstandsmetrik geordnet.",
            productCode:
                "Verwendung von Produktcodes zusammen mit Produktnamen, wenn diese in der Datenbank verfÃ¼gbar sind.",
            productFiles: "Quelle der Produktdateien, die im Rezepturfenster angezeigt werden.",
            productGroups:
                "Die Einstellung ermÃ¶glicht eine Anzeige der Hierarchie nach Produktgruppen, falls diese in der Datenbank vorhanden sind.",
            productPanelSize: "GrÃ¶Ãe des Produkts im Rezepturfenster einstellen",
            searchNewFormula:
                "Beim Ãffnung von einer neuen Karte wird der Neue-Rezeptur-Suchen-Panel erscheinen (enthÃ¤lt Informationen Ã¼ber die letzdosierten Rezepturen und Ã¼ber Favoritrezepturen).",
            searchNewFormulaInitial:
                "Beim Start von %{name} wird der Neue-Rezeptur-Suchen-Panel erscheinen (enthÃ¤lt Informationen Ã¼ber die letzdosierten Rezepturen und Ã¼ber Favoritrezepturen).",
            searchPanelFormulaItems: "Mindestens eine der Positionen fÃ¼r die Rezeptur muss ausgewÃ¤hlt sein.",
            searchPanelProductItems: "Es kann nur einer der Produktartikel ausgewÃ¤hlt werden.",
            searchPanelQuickSelect:
                "Sie mÃ¼ssen nicht auf die SchaltflÃ¤che Formel laden klicken. Das Rezepturfenster wird direkt nach der Rezepturauswahl angezeigt.",
            setCompetitiveColorSearch:
                "Wenn diese Einstellung aktiviert ist, ist die Funktion der wettbewerbsorientierten Farbsuche in der Farbpalette verfÃ¼gbar und im Rezepturfenster.",
            setFormulaInfoInPreview:
                "Im Rezeptur-Fenster wird der ausgewÃ¤hlte Datentyp immer in der Farbvorschau angezeigt.",
            setFormulaPreview:
                "Die Einstellung Ã¤ndert die Position und Anzeige der Farbvorschau, des Produktfotos und der Informationsdaten zur Farbe.",
            setFormulaRGBPreviewVisibleInformation:
                "Auf der Rezepturkarte wird der ausgewÃ¤hlte Datentyp immer in dem Farbvorschau sichtbar.",
            setFormulaUnit:
                "Auf der Rezepturkarte wird die ausgewÃ¤hlte MaÃeinheit als die erste geÃ¶ffnet. Auch in Manueller Dosierung anwenbar.",
            setFormulaVisibilityAndOrder:
                "Auf der Rezepturkarte werden die ausgewÃ¤hlten Datentypen in der Sektion Mehr info sichtbar sein (nur anwenbar wenn Rezepturvorschaueinstellung Bild oder Mehr Informationen ist).",
            setMaxToleranceForCompetitiveColors:
                "Die maximale Delta E-Toleranz (CIA 2000) fÃ¼r die kompetitive Farbsuche festlegen.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "Auf der Rezepturkarte werden die ausgewÃ¤hlten MaÃeinheiten sichtbar sein. Auch in Manueller Dosierung anwenbar.",
            showColorPreview:
                "Auf der Rezepturkarte wird beim Rezeptursuchung eine kleine Farbvorschau neben dem Farbennamen sichtbar sein.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "Auf der Rezepturkarte wird die Farbtonnummer aktiviert."
        },
        formulaValidation: {
            batchNumberInvalid: "Der Kanister (%{colorants}) ist mit einer fehlerhaften Farbstoffcharge gefÃ¼llt.",
            batchNumberWarning: "Das Pigmentkonzentrat (%{colorants}) mit dieser Chargennummer kann beschÃ¤digt sein.",
            bellowBaseLimit: "Die Summe der Pigmentmengen liegt unter dem Basisgrenzwert.",
            checkColorantBaseRules:
                "Die Einstellung prÃ¼ft, ob die verwendeten Pigmentkonzentrate und die Base in dieser Kombination verwendet werden kÃ¶nnen.",
            checkMinDosableAmount:
                "Die minimale dosierbare Menge ist die kleinste Pigmentmenge, die gemÃ¤Ã den Empfehlungen des Labors oder des Maschinenherstellers dosiert werden kann.",
            checkOverfill:
                "Bei dieser Einstellung wird Ã¼berprÃ¼ft, ob in dem Gebinde genÃ¼gend Platz fÃ¼r die Pigmente vorhanden ist, sobald die Mengen eingestellt sind.",
            checkTotalCntAmounts:
                "Die Einstellung prÃ¼ft, ob die Grenzwerte fÃ¼r die minimalen und maximalen Farbstoffmengen in der Produktverpackung Ã¼berschritten wurden. Diese Grenzwerte sind in der Datenbank definiert.",
            colorantBaseRules: "Das Pigmentkonzentrat ist fÃ¼r die ausgewÃ¤hlte Base nicht zugelassen.",
            colorantMinAmount: "Die Pigmentmenge liegt unter der minimalen abtÃ¶nbaren Menge.",
            dispensingWithErrorsEnabled:
                "Wenn erlaubt, erscheint bei VerstÃ¶Ãen gegen die Validierung eine Warnmeldung, aber es ist mÃ¶glich, trotzdem mit der Dosierung fortzufahren.",
            invalidBatchNumber: "Das Pigmentkonzentrat hat eine ungÃ¼ltige oder fehlerhafte Chargennummer",
            overBaseLimit: "Die Summe derPigemntmengen liegt Ã¼ber der maximal abtÃ¶nbaren Menge.",
            overfill: "Es wurde eine ÃberfÃ¼llung festgestellt.",
            unifyColorantBatchForMultipleCans:
                "Wenn erlaubt, erscheint eine Info zum NachfÃ¼llen bis zum Maximum, wenn die Farbstoffmenge grÃ¶Ãer als das Maximum des Kanisters ist und der Kanister nicht bis zum Maximum gefÃ¼llt ist.",
            warningConfirmBtn: "Die Risiken sind mir bewusst, trotzdem fortfahren"
        },
        help: "Hilfe",
        helpLink: "Hilfe-Center",
        helper: {
            automaticallyCheckForUpdates:
                "Es wird automatisch geprÃ¼ft, ob im angegebenen Zeitintervall eine Aktualisierung fÃ¼r %{name} oder die Datenbank verfÃ¼gbar ist.",
            automaticallyDownloadUpdates:
                "Wenn ein Update verfÃ¼gbar ist, wird es automatisch heruntergeladen, ohne dass Sie es bestÃ¤tigen mÃ¼ssen.",
            automaticallyInstallNewDatabases:
                "Wenn eine bisher nicht vorhandener DB gesendet wird, wird diese als neue DB installiert. Danach kann der DB verwendet werden.",
            automaticallyInstallUpdates:
                "Wenn ein Update heruntergeladen wurde, wird es automatisch installiert, ohne dass Sie es bestÃ¤tigen mÃ¼ssen.",
            canBrowseChangeLog:
                "Wenn Sie die Software aktualisieren, kÃ¶nnen Sie das offizielle Ãnderungsprotokoll von %{name} einsehen",
            forceInstall: "Das Update wird auf jeden Fall installiert.",
            installDuringNight: "Das Update wird wÃ¤hrend der Nacht installiert, wenn der Computer eingeschaltet ist."
        },
        licensing: {
            collect:
                "Die Logdateien werden an den ausgewÃ¤hlten Ort heruntergeladen. Die Logdateien werden von der mitgelieferten Software fÃ¼r die Fehleranalyse benÃ¶tigt.",
            company: "Das Unternehmen, das die Lizenz erteilt hat.",
            computerID: "Computer-Identifikation, bitte dem Software-Lieferanten im Support-Fall mitteilen.",
            email: "Die E-Mail Adresse des Lizenzinhabers.",
            licenseUuid: "Lizenz-Identifikation, bitte dem Software-Lieferanten im Support-Fall mitteilen.",
            name: "Der Name des Lizenzinhabers.",
            openBugreport:
                "Bitte lassen Sie uns wissen, wenn es einen Fehler in der Software gibt und senden Sie uns einen Bericht mit der Fehlerbeschreibung.",
            posInfoContactperson: "POS-Informationen Ã¼ber den EigentÃ¼mer, die auf dem Etikett gedruckt werden sollen.",
            posInfoMachineInformation:
                "POS-Informationen Ã¼ber die Dosieranlage, die auf das Etikett gedruckt oder im Netzwerk erkannt werden sollen.",
            posInfoPos: "POS-Informationen Ã¼ber den Standort, der auf das Etikett gedruckt werden soll.",
            reactivation: "Reaktivierung oder Ãnderung der aktuellen Lizenz.",
            refresh: "Die neuesten Lizenzinformationen herunterladen.",
            refreshUnavailable: "Die Lizenzaktualisierung ist nicht verfÃ¼gbar, da Sie offline sind.",
            registrationContactperson: "Registrierungsinformationen zur Identifizierung des EigentÃ¼mers der Lizenz.",
            registrationMachineInformation:
                "Registrierungsinformationen zur Identifizierung des Dispensers der Lizenz.",
            registrationPos: "Registrierungsinformationen zur Identifizierung des Standorts der Lizenz.",
            versionScope: "Die Software hat ein Ablaufdatum.",
            versionType: "Die Art des Softwareprodukts"
        },
        machineIsBusy: "Fehler kÃ¶nnen nicht zurÃ¼ckgesetzt werden, da die Maschine beschÃ¤ftigt ist oder nicht reagiert.",
        machineSettings: {
            allowManualColorantAddition:
                "Wenn die erforderliche Pigmentenmenge die maximale Ausgabemenge Ã¼berschreitet, kann sie mit diesem Einstellung nach der Dosierung manuell hinzugefÃ¼gt werden.",
            autotasks:
                "Autotasks sind automatische Maschinen- und Computerwartungsereignisse, die so eingestellt werden kÃ¶nnen, dass sie in einem bestimmten Zeitraum oder Zeitintervall ausgefÃ¼hrt werden.",
            barcodeRefillValidation: "Mit dieser Einstellung wird die BarcodeÃ¼berprÃ¼fung beim NachfÃ¼llen aktiviert.",
            barcodeRefillValidationBaseAndColorant:
                "Beim NachfÃ¼llen von Kanistern und Pigmentkonzentratpackungen wird eine Barcodekontrolle durchgefÃ¼hrt.",
            barcodeRefillValidationColorant:
                "Beim NachfÃ¼llen von Pigmentkonzentratpackungen wird eine Barcodekontrolle durchgefÃ¼hrt.",
            canisterBarcode:
                "Der Barcode ist dem Kanister zugeordnet, in dem das Pigment enthalten ist. Der Barcode ist notwendig, um eine korrekte NachfÃ¼llung des Pigments zu gewÃ¤hrleisten.",
            checkCanBeforeDispense: "Die Einstellung gilt nur fÃ¼r die Fast Fluid Simulation.",
            checkOverfill:
                "Die Einstellung prÃ¼ft, ob vor der Abgabe genÃ¼gend Platz in der Dose fÃ¼r die Pigmenten vorhanden ist.",
            currentlySelectedMachine: "Hier finden Sie Informationen Ã¼ber die aktuell ausgewÃ¤hlte Maschine.",
            dispenseInvalidColorants:
                "Die Einstellung ermÃ¶glicht die Ausgabe von Pigmenten, die nicht in der Maschinenkonfiguration definiert sind, indem eine manuelle Pigmentzugabe angefordert wird.",
            dispenserConfigurationBackup:
                "Laden Sie die aktuelle Maschinenkonfiguration herunter und speichern Sie sie, um ein Backup zu erhalten.",
            dispensingLogic:
                "Dosierlogik-Typen kÃ¶nnen ein unterschiedliches Verhalten fÃ¼r jeden Kanister sicherstellen, wenn mehr Pigment zu dosieren ist als erlaubt oder gewÃ¼nscht. Das zusÃ¤tzliche Verhalten wird in den Dosiereinstellungen festgelegt.",
            enableTmc: "Die Einstellung ermÃ¶glicht das Senden von Daten an TMC.",
            enableUserIdentification: "Der Benutzer muss sich anmelden, bevor die Dosierung erlaubt wird.",
            machineUnit: "Die Maschineneinheit definiert die MaÃeinheit fÃ¼r Pigmente in den Kanistern.",
            minDispensedAmount:
                "Die min. Abgabemenge legt fest, wie viel Pigmente abgegeben werden muss, um die SpÃ¼lung als fertig zu berÃ¼cksichtigen (um eine zusÃ¤tzliche SpÃ¼lung zu vermeiden).",
            minimalDispenseAmount:
                "Die min. Abgabemenge ist die kleinste empfohlene Pigmentenmenge, die dosiert werden kann. Bei Verletzung erscheint eine Meldung (Dosierung ist weiterhin mÃ¶glich).",
            missingAutotaskCanisters: "Es muss mindestens 1 Kanister ausgewÃ¤hlt werden",
            missingAutotaskChannels: "Es muss mindestens 1 Kanal ausgewÃ¤hlt werden",
            missingAutotaskChannelsValue: "Die Anzahl aller ausgewÃ¤hlten KanÃ¤le muss eingegeben werden",
            missingAutotaskCleanTime: "Die Uhrzeit der Reinigung muss angegeben werden",
            missingAutotaskName: "Der Name des Autotask muss eingegeben werden",
            missingAutotaskRecirculation: "Zeit und Geschwindigkeit der Rezikulation mÃ¼ssen eingegeben werden",
            missingAutotaskStirring: "Zeit und Geschwindigkeit des RÃ¼hrens mÃ¼ssen angegeben werden",
            missingAutotaskVolume: "Volumen der SpÃ¼lung muss eingestellt werden",
            placeCanSensor:
                "Die Einstellung aktiviert den Sensor fÃ¼r die Dosenstellung - die Dosierung beginnt erst, wenn die Dose richtig platziert wurde.",
            placeCanSensorDelay:
                "Empfohlene Einstellung in Verbindung mit dem Dosen-Sensor. Es stellt sicher, dass die Dosierung erst nach Ablauf der definierten Zeitspanne beginnt, in der die Dose richtig platziert wurde.",
            purgeVolume:
                "Das SpÃ¼lvolumen legt fest, wie viel Pigmentenmenge bei der Intelligenten SpÃ¼lung gespÃ¼lt wird.",
            rccUrl: "Das Redlike Control Center (RCC) ist fÃ¼r die Kommunikation mit dem Dispenser zustÃ¤ndig.",
            refillThreshold:
                "Sinkt die Menge des Pigmentkonzentrats im Kanister mit der angegebenen UFI- oder Chargennummer unter diesen Grenzwert, wird diese UFI- oder Chargennummer verworfen.",
            refillThresholdBatch:
                "Sinkt die Menge des Farbstoffs im Kanister mit der angegebenen Chargennummer unter diesen Grenzwert, wird diese Chargennummer verworfen.",
            refillThresholdUfi:
                "Sinkt die Menge des Farbstoffs im Kanister mit dem gegebenen UFI unter diesen Grenzwert, wird dieser UFI verworfen.",
            removeCanSensor:
                "Die Einstellung aktiviert den Sensor fÃ¼r die Dosenentnahme - die Dosierung gilt erst dann als abgeschlossen, wenn die Dose entnommen wurde.",
            removeCanSensorDelay:
                "Empfohlene Einstellung in Verbindung mit dem Sensor zum Entfernen der Dose. Es stellt sicher, dass die Dosierung erst nach Ablauf der definierten Zeitspanne, in der die Dose entnommen wurde, abgeschlossen ist.",
            skipPlaceCanDialog:
                "Wenn diese Einstellung eingeschaltet ist, wartet die Machine nicht beim Einlegen einer Dose, bis der OK-Knupf gedrÃ¼ckt wird, sondern startet den Dosiervorgang automatisch.",
            skipRemoveCanDialog:
                "Wenn diese Einstellung eingeschaltet ist, wartet die Machine nicht beim Entnehmen einer Dose, bis der OK-Knupf gedrÃ¼ckt wird, sondern betrachtet den Dosiervorgang als automatisch beendet.",
            smartPurgeType:
                "Der SpÃ¼ltyp kann entweder nur die Dosierung oder die Dosierung sowie andere SpÃ¼lvorgÃ¤nge in Betracht ziehen, um zu Ã¼berprÃ¼fen, ob eine intelligente SpÃ¼lung erforderlich ist.",
            splitFormula:
                "Wenn die erforderliche Pigmentenmenge die maximale Ausgabemenge Ã¼berschreitet, kann man mit dieser Einstellung einen Pigmententeil ausgeben, der BehÃ¤lter wieder befÃ¼llen und dann der Rest weiter dosieren.",
            tintometricSystem:
                "Das TÃ¶nsystem (Menge der verfÃ¼gbaren Pigmentkonzentrate) legt fest, welche Pigmentkonzentrate und Rezepturen in der Anwendung und den Anwendungseinstellungen verfÃ¼gbar sind.",
            validateBarcodeBaseCan:
                "Das Basengebinde muss mit einem Barcode validiert werden, bevor die Abgabe erlaubt ist. Die Einstellung stellt sicher, dass die richtige Base verwendet wird.",
            validateColorantsDuringInit:
                "Die Maschinenkonfiguration wird jedes Mal mit der Datenbank verglichen, wenn RCC neu gestartet wird. Bei Unstimmigkeiten erfolgt eine Benachrichtigung."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Legt fest, wie viele Ergebnisse nach dem Messen angeboten werden sollen."
        },
        navigation: {
            barcodeScan: "Ãffnet ein Fenster mit der MÃ¶glichkeit, den Barcode manuell einzugeben.",
            canisterBarcodes:
                "Ãffnet ein Fenster mit einer Ãbersicht Ã¼ber den Kanister-Barcode und der MÃ¶glichkeit, sie einzustellen.",
            canisterLevel:
                "Ãffnet ein Fenster mit einer Ãbersicht der Kanisterebenen und der MÃ¶glichkeit, sie einzustellen.",
            canisters:
                "Ãffnet ein Fenster mit einer Ãbersicht der Kanisterebenen und der MÃ¶glichkeit, sie einzustellen",
            clean: "Ãffnen Sie ein Fenster mit der MÃ¶glichkeit, die Kanister oder Leitungen der Maschinen zu reinigen",
            colorPanel:
                "Ãffnet ein Fenster mit der MÃ¶glichkeit, in einer elektronischen Kollektion nach einer neuen Rezeptur zu suchen.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Ãffnet ein Fenster mit der Ãbersicht der durchgefÃ¼hrten KanisterbefÃ¼llungen.",
            customFormula:
                "Ãffnet ein Fenster mit der MÃ¶glichkeit, eine neue benutzerdefinierte Rezeptur zu erstellen.",
            customers:
                "Ãffnet ein Fenster mit einer Ãbersicht der Kunden und der MÃ¶glichkeit, sie hinzuzufÃ¼gen/zu bearbeiten/zu lÃ¶schen.",
            dispensingHistory: "Ãffnet ein Fenster mit einer Ãbersicht der durchgefÃ¼hrten TÃ¶nungen.",
            favorites: "Ãffnet ein Fenster mit der MÃ¶glichkeit, eine Favoriten-Rezeptur auszuwÃ¤hlen.",
            help: "Ãffnet ein Fenster mit Kundenservice-Informationen, wenn diese vom Anbieter zur VerfÃ¼gung gestellt werden.",
            hideItems: "Ãffnet ein Fenster mit der MÃ¶glichkeit, Produkte und Fandecks als versteckt zu markieren.",
            historyOfOrders:
                "GÃ¼ltig nur fÃ¼r %{name}, Ã¶ffnet ein Fenster mit einer Ãbersicht der abgetÃ¶nten Bestellungen.",
            machineReset: "Reset der Machine wird gestartet.",
            matching: "Ãffnet ein Fenster mit der MÃ¶glichkeit, einen neuen Farbton mit einem Spektro zu messen.",
            myOrders: "Ãffnet ein Fenster mit den gesendeten Bestellungen.",
            purge: "Ãffnet ein Fenster mit der MÃ¶glichkeit, DÃ¼senreinigung einzustellen.",
            quickTint: "Ãffnet ein Fenster mit der MÃ¶glichkeit, manuelle Dosierung durchzufÃ¼hren.",
            searchFormula: "Ãffnet ein Fenster mit der MÃ¶glichkeit, neue Rezeptur zu suchen.",
            spectro: "Ãffnet ein Fenster mit der MÃ¶glichkeit, mit dem Spectro zu messen.",
            stir: "Ãffnet ein Fenster mit der MÃ¶glichkeit, KanisterrÃ¼hrung einzustellen.",
            ticketing: "Ãffnet ein Fenster im Bedienfeld um Tickets anzuzeigen und zu erstellen.",
            toDispense: "Ãffnet ein Fenster mit empfangenen Bestellungen."
        },
        noHelpForLicense:
            "Es ist keine Hilfe fÃ¼r Ihre Lizenz verfÃ¼gbar, bitten Sie Ihren Lieferanten, diese hinzuzufÃ¼gen.",
        posInfo: {
            sync: "Synchronisiert Daten mit dem Bereich Registrierung"
        },
        poweredByDeso: "Angetrieben von %{name}",
        priceSettings: {
            VatPrice: "MwSt von Pigment in %.",
            VatPriceProduct: "Die generische Produkt-Mehrwertsteuer ist fÃ¼r alle Pigmente gleich. Festgelegt in %.",
            basePurchase: "Der Kaufpreis fÃ¼r Basis (inkl. ausschlieÃlich die Basis).",
            basePurchasePriceProduct:
                "Einkaufspreis fÃ¼r die GebindegrÃ¶Ãe der angegebenen Basis. Wird in der gewÃ¤hlten WÃ¤hrung festgelegt.",
            baseSell: "Der Verkaufspreis nur fÃ¼r die Basis (inkl. Basis und Marge/Preisaufschlag).",
            baseSellFull: "Kaufpreis der Base (inkl. Base exklusiv) ohne Rabatt.",
            cntName: "Legt fest, auf welchen Pigment sich der Preis bezieht.",
            cntPurchase: "Der Kaufpreis fÃ¼r Pigmente (inkl. ausschlieÃlich Pigmente).",
            cntPurchaseByName: "Individuelle Kaufpreise fÃ¼r jedes Pigment (inkl. ausschlieÃlich Pigmente).",
            cntPurchasePricePerLiter: "Der Kaufpreis fÃ¼r Pigment pro Liter (ohne Marge oder Preisaufschlag).",
            cntSell: "Der Verkaufspreis nur fÃ¼r Pigmente (inkl. Pigmente und Marge/Preisaufschlag).",
            cntSellByName:
                "Individuelle Verkaufspreise fÃ¼r alle Pigmente in dem Produkt (inkl. Pigmente und Marge/Preisaufschlag).",
            cntSellFull: "Einkaufspreis fÃ¼r Farbstoffe (inkl. Farbstoffe exklusiv) ohne Rabatt.",
            cntSellFullByName:
                "Einkaufspreis fÃ¼r Farbstoffe wird individuell fÃ¼r jeden (inkl. Farbstoffe ausschlieÃlich) ohne Rabatt berechnet.",
            cntSellPricePerLiter:
                "Der Verkaufspreis des Pigments pro Liter (inkl. Farbstoff exklusiv). Wird in der ausgewÃ¤hlten WÃ¤hrung angegeben.",
            cntVat: "Pigment-Mehrwertsteuerwert in %.",
            colorants:
                "Die allgemeinen Pigmentenpreise sind fÃ¼r jedes Pigment gleich. Diese Funktion ist insbesondere fÃ¼r die Einstellung der Mehrwertsteuer nÃ¼tzlich.",
            colorantsPosCoeficient: "Der generelle Rabatt fÃ¼r Pigmente dieses POS.",
            colorantsSellPrice:
                "Die generischen Pigmentpastenpreise sind fÃ¼r alle Pigmente gleich. Es wird empfohlen, den Verkaufspreis durch einen Rabatt zu Ã¤ndern und in der gewÃ¤hlten WÃ¤hrung einzustellen.",
            currencyCodeNew: "Der WÃ¤hrungscode muss offiziel sein (3 Buchstaben), z.B. EUR.",
            currencyNameNew: "Name der WÃ¤hrung, z.B. Euro.",
            currencyRateNew:
                "Der WÃ¤hrungskurs zur HauptwÃ¤hrung, z.B. 25.855 CZK fÃ¼r 1 â¬. Der Kurs muss kontinuierlich angepasst werden, um aktuel zu bleiben.",
            currencyRoundingNew:
                "Die Rundung setzt den kleinstmÃ¶glichen FÃ¤lligkeitswert der WÃ¤hrung, z.B. Euro hat die Rundung 0.01 weil der kleinstmÃ¶gliche FÃ¤lligkeitswert 1 Cent ist.",
            currencySymbolNew: "Das offizielle Symbol der WÃ¤hrung, z.B. â¬ fÃ¼r Euro.",
            defaultPrice: "Pigmentpreis, der in der ausgewÃ¤hlten Datenbank festgelegt ist (ohne MwSt).",
            defaultPriceGroup:
                "Pigmentpreis fÃ¼r die in der ausgewÃ¤hlten Datenbank eingestellte Preisgruppe (ohne MwSt).",
            defaultVatPrice: "Pigment-Mehrwertsteuer, die in der ausgewÃ¤hlten Datenbank festgelegt ist.",
            discountHeader: "Der Rabatt zieht den definierten Wert in % vom Einkaufspreis des Pigments ab.",
            discountHeaderProduct: "Der Rabatt zieht den definierten Wert in % vom Preis des Pigments ab.",
            export: "Export einer Datei mit den aktuellen Preisen. Diese Datei kann nach einer Ãnderung der Preise wieder importiert werden.",
            import: "Importieren einer korrekt formatierten (exportierten) Datei, um die Preise wieder einzufÃ¼gen oder zu Ã¤ndern.",
            localPrices:
                "Lokale Preiseingaben ersetzen die PreisvorschlÃ¤ge aus der Hauptdatenbank und werden nur lokal auf diesem Computer angezeigt.",
            margin: "WÃ¤hlen Sie, welche Preisberechnung fÃ¼r die Definition des endgÃ¼ltigen Verkaufspreises verwendet werden soll. Spanne und Aufschlag addieren sich, wÃ¤hrend der Rabatt vom angegebenen Verkaufspreis abgezogen wird.",
            marginAll: "Der Preis fÃ¼r Marge/Preisaufschlag fÃ¼r mehrere Gebinde (inkl. Marge/Preisaufschlag).",
            marginHeader: "Die Marge addiert den festgelegten Wert zum Einkaufspreis des Pigments. Festgelegt in %.",
            marginHeaderProduct: "Die Marge addiert den definierten Wert zum Preis des Produkts. Festgelegt in %.",
            marginPerPkg: "Der Preis fÃ¼r Marge/Preisaufschlag fÃ¼r eine Gebinde (inkl. Marge/Preisaufschlag).",
            markupHeader: "Der Aufschlag addiert den definierten Wert zum Einkaufspreis des Pigments. Festgelegt in %.",
            markupHeaderProduct:
                "Der Aufschlag addiert den definierten Wert auf den Kaufpreis des Produkts. Festgelegt in %.",
            packagePricing: "ZusÃ¤tzlicher Zuschlag wird fÃ¼r jede GebindegrÃ¶Ãe individuell festgelegt.",
            packageSurcharge: "Die allgemeinen Gebindepreise sind fÃ¼r jeden Gebindezuschlag gleich.",
            priceDefinition:
                "Die Einstellung legt fest, welche Preistypen bei der Berechnung der Endpreise verwendet werden.",
            priceGroupNumber:
                "Die Einstellung legt fest, wie viele Preisgruppen verwendet werden sollen. Der Bereich fÃ¼r die einzelnen Preisgruppen kann unter Standardwerte festgelegt werden.",
            priceGroupPricePerLiter: "Der Pigmentpreis, der bei der Berechnung des Preisgruppenpreises verwendet wird.",
            priceGroups:
                "Preisgruppen zeigt die Nummer der jeweiligen Preisgruppe an (die Grenzen werden auf der Datenbank oder bei der allgemeinen Preisgestaltung gesetzt).",
            priceGroupsEnabled:
                "Die Einstellung ermÃ¶glicht es Ihnen, mit Preisgruppen zu arbeiten. Definieren Sie den Bereich unter Standardwerte und die einzelnen Preise der Pigmente unter Pigmentpreise.",
            priceGroupsGeneric:
                "Preisgruppen sind Preisintervalle des Endprodukts basierend auf den Pigmentpreisen in der Rezeptur.",
            productBasePackageSellPrice:
                "Verkaufspreis fÃ¼r das Gebinde mit der angegebenen Basis. Wird in der ausgewÃ¤hlten WÃ¤hrung festgelegt.",
            productBaseSellPrice:
                "Verkaufspreis fÃ¼r das Gebinde pro Liter berechnet (inkl. Base exklusiv). Wird in der gewÃ¤hlten WÃ¤hrung eingestellt.",
            productBaseVat: "Produkt-Mehrwertsteuer-Basiswert fÃ¼r das angegebene Gebinde in %.",
            productName: "Legt fest, auf welche Produktbase sich der Preis bezieht.",
            productPosCoeficient: "Der generelle Rabatt fÃ¼r Produkte dieses POS.",
            productPricing: "Der Kaufpreis fÃ¼r alle Gebinde wird bei der manuellen Eingabe verwendet.",
            productSize: "Legt fest, auf welches Gebinde der gegebenen Produktbase sich der Preis bezieht.",
            productVat: "Wert der Produkt-Mehrwertsteuer in %",
            products:
                "Die allgemeinen Preise fÃ¼r Produkte sind fÃ¼r jedes Produkt gleich. Diese Funktion ist insbesondere fÃ¼r die Einstellung der Mehrwertsteuer nÃ¼tzlich.",
            productsSellPrice:
                "Die generischen Produktpreise sind fÃ¼r alle Pigmente gleich. Es wird empfohlen, den Verkaufspreis durch einen Rabatt zu Ã¤ndern und in der gewÃ¤hlten WÃ¤hrung einzustellen.",
            sellPriceAll:
                "Der Verkaufspreis fÃ¼r mehrere Gebinde (inkl. Basis, Pigmente, Zuschlag und Marge/Preisaufschlag).",
            sellPricePerKg:
                "Der Verkaufspreis des Produkts pro Kilogramm (inkl. Basis, Pigmente, Zuschlag und Marge/Preisaufschlag).",
            sellPricePerL:
                "Der Verkaufspreis des Produkts pro Liter (inkl. Basis, Pigmente, Zuschlag und Marge/Preisaufschlag).",
            sellPricePerPkg:
                "Der Verkaufspreis fÃ¼r eine Gebinde (inkl. Basis, Pigmente, Zuschlag und Marge/Preisaufschlag).",
            setPriceTypesVisibilityAndOrder:
                "Auf der Rezepturkarte werden die ausgewÃ¤hlten Preistypen in der Preissektion sichtbar. Die hÃ¶chste Position hier definiert die linke Position in der Preissektion.",
            surchargeAll: "Der Preis eines zusÃ¤tzlichen Aufschlags fÃ¼r mehrere Gebinde (inkl. Zuschlag).",
            surchargePerPkg: "Der Preis eines zusÃ¤tzlichen Aufschlags fÃ¼r ein Gebinde (inkl. Zuschlag).",
            tintPurchaseAll:
                "Der Kaufpreis fÃ¼r den gesamten TÃ¶nungsprozess mehrerer Gebinde (inkl. Pigmente und Zuschlag).",
            tintPurchasePerPkg:
                "Der Kaufpreis fÃ¼r den gesamten TÃ¶nungsprozess einer Gebinde (inkl. Pigmente und Zuschlag).",
            tintSellFullAll:
                "Der Kaufpreis fÃ¼r den gesamten TÃ¶nvorgang eines Gebindes (inkl. Farbmittel und Aufpreis) ohne Rabatt.",
            tintlSellFullAllPerPackage:
                "Der Kaufpreis fÃ¼r den gesamten TÃ¶nvorgang mehrerer Gebinde (inkl. Farbmittel und Aufpreis) ohne Rabatt.",
            totalPurchaseAll: "Der Gesamtkaufpreis des Produkts fÃ¼r mehrere Gebinde (inkl. Base und Pigmente).",
            totalPurchasePerKg: "Der Gesamtkaufpreis des Produkts pro Kilogramm (inkl. Base and Pigmente).",
            totalPurchasePerL: "Der Gesamtkaufpreis des Produkts pro Liter (inkl. Base and Pigmente).",
            totalPurchasePerPkg: "Der Gesamtkaufpreis des Produkts pro Gebinde (inkl. Basis und Pigmente).",
            totalSellFullAll:
                "Der Gesamtkaufpreis des Produkts fÃ¼r mehrere Packungen (inkl. Base und Pigmente) ohne Rabatt.",
            totalSellFullPerKg:
                "Der Gesamtkaufpreis des Produktes pro Kilogramm (inkl. Base und Pigmente) ohne Rabatt.",
            totalSellFullPerLiter:
                "Der Gesamtkaufpreis des Produkts pro Liter (einschlieÃlich Base und Pigmente) ohne Rabatt.",
            totalSellFullPerPackage:
                "Der Gesamtkaufpreis des Produktes pro Packung (inkl. Base und Pigmente) ohne Rabatt.",
            withAndWithoutVat:
                "Im Rezepturfenster wird der Preis beider Varianten, mit und ohne Mehrwertsteuer, gleichzeitig angezeigt.",
            withVat: "Im Rezepturfenster werden alle Preise nur inklusive Mehrwertsteuer angezeigt.",
            withoutVat: "Im Rezepturfenster werden alle Preise ohne Mehrwertsteuer angezeigt."
        },
        qualityControlSettings: {
            colorDifference: "Farbtondifferenzmodell fÃ¼r die QualitÃ¤tskontrolle.",
            deltaA: "Legt die Toleranzgrenze fÃ¼r delta A in der QualitÃ¤tskontrolle fest.",
            deltaB: "Legt die Toleranzgrenze fÃ¼r delta B in der QualitÃ¤tskontrolle fest.",
            deltaE: "Legt die Toleranzgrenze fÃ¼r delta E in der QualitÃ¤tskontrolle fest.",
            deltaL: "Legt die Toleranzgrenze fÃ¼r delta L in der QualitÃ¤tskontrolle fest.",
            deltaMetamerism: "Legt die Toleranzgrenze fÃ¼r Metamerie-Delta in der QualitÃ¤tskontrolle fest."
        },
        registration: {
            sync: "Synchronisiert Daten mit dem Abschnitt POS Info"
        },
        searchingPleaseWait: "Bitte warten Sie, die beste Ãbereinstimmung wird gesucht",
        setupSteps: {
            customData: "Benutzerdefinierte Daten",
            machineType: "Maschinentyp",
            userPreferences: "Benutzereinstellungen"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Wenn Sie profilierte Werte verwenden, werden die Messergebnisse neu berechnet, um den Filtereffekt zu entfernen. Erlauben Sie diese Option fÃ¼r die universelle Spektralmessung.",
            XRiteModelRM400: "Keine Treiber erforderlich",
            datacolorDiagnosticTile: "Datacolor Diagnosekachel verwenden",
            datacolorSilent: "Datacolor nicht sichtbar",
            measureModes: "UnterstÃ¼tzte Glanzgrade auswÃ¤hlen",
            model: "Modell",
            simulationPath: "Pfad zur Simulationsdatei. Default voreingestellt",
            spectroType: "Der offizielle Spectro-Treiber muss installiert sein. Nur fÃ¼r Windows.",
            spectroTypeCom:
                "Der offizielle Spectro-Treiber muss installiert sein. Achten Sie auf den verwendeten COM Port. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
            spectroTypeDataColorReader:
                "Der Computer muss Ã¼ber eine Bluetooth-Verbindung verfÃ¼gen und das Spectro muss mit dem Computer gekoppelt werden. Mindestvoraussetzung: Windows 10 mit Herbst Update 2018",
            spectroTypeMinolta2XXXd:
                "Der offizielle Spectro-Treiber muss installiert werden. Achten Sie auf den verwendeten COM Port. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
            spectroTypeNotSelected: "WÃ¤hlen Sie Ihr Spectro-Modell aus.",
            spectroTypeRM400: "Keine Treiber erforderlich",
            spectroTypeSimulation:
                "Laborwerte, die erforderlich sind, um Simulationsergebnisse zu erhalten. Sowohl fÃ¼r Windows als auch fÃ¼r Linux.",
            spectroTypeXRite: "Nur fÃ¼r Windows"
        },
        ufiCode: {
            baseUfiCodeValidation:
                "Der UFI-Code des Basengebindes muss Ã¼ber einen Barcode validiert werden, bevor die Dosierung erlaubt ist.",
            enableUfiCodes:
                "UFI-Codes werden in der EU verwendet und geben Auskunft darÃ¼ber, wie gefÃ¤hrlich ein Produkt fÃ¼r die Umwelt ist.",
            invalidUfi: "UngÃ¼ltiger UFI code",
            printUfiCode:
                "Wenn ein Pigment in einer Rezeptur den angegebenen Grenzwert Ã¼berschreitet, wird sein UFI-Code auf das Drucketikett gedruckt.",
            printUfiCodePercentage:
                "Wenn ein Pigment in einer Rezeptur den angegebenen Grenzwert Ã¼berschreitet, wird sein UFI-Code zusammen mit seiner prozentualen Darstellung auf das Drucketikett gedruckt.",
            ufiCodesByPercentage:
                "Der vorherrschende UFI-Code wird fÃ¼r den Druck unter BerÃ¼cksichtigung seiner tatsÃ¤chlichen Menge im Kanister verwendet. Navigieren Sie zu Kanistereinstellungen, um den Schwellenwert fÃ¼r jeden Kanister festzulegen.",
            ufiCodesFromDatabase:
                "Zum Drucken wird der vom Datenbankverwalter angegebene UFI-Code aus der Hauptdatenbank verwendet.",
            ufiCodesFromLastFilling:
                "Der UFI-Code der letzten NachfÃ¼llung, der vom Bediener angegeben wurde, wird fÃ¼r den Druck verwendet, unabhÃ¤ngig von der nachgefÃ¼llten Menge."
        },
        userManagement: {
            add: "Mit dieser Einstellung wird ein neuer Benutzer hinzugefÃ¼gt, der sich bei der Software anmelden kann. Dem Benutzer kann ein Barcode zugewiesen werden und er kann so eingestellt werden, dass er sich nach dem Start der Software automatisch anmeldet.",
            assignedGroups:
                "Hier wird festgelegt, zu welchen Benutzergruppen der Benutzer gehÃ¶rt. Verschiedene Benutzergruppen haben unterschiedliche Privilegien.",
            availableGroups:
                "Hier wird festgelegt, welche Benutzergruppen fÃ¼r den Benutzer zur VerfÃ¼gung stehen. Verschiedene Benutzergruppen haben unterschiedliche Privilegien.",
            loggedUserDelete: "Der aktuell angemeldete Benutzer kann nicht gelÃ¶scht werden."
        },
        visit: "oder besuchen Sie",
        visitNoLicense: "FÃ¼r mehr Informationen besuchen Sie bitte"
    },
    helpSettings: {
        customHelpLink: "Benutzerdefinierter Service-Center-Link",
        helpSettings: "Hilfe-Einstellungen",
        message: "Nachricht"
    },
    helper: {
        automaticallyCheckForUpdates: "Updates automatisch suchen",
        automaticallyDownloadUpdates: "Updates automatisch herunterladen",
        automaticallyInstallNewDatabases: "Neue Datenbank-Updates automatisch installieren",
        automaticallyInstallUpdates: "Updates automatisch installieren",
        bugReport: "Fehlerbericht",
        canBrowseChangeLog: "Online-Ãnderungsprotokoll von %{name} anzeigen.",
        collect: "AuswÃ¤hlen",
        collectLogFiles: "Log-Dateien sammeln und speichern",
        component: "Komponente",
        content: "Inhalt",
        contentSize: "GrÃ¶Ãe des Inhalts",
        download: "Download",
        downloadLogFiles: "Download log files",
        downloadingData: "Daten herunterladen",
        everyHours: "alle %{interval} Stunden",
        forceInstall: "Update erzwingen",
        installDuringNight: "In der Nacht (zwischen %{start} - %{end} Uhr) alle %{interval} Stunden",
        newVersion: "Neue Version",
        notConnected: "Helper ist nicht verbunden",
        openBugReport: "Fehlerbericht Ã¶ffnen",
        packageSize: "GebindegrÃ¶Ãe",
        pleaseWait: "Bitte wartenâ¦ Dieser Vorgang kann eine Zeitlang dauernâ¦",
        send: "Senden",
        sendBugReportToCustomerService: "Fehler-Report senden",
        sendingReport: "Wird gesendet",
        subject: "Betreff"
    },
    helperDialog: {
        1: "Sie kÃ¶nnen nach Software- oder Datenbank-Updates suchen.",
        2: "Mit dem Herunterladen des Updates fortfahren?",
        3: "Mit der Installation des heruntergeladenen Updates fortfahren?",
        10: "Suche nach Software- und Datenbank-Updates, bitte warten...",
        11: "Ein Update ist fÃ¼r ihren Computer verfÃ¼gbar. MÃ¶chten Sie sie herunterladen?",
        12: "Es sind keine Updates fÃ¼r Ihren Computer verfÃ¼gbar.",
        14: "Bei der Suche nach Updates ist ein Fehler aufgetreten. %{0}",
        15: "Datenbanken werden synchronisiert, bitte warten...",
        20: "Update wird heruntergeladen, bitte warten...",
        21: "Das heruntergeladene Update wird verifiziert, bitte warten.....",
        22: "Das Herunterladen des Updates ist fehlgeschlagen, mÃ¶chten Sie es erneut versuchen?",
        23: "Das Herunterladen des Updates ist fehlgeschlagen (Datei ist defekt), mÃ¶chten Sie es erneut versuchen?",
        24: "Mit der Installation des Updates fortfahren?",
        25: "Die automatische Installation des Updates beginnt in %{0}",
        26: "Es gibt ein Update fÃ¼r Ihren Computer. MÃ¶chten Sie das Update herunterladen?",
        27: "Mit der Installation des Updates fortfahren?",
        40: "Anwendungen und Dienste werden gestoppt, bitte warten...",
        41: "Neue Dateien werden kopiert, bitte warten...",
        42: "Anwendungen und Dienste werden gestartet, bitte warten...",
        43: "Fertigstellung des Software-Updates, bitte warten...",
        44: "Ihre Software wurde erfolgreich aktualisiert.",
        45: "MÃ¶chten Sie die Installation erneut versuchen?  SchlieÃen Sie bitte zuerst alle Software-Komponenten.",
        46: "Ein Neustart des Computers ist erforderlich, um das Update abzuschlieÃen, der Neustart wird in %{0} ausgefÃ¼hrt",
        999: "Es ist ein interner Fehler aufgetreten: %{0}",
        automaticInstallation: "Automatische Installation des Updates",
        btnAbort: "Abbrechen",
        btnCancel: "Abbrechen",
        btnCheckUpdate: "Nach Updates suchen",
        btnContinue: "Fortfahren",
        btnDownloadUpdate: "Update herunterladen",
        btnInstallUpdate: "Update installieren",
        btnOk: "OK",
        btnRetry: "Erneut versuchen",
        btnSkip: "Ãberspringen",
        checkingForUpdates: "Nach Updates suchen...",
        downloadingFailed: "Der Download ist fehlgeschlagen",
        downloadingPackage: "Update wird heruntergeladen, bitte warten...",
        finishingUpdate: "Update wird beendet",
        installingUpdate: "Update wird installiert",
        internalError: "Interner Fehler",
        rebootRequired: "Neustart (Reboot) erforderlich",
        startingComponents: "Starten der Software-Komponenten",
        stoppingComponents: "Stoppen der Software-Komponenten",
        synchronizingDatabases: "Synchronisieren der Datenbanken",
        updateAvailable: "Es sind Updates verfÃ¼gbar, bitte wÃ¤hlen Sie die zu aktualisierende Komponenten aus.",
        updateDownloaded: "Das Update wurde heruntergeladen",
        updateFailed: "Das Update ist fehlgeschlagen",
        updateInstalled: "Das Update wurde installiert",
        verificationFailed: "Verifizierung des Updates fehlgeschlagen",
        verifyingPackage: "Das heruntergeladenen Update wird verifiziert",
        yourSoftwareIsUpToDate: "Ihre Software ist aktuell.",
        yourSoftwareVersion: "Ihre Software-Version: %{0}"
    },
    importData: {
        abortImportingData: "Import wird abgebrochen",
        aborted: "Der Import wurde abgebrochen.",
        backupLocalDB: "Backup der local Datenbank",
        confirmRestore: "Wollen Sie wirklich alle lokalen Einstellungen wiederherstellen?",
        dataMissing: "Der Import ist fehlgeschlagen, weil die Quelldatei keine Daten enthielt.",
        deleteImportedData: "Importierte Daten lÃ¶schen",
        encodingFile: "Dateikodierung",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Der Import ist fehlgeschlagen, weil die Quelldatei beschÃ¤digt zu sein scheint.",
        fileMissing: "Der Import ist fehlgeschlagen, weil die Quelldatei nicht existiert.",
        format: "Format",
        formatPath: "Format-Pfad",
        headerMissing: "Der Import ist fehlgeschlagen, weil die Datei nicht komplett ist.",
        import: "Import",
        importAborted: "Import abgebrochen",
        importAborting: "Import wird abgebrochen",
        importFailed: "Der Import ist wegen eines unerwarteten Fehlers fehlgeschlagen.",
        importLocalSettings: "Local Settings importieren",
        importPrices: "Preise importieren",
        imported: "Import erfolgreich beendet.",
        importedWithErrors: "Der Import wurde mit Fehlern beendet. Die fehlerhaften DatensÃ¤tze wurden Ã¼bersprungen.",
        importing: "Import lÃ¤uftâ¦",
        noFormatAvailable: "Kein Format verfÃ¼gbar",
        processing: "Verarbeitung",
        processingCustomFormulas: "Eigene Rezepturen werden verarbeitet",
        processingCustomers: "Kunden werden verarbeitet",
        productsFile: "Produktdatei",
        restoreLocalSettings: "Locale Einstellungen wiederherstellen",
        underProgress: "Der Import lÃ¤uft...",
        unknownFormat: "Der Import ist fehlgeschlagen, weil die Quelldatei ein unbekanntes Format hat.",
        userFormulasFile: "Kundenrezepturen"
    },
    infoType: {
        baseDensity: "Dichte der Base",
        baseMass: "Masse der Base",
        baseUfiCode: "UFI-Code der Base",
        baseVolume: "Volumen der Base",
        batchNumbersTable: "Tabelle mit Chargennummern",
        bfsGrade: "BFS Klasse",
        colorLab: "LAB-Wert des Farbtons",
        colorRgb: "RGB-Wert des Farbtons",
        colorRgbHex: "RGB-Hex-Wert des Farbtons",
        colorXyz: "XYZ-Wert des Farbtons",
        colorantBatchNumbers: "Chargennummer des Pigmentkonzentrats",
        colorantMass: "Menge des Pigmentkonzentrats",
        colorantUfiCodes: "UFI-Codes der Pigmentkonzentrate",
        colorantVolume: "Volumen der Pigmentkonzentrate",
        formulaDate: "Rezeptur-Datum",
        formulaDatetime: "Rezeptur-Datum und Uhrzeit",
        formulaMoreInfo: "Weitere Informationen zur Rezeptur",
        formulaMoreInfoInternal: "Weitere interne Informationen zur Rezeptur",
        formulaMoreInfoPrint: "Weitere Informationen zur Rezeptur drucken",
        hbw: "HBW",
        isPackageGravimetric: "Gravimetrisches Gebinde",
        maxColorantMass: "Maximal erlaubte Pigmentmenge",
        maxColorantVolume: "Maximal erlaubtes Pigmentvolumen",
        nominalMass: "Nominale Menge des Gebindes",
        nominalVolume: "Nominales Volumen des Gebindes",
        overfillDetected: "ÃberfÃ¼llung festgestellt",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Gesamtmenge der Farbe",
        totalPaintVolume: "Gesamtvolumen der Farbe",
        ufiCodesTable: "UFI Code-Tabelle",
        verifiedFormula: "BestÃ¤tigte Rezeptur",
        yValue: "Y-Wert"
    },
    initialTab: {
        favoriteFormulas: "Favorisierte Rezepturen",
        lastDispensedFormulas: "Zuletzt dosierte Rezepturen",
        searchNewFormula: "Neue Rezeptur suchen"
    },
    invalidBatchNumbersModal: {
        header: "PrÃ¼fen der Pigment-Chargennummer",
        info: "Mindestens ein Kanister ist mit einer (mÃ¶glicherweise) fehlerhaften Farbstoffcharge gefÃ¼llt. Bitte verwenden Sie diese Charge nicht. Entleeren Sie den Kanister mit der Quick-Tint-Funktion.",
        unknownStatus: "Unbekannter Status der Charge"
    },
    keyWords: {
        action: "Aktion",
        add: "HinzufÃ¼gen",
        addition: "hinzufÃ¼gen",
        additional: "zusÃ¤tzlich",
        address: "Adresse",
        admin: "Admin",
        advanced: "Fortgeschrittene",
        after: "nach",
        afterDispensing: "nach Dosierung",
        alfa: "alfa",
        all: "alle",
        allow: "erlauben",
        alphabetically: "alphabetisch",
        amount: "Menge",
        api: "API",
        ask: "fragen",
        autocap: "Autocap",
        autotask: "Autotask",
        availablePrice: "verfÃ¼gbarer Preis",
        backup: "Backup",
        banner: "Banner",
        barcode: "Barcode",
        barcodes: "Barcodes",
        base: "Base",
        before: "bevor",
        begin: "beginnen",
        bfs: "BFS",
        bottom: "Unten",
        brand: "Brand",
        brush: "BÃ¼rste",
        bug: "Bug",
        button: "Button",
        buy: "kaufen",
        cC3: "cC3",
        cM: "cM",
        calibration: "Kalibrierung",
        can: "Gebinde",
        canHandling: "Handhabung von Gebinden",
        canister: "Kanister",
        canisterFilling: "Kanister fÃ¼llen",
        canisterLevels: "KanisterstÃ¤nde",
        canisters: "Kanister",
        cap: "Cap",
        center: "Mitte",
        centre: "Mittig",
        change: "wechseln",
        changelog: "Changelog/Ãnderungsprotokoll",
        channels: "Channels",
        check: "ÃberprÃ¼fen",
        chunk: "StÃ¼ck",
        chunks: "StÃ¼ckchen",
        city: "Stadt",
        clean: "SÃ¤ubern",
        cleaning: "reinigen",
        clientIdentifier: "Kundenidentifikation",
        close: "schlieÃen",
        closest: "am nÃ¤chsten",
        code: "Code",
        collect: "sammeln",
        color: "Farbton",
        colorLink3: "ColorLink3",
        colorPanel: "Farbpalette",
        colorReader: "ColorReader",
        colorant: "Pigmentkonzentrat",
        colorantConsumption: "Pigmentverbrauch",
        colorantPrice: "Prigmentpreis",
        colorants: "Pigmentkonzentrate",
        colorix: "Colorix",
        colour: "Farbe",
        communication: "Kommunikation",
        compare: "vergleichen",
        competitive: "wettbewerbsfÃ¤hig",
        computer: "Computer",
        config: "config",
        configuration: "Konfiguration",
        confirm: "bestÃ¤tigen",
        confirmation: "BestÃ¤tigung",
        connection: "Verbindung",
        contactPerson: "Kontaktperson",
        control: "Kontrolle",
        copies: "Kopien",
        corob: "Corob",
        cost: "Kosten",
        country: "Land",
        create: "erstellen",
        currency: "WÃ¤hrung",
        current: "aktuell",
        custom: "benutzerdefiniert",
        customers: "Kunden",
        daily: "tÃ¤glich",
        dark: "Dark",
        data: "Daten",
        database: "Datenbank",
        datacolor: "Datacolor",
        date: "Datum",
        decimals: "Dezimalen",
        default: "Standard",
        delay: "VerzÃ¶gerung",
        delete: "lÃ¶schen",
        deletion: "LÃ¶schung",
        deltaE: "Delta E",
        device: "GerÃ¤t",
        devices: "GerÃ¤te",
        diagnosticTile: "Diagnosekachel",
        dialog: "Dialog",
        direct: "direkt",
        disconnect: "Verbindung trennen",
        discount: "Rabatt",
        dispense: "dosieren",
        dispenser: "Dosierer",
        dispensing: "Dosierung",
        down: "herunter",
        download: "herunterladen",
        driver: "Treiber",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "bearbeiten",
        editor: "Editor",
        email: "email",
        error: "Fehler",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "Excel",
        expiration: "Ablauf",
        export: "Export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "FarbtonfÃ¤cher",
        fastFluid: "Fast & Fluid",
        file: "Datei",
        fill: "fÃ¼llen",
        fillToMax: "max. auffÃ¼llen",
        find: "finden",
        first: "erste",
        flex: "Flex",
        folder: "Ordner",
        formula: "Rezepturformel",
        formulas: "Rezepturformeln",
        from: "von",
        fts5: "fts5",
        fullScreen: "Vollbild",
        fullText: "Volltext",
        fulltext: "Volltext",
        g: "g",
        genericPricing: "allgemeine Preisgestaltung",
        hLD: "HLD",
        hard: "hart",
        hbw: "hbw",
        help: "Hilfe",
        helpCenter: "Hilfe-Center",
        hero: "Hero",
        history: "Historie",
        home: "Startseite",
        host: "Host",
        humidifier: "Humidifier",
        iDD: "IDD",
        identification: "Identifizierung",
        image: "Bild",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "Import",
        individually: "individuell",
        info: "Info",
        information: "Information",
        initial: "initial",
        initialization: "Initialisierung",
        initialize: "initialisieren",
        insert: "einfÃ¼gen",
        install: "installieren",
        intellyPurge: "Intelligente Reinigung",
        invalid: "ungÃ¼ltig",
        ipAddress: "IP-Adresse",
        italtinto: "Italtinto",
        items: "Artikel",
        keyboard: "Tastatur",
        kg: "kg",
        kiosk: "Kiosk",
        kioskMode: "Kiosk-Mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "Etikett",
        labels: "Etiketten",
        language: "Sprache",
        largo: "Largo",
        last: "zuletzt",
        lenteq: "Lenteq",
        levels: "Level",
        license: "Lizenz",
        light: "Light",
        limit: "Limit",
        link: "Link",
        linux: "Linux",
        load: "laden",
        lock: "sperren",
        logFiles: "Logfiles",
        logic: "Logik",
        logo: "Logo",
        lower: "unter",
        machine: "Maschine",
        machineConfiguration: "Maschinenkonfiguration",
        machineManagement: "Maschinenverwaltung",
        machineName: "Maschinenname",
        main: "Hauptseite",
        maintenance: "Wartung",
        manual: "Manuell",
        manualAddition: "manuelle Zugabe",
        manualDispensing: "manuelle Dosierung",
        manualScan: "manueller Scan",
        margins: "Spannen",
        markups: "AufschlÃ¤ge",
        mass: "Masse",
        match: "Match",
        measure: "messen",
        measurement: "Messung",
        measurementUnits: "MaÃeinheiten",
        melody: "Melodie",
        message: "Nachricht",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "Minuten",
        misura: "Misura",
        ml: "ml",
        mode: "Modus",
        model: "Modell",
        modification: "Ãnderung",
        modify: "Ã¤ndern",
        monthly: "monatlich",
        moreInfo: "mehr Infos",
        movableTable: "beweglicher Tisch",
        move: "bewegen",
        music: "music",
        myOrders: "meine AuftrÃ¤ge",
        name: "Name",
        naming: "Namensgebung",
        nano: "Nano",
        navigation: "Navigation",
        new: "neu",
        nextDriver: "NextDriver",
        night: "Nacht",
        nixPro: "Nix Pro",
        notes: "Anmerkungen",
        notification: "Benachrichtigung",
        number: "Nummer",
        off: "aus",
        open: "Ã¶ffnen",
        order: "Auftrag",
        ordering: "Bestellung",
        overfill: "ÃberfÃ¼llung",
        overview: "Ãbersicht",
        overwrite: "Ã¼berschreiben",
        own: "eigene",
        pCPDriver: "PCPDriver",
        package: "Gebinde",
        packagePrice: "Gebindepreis",
        packages: "Gebinde",
        panels: "Panel",
        parameter: "Parameter",
        path: "Pfad",
        pc: "PC",
        phone: "Telefon",
        phoneNumber: "Telefonnummer",
        picture: "Bild",
        place: "Ort",
        placement: "Platzierung",
        plug: "stecken",
        plugger: "Stecker",
        plugging: "Einstecken",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "Gegenwart",
        preview: "Vorschau",
        price: "Preis",
        priceExport: "Preis-Export",
        priceGroup: "Preisgruppe",
        priceImport: "Preis-Import",
        prices: "Preise",
        pricing: "Preisgestaltung",
        primaryCurrency: "HauptwÃ¤hrung",
        print: "drucken",
        printer: "Drucker",
        printing: "Drucken",
        problem: "Problem",
        product: "Produkt",
        productPrice: "Produktpreis",
        profiledValues: "profilierte Werte",
        punch: "Stanz",
        puncher: "Stanzer",
        punching: "Stanzen",
        purge: "Reinigung",
        purgeType: "Reinigungsart",
        purgeVolume: "Reinigungsmenge",
        quality: "QualitÃ¤t",
        quick: "schnell",
        quickTint: "schnelles Dosieren",
        rM: "RM",
        raise: "erhÃ¶hen",
        rcc: "rcc",
        reader: "LesegerÃ¤t",
        reboot: "Neustart",
        receive: "erhalten",
        recirculate: "zurÃ¼ckfÃ¼hren",
        recirculation: "RÃ¼ckfÃ¼hrung",
        redlike: "Redlike",
        refill: "NachfÃ¼llen",
        registration: "Anmeldung",
        regular: "regelmÃ¤Ãig",
        removal: "Umzug",
        remove: "entfernen",
        report: "Bericht",
        reset: "zurÃ¼cksetzen",
        resolution: "AuflÃ¶sung",
        restart: "Neustart",
        rgb: "RGB",
        rights: "Rechte",
        rounding: "Rundung",
        rules: "Regeln",
        sanTint: "SanTint",
        save: "speichern",
        scale: "Skala",
        scan: "scannen",
        scope: "Umfang",
        screen: "Bildschirm",
        screensaver: "Bildschirmschoner",
        search: "Suche",
        secondaryCurrency: "ZweitwÃ¤hrung",
        select: "AuswÃ¤hlen",
        selectedFormula: "AusgewÃ¤hlte Rezeptur",
        sell: "verkaufen",
        sensor: "Sensor",
        serialNumber: "Seriennummer",
        server: "Server",
        servers: "Server",
        service: "Dienstleistung",
        serviceAction: "Service-Aktion",
        serviceActions: "Service-Aktionen",
        serviceSoftware: "Service-Software",
        serviceWindow: "Service-Fenster",
        settings: "Einstellungen",
        shelf: "Reiter",
        shortcuts: "Shortcut",
        shot: "Shot",
        show: "Anzeigen",
        shutDown: "Herunterfahren",
        shutdown: "Herunterfahren",
        silent: "Versteckt",
        simple: "Einfach",
        simulation: "Simulation",
        size: "GrÃ¶Ãe",
        skip: "Ãberspringen",
        smartPurge: "Smart Purge",
        software: "Software",
        softwareSupplier: "Software-Anbieter",
        sort: "sortieren",
        sound: "Sound",
        spectro: "Spektro",
        spectrophotometer: "Spektralphotometer",
        speed: "Geschwindigkeit",
        split: "teilen",
        start: "Start",
        startup: "Startup",
        statistics: "Statistik",
        status: "Status",
        stir: "rÃ¼hren",
        stirring: "RÃ¼hren",
        street: "StraÃe",
        support: "Support",
        surcharge: "Aufpreis",
        tab: "Tab",
        tabs: "Tabs",
        task: "Aufgabe",
        template: "Vorlage",
        testing: "Testen",
        time: "Zeit",
        tintingManagementCenter: "Tinting Management Center",
        to: "zu",
        toDispense: "Zu dosierende AuftrÃ¤ge",
        tolerance: "Toleranz",
        top: "top",
        total: "insgesamt",
        translation: "Ãbersetzung",
        turnOff: "Ausschalten",
        turntable: "Drehkranz",
        type: "Typ",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "Enheit",
        up: "Oben",
        update: "Update",
        url: "URL",
        user: "Benutzer",
        userGroups: "Benutzergruppen",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "MwSt.",
        validate: "validieren",
        validation: "Validierung",
        version: "Version",
        virtual: "virtuell",
        volume: "Volume",
        weekly: "WÃ¶chentlich",
        window: "Fenster",
        windows: "Windows",
        with: "mit",
        without: "ohne",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "Y-Wert",
        zipCode: "PLZ",
        zoom: "Zoom"
    },
    languages: {
        bg: "Bulgrisch",
        cs: "Tschechisch",
        da: "DÃ¤nisch",
        de: "Deutsch",
        el: "Griechisch",
        en: "Englisch",
        es: "Spanisch",
        fr: "FranzÃ¶sisch",
        hr: "Ungarisch",
        hu: "Ungarisch",
        id: "Indonesisch",
        is: "IslÃ¤ndisch",
        it: "Italienisch",
        lt: "Litauisch",
        lv: "Lettisch",
        ms: "Malaiisch",
        nl: "HollÃ¤ndisch",
        no: "Norwegisch",
        pl: "Polnisch",
        pt: "Portugiesisch",
        ro: "RumÃ¤nisch",
        ru: "Russisch",
        sk: "Slovakisch",
        sr: "Serbisch",
        sv: "Schwedisch",
        zh: "Chinesisch"
    },
    license: {
        activateLicense: "Lizenz aktivieren",
        activateNewLicense: "Neue Lizenz aktivieren",
        checkLicenseKey: "LizenzschlÃ¼ssel Ã¼berprÃ¼fen",
        companyId: "Firmen-ID",
        contactPerson: "Ansprechpartner",
        copy: "Kopieren",
        country: "Land",
        emptyCity: "Die Stadt ist eine Pflichtangabe",
        emptyCountry: "Das Land ist eine Pflichtangabe",
        emptyName: "Das Name der Verkaufsstelle ist eine Pflichtangabe",
        enterIdentificationKeys: "Geben Sie Ihre IdentifikationsschlÃ¼ssel ein",
        expirationDate: "Verfallsdatum %{dateTime}",
        fillRegistration: "FÃ¼llen Sie bitte die Registrierungsdaten aus (scrollen Sie nach unten, um mehr zu sehen)",
        insertLicense: "Generierten SchlÃ¼ssel fÃ¼r Offline-Aktivierung einfÃ¼gen",
        invalidEmail: "Keine gÃ¼ltige Emailadresse",
        invalidPhone: "Keine gÃ¼ltige Telefonnummer",
        itemsMarkedasterisk: "(die mit einem Sternchen gekennzeichneten Felder mÃ¼ssen ausgefÃ¼llt werden.)",
        lastUpdate: "Letzte Ãnderung: %{dateTime}",
        leasedLicense: "Gemietete Lizenz",
        licenseActivated: "Lizenz freigeschaltet",
        licenseStatus: "Lizenzstatus",
        licenseWillExpire: "Ihre Lizenz lÃ¤uft in %{dayCount} Tagen ab",
        licenseWillExpireOneDay: "Ihre Lizenz lÃ¤uft in %{dayCount} Tag ab",
        machineInformation: "Machineninformation",
        noLicenseAvailable: "Keine Lizenz vorhanden",
        noProductsForKey: "FÃ¼r die genannten IdentifikationsschlÃ¼ssel gibt es keine Produkte.",
        pointOfSale: "Pont of Sale / Verkaufsstelle",
        producer: "Hersteller",
        reactivate: "Reaktivieren",
        reactivateLicense: "Reactivate license",
        region: "Region",
        registerLicense: "Bitte nehmen Sie eine Kopie der Aktivierungsanfrage und navigieren Sie zu:",
        registrationForm: "Registrierungsformular",
        selectProduct: "Produkt auswÃ¤hlen",
        serialNumber: "Seriennummer",
        skipNewLicense: "Wenn Sie die neue Lizenz spÃ¤ter aktivieren mÃ¶chten, kÃ¶nnen Sie auf Ãberspringen klicken.",
        unlimitedLicense: "Unbefristete Lizenz",
        userId: "Benutzer ID",
        uuid: "Lizenz UUID",
        versionDetails: "Versionsdetails",
        versionScope: "Versionsumfang",
        versionType: "Versiontyp",
        zip: "Postleitzahl"
    },
    login: {
        authenticate: "Authentifizierung",
        logIn: "Einloggen",
        loginAs: "Als anderer Benutzer anmelden",
        messages: {
            incorrectUsername: "Benutzername oder Passwort ist falsch."
        },
        password: "Passwort",
        username: "Benutzername"
    },
    machineActionHistory: {
        actionHistory: "Aktionshistorie"
    },
    machineErrors: {
        channel: "Kanal",
        code: "Code",
        machineErrors: "Maschinenfehler",
        noMachineErrors: "Es liegen derzeit keine Maschinenfehler vor",
        resetErrors: "Fehler zurÃ¼cksetzen"
    },
    machineSettings: {
        action: "Aktion",
        addAutotask: "Autotask hinzufÃ¼gen",
        autoCanisterIn: "Auto Kanister in",
        autoCanisterOut: "Auto Kanister auf",
        automaticRefill: "Automatisches NachfÃ¼llen",
        autotaskSettings: "Autotaskeinstellungen",
        backupConfiguration: "Machinenkonfiguration sichern",
        brushMaintenance: "BÃ¼rstenwartung",
        capMaintenance: "Deckelwartung",
        checkCanisterBeforeDispense: "ÃberprÃ¼fen Sie den Kanister vor der Dosierung",
        checkColorantBaseRules: "ÃberprÃ¼fen Sie die Regeln fÃ¼r Rezepturen mit Pigmenten",
        checkMinDosableAmount: "PrÃ¼fen Sie die minimale abtÃ¶nbare Menge an Pigmenten",
        checkOverfill: "ÃberfÃ¼llung des Gebindes prÃ¼fen",
        checkTotalCntAmounts: "PrÃ¼fen der Gesamtmenge der Farbstoffe fÃ¼r die Basisfarbe",
        cleanAll: "Alles reinigen",
        computerReboot: "Computer-Neustart",
        computerShutdown: "Computerabschaltung",
        connectMachine: "Maschine anschlieÃen",
        days: "Tage",
        daysOfMonth: "Monatstage",
        devices: "GerÃ¤te",
        disabled: "Deaktiviert",
        dispenseAndPurge: "Dosieren und spÃ¼len",
        dispenseOnly: "Nur dosieren",
        dispenserCleaning: "Machinereinigung",
        dispensingWithErrorsEnabled: "Dosierung trotz Validierungsfehlern zulassen",
        editAutotask: "Autotask bearbeiten",
        firstRun: "Erster Durchgang",
        hours: "Uhr",
        humidifier: "Befeuchter",
        humidifierWaterLevelMaintenance: "Wartung des Wasserniveaus des Befeuchters",
        machineConfigurationNoCanisters: "Die Maschinenkonfiguration enthÃ¤lt keine Kanister.",
        machineName: "Maschinenname",
        machineSettings: "Maschineneinstellungen",
        manualPuncher: "Manualler Stanzer",
        minDispensedAmount: "Minimale Abgabemenge",
        minutes: "Minuten",
        nextRun: "NÃ¤chster Lauf",
        noAutotasksSet: "Keine Autotask-Einstellungen gesetzt",
        noDataAvailable: "Keine Daten verfÃ¼gbar",
        noMachine: "Keine Maschine",
        onStart: "Beim Start",
        plugger: "Stromversorgung",
        postpone: "Verschieben",
        puncher: "Stanzer",
        purgeAll: "Alle spÃ¼len",
        purgeOnly: "Nur SÃ¤ubern",
        recirculateAll: "Alle umwÃ¤lzen",
        recirculateChannels: "KanÃ¤le umwÃ¤lzen",
        recirculationSpeed: "UmwÃ¤lzungsgeschwindigkeit",
        recirculationTime: "UmwÃ¤lzungszeit",
        refillAll: "Alle nachfÃ¼llen",
        refillCanisters: "Kanister nachfÃ¼llen",
        runAt: "Laufen um",
        runDefinedDaysAt: "Definierte Tage bei",
        runEvery: "Laufen jeden",
        runInDays: "Laufzeiten in Tagen",
        serialNum: "Seriennummer",
        settingsMachine: "Maschineneinstellung",
        smartPurgeAll: "smartPurge alle Kanister",
        smartPurgeChannels: "smartPurge einzelne Kanister",
        smartPurgeRules: "smartPurge Regeln",
        startType: "Starttyp",
        stirAll: "Alle rÃ¼hren",
        stirCanisters: "Kanister rÃ¼hren",
        stirringSpeed: "RÃ¼hrgeschwindigkeit",
        stirringTime: "RÃ¼hrzeit",
        switchPlateMaintenance: "Wartung der Platine",
        theCurrentlySelectedMachine: "Aktuell ausgewÃ¤hlte Maschine",
        threshold: "Schwellenwert",
        turntable: "Drehtisch",
        unifyColorantBatchForMultipleCans:
            "Vereinheitlichung der Pigmentkenzentratchargen fÃ¼r die Dosierung mehrerer Gebinde",
        volume: "Volumen",
        weekdays: "Wochentage"
    },
    mainTab: {
        acceptedFormula: "BestÃ¤tigte Rezeptur",
        addBuildingSite: "Add building site",
        addToFavorites: "Zu den Favoriten hinzufÃ¼gen",
        alternativeFormulas: "Alternative Rezepturen",
        alternativeValidFormulas: "ÃberprÃ¼fte alternative Rezepturen",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Ein oder mehrere Pigmentkonzentrate sind ungÃ¼ltig",
        dispensedPackages: "Dosierte Gebinde",
        dispensingInProgress: "Dosierung lÃ¤uft gerade",
        dispensingIsAborted: "Dosierung wird abgebrochen",
        dispensingIsNotAvailable: "Dosierung ist nicht mÃ¶glich",
        dispensingProgress: "%{done} von %{all}",
        editColorant: "Pigmentkonzentrate bearbeiten",
        editNote: "Anmerkung bearbeiten",
        findCompetitiveColor: "Versuchen einen Ã¤hnlichen Farbton zu finden",
        forceDispensing: "Aufwand fÃ¼r die Dosierung",
        formulaInvalidColorants: "Die Rezeptur enthÃ¤lt ungÃ¼ltige Pigmente: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Rezeptur-Eigenschaften",
        hiddenFandecks: "Ausgeblendete FarbtonfÃ¤cher",
        hiddenProducts: "Ausgeblendete Produkte",
        historicalFormulas: "Historische Dosierungen",
        lowerDeltaNumber: "Je geringer der dE-Wert, desto genauer die FarbtonÃ¼bereinstimmung",
        machineError: "Machinenfehler",
        machineIsBusy: "Machine ist beschÃ¤ftigt",
        machineNotConnected: "Maschine ist nicht angeschlossen",
        manualColorantAddition: "Manuelle Pigmentenzugabe",
        modifiedFormula: "Rezeptur wurde geÃ¤ndert",
        modifiedFormulaInLab: "Im Labor modifizierte Rezeptur",
        newColorAfterScaling: "Neuer Farbton nach Skalierung",
        newRgbNotAccuratelyMeasured: "Der neue RGB-Wert wird nicht gemessen, es ist nur ein Richtwert.",
        noBaseAvailable: "Keine Base verfÃ¼gbar",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "Keine zusÃ¤tzlichen Pigmentkonzentrate fÃ¼r die Korrektur ausgewÃ¤hlt",
        noColorants: "Keine Pigmentkonzentrate",
        noCustomer: "Kein Kunde ausgewÃ¤hlt",
        noCustomers: "Keine Kunden verfÃ¼gbar",
        noDispenseNotesAvailable: "Keine Anmerkungen zur Dosierung",
        noFormulaAvailable: "Sie haben eine Kombination gewÃ¤hlt, die keine Rezeptur enthÃ¤lt!",
        noFormulaSelected: "Keine Rezeptur ausgewÃ¤hlt",
        noInternalNotesAvailable: "Keine internen Anmerkungen",
        noNotesAvailable: "Keine Anmerkungen",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Kein Gebinde ausgewÃ¤hlt",
        noProductAvailable: "No product is available",
        noResultsFound: "Keine Ergebnisse gefunden",
        openLocalFile: "Aus lokaler Datenbank Ã¶ffnen",
        openOnlineFile: "Ãber das Internet Ã¶ffnen",
        order: "Bestellung",
        orderingIsNotAvailable: "Bestellung ist nicht mÃ¶glich",
        originalColor: "Original Farbton",
        overAvailableLevel: "Ãber den verfÃ¼gbaren Stand",
        package: "GebindegrÃ¶Ãe",
        packageIsRequired: "Gebinde wird benÃ¶tigt",
        packaging: "Verpackung",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Drucken ist nicht mÃ¶glich",
        productFiles: "Produktdateien",
        productFilesViewer: "Betrachter fÃ¼r Produktdateien",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Eigenschaften",
        regularPrice: "RegulÃ¤rer Preis",
        resetFormulaData: "Neue Rezeptur",
        rgbOnlyIndicative: "RGB ist nur ein Richtwert!",
        saveAsCustom: "Speichern als",
        saveToStatsIsNotAvailable: "Speichern in die Historie ist nicht mÃ¶glich",
        searchForCheaper: "Suche nach billigeren",
        selectFromCompetitive: "Sie kÃ¶nnen einen Farbton aus den anderen Farbkollektionen auswÃ¤hlen.",
        specialPrice: "Sonderpreis",
        specialPriceVip: "Sonderpreis VIP",
        splitFormula: "Rezeptur aufteilen",
        withVAT: "mit MwSt",
        withoutVAT: "ohne MwSt"
    },
    marginSettings: {
        allBases: "Alle Basen",
        allProducts: "Alle Produkte",
        editMargin: "Marge bearbeiten",
        marginAndDiscountWarning:
            "Sie mÃ¼ssen die Preisberechnungsoption fÃ¼r die Verwendung von Spannen und Rabatten einstellen.",
        marginSettings: "Margeeinstellungen",
        marginsFor: "Margen fÃ¼r",
        markupColorants: "Pigmentpreisaufschlag",
        sizeOfPackage: "GebindegrÃ¶Ãe",
        valueBase: "Wert Base",
        valueColorant: "Wert Pigment"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "Alle Korrekturen",
        allTillItems: "Alle bis hin zu den Korrekturen",
        auto: "Automatisch",
        autoSelectAll: "Automatisch alle",
        canStartCorrection: "Dann kÃ¶nnen Sie mit der Korrektur beginnen.",
        canStartMatching: "Dann kÃ¶nnen Sie mit der Messung beginnen.",
        cannotBeUsed: "Matching kann nicht verwendet werden.",
        changeProductAndColorants: "Versuchen Sie, das Produkt oder die Pigmente zu wechseln",
        checkConfig: "Bitte prÃ¼fen Sie die Matching-Konfiguration.",
        colorCorrection: "Farbkorrektur",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Pigmentkonzentrate in der dosierten Rezeptur",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Verbindungsproblem",
        correctionHistory: "Historie der Farbtonkorrekturen",
        correctionRunning: "Farbtonkorrektur lÃ¤uft",
        draftFormula: "Draft formula",
        exclude: "Ausgeschlossen",
        excludeAll: "Alle ausgeschlossen",
        include: "Enthalten",
        includeAll: "Alle enthaltenen",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Nur Teil",
        manualColorCorrection: "Manuelle Farbtonkorrektur",
        matchFormula: "Rezeptur messen",
        matchingInformation: "Matching-Info",
        matchingResult: "Matching-Ergebnis",
        matchingRunning: "Matching lÃ¤uft",
        matchingSearchOptions: "Matching Suchoptionen",
        measurement: "Messung",
        noCorrection: "Keine Korrektur gefunden",
        noSpectralCurveProvided:
            "Das angeschlossene GerÃ¤t kann nicht zur Messung verwendet werden, da es keine Spektralkurve liefert.",
        notAvailableForMatching: "Zur Farbtonmessung nicht verfÃ¼gbar",
        originalFormula: "Originalrezeptur",
        reformulate: "Neue berechnete Rezeptur",
        reformulationRunning: "Neuberechnung lÃ¤uft",
        resultColor: "Ergebnisfarbton",
        saveAsCustomFormula: "Als Eigenrezeptur speichern",
        searchInProgress: "Suche lÃ¤uft, bitte warten",
        selectColorfile: "Bitte Farbdatei auswÃ¤hlen.",
        selectRequiredItems: "Bitte wÃ¤hlen Sie das Produkt, die Base, Pigmente und die GebindegrÃ¶Ãe aus.",
        selectedResult: "AusgewÃ¤hltes Ergebnis",
        spectralDataNotAvailable: "Spektraldaten nicht verfÃ¼gbar",
        startCorrection: "Starte Korrektur",
        startMatching: "Starte Matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "FÃ¼r Matching verwendet"
    },
    modal: {
        changeColorantUnit: "Pigmenteneinheit Ã¤ndern",
        payAttention: "Vorsicht!"
    },
    module: {
        productGroups: "Produktgruppen"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Farbtonkollektion-Filter",
            formulasOverLimit:
                "Ãber %{count} Ergebnisse. Geben Sie bitte mehr Zeichen ein um das Suchergebnis einzugrenzen.",
            foundFormulas: " %{count} - Rezepturen gefunden",
            help: "Hilfe:",
            helpText:
                "Geben Sie z. '%{filter}', um nach Rezepturen zu suchen, die mit '%{formula}' beginnen, Produkt mit '%{product}' und Kollektionen '%{fandeck}'.",
            productFilter: "Produktfilter",
            searchInFormulas: "Suche in Rezepturen",
            typeMore: "Bitte geben Sie mehr Zeichen ein"
        },
        menu: {
            actionHistory: "Aktionshistorie",
            additionalFormulaTab: "Neuer Tab",
            advancedSettings: "Erweiterte Einstellungen",
            autotaskSettings: "Autotaskeinstellungen",
            availableDatabases: "VerfÃ¼gbare Datenbanken",
            availablePrices: "VerfÃ¼gbare Preise",
            bugReport: "Fehlerbericht",
            canisterBarcodes: "Kanister-Barcodes",
            canisterDispensingLogic: "Dosierlogik",
            canisterFilling: "KanisterfÃ¼llung",
            canisterSettings: "Kanister-Einstellungen",
            clientServerSettings: "Client/Server-Verbindung",
            closing: "SchlieÃen",
            color: "Farbton",
            colorModification: "Farbmodifikation",
            colorPanel: "Einstellungen der Farbpalette",
            colorRepresentation: "Anzeige Produkt- Bild & -Daten",
            colorSearch: "Farbtonsuche",
            colorant: "Pigment",
            colorantConsumption: "Pigment-Verbrauch",
            colorantPricing: "Pigmentenpreisgestaltung",
            colorantRefillHistory: "Pigment-NachfÃ¼ll-Historie",
            competitiveSearch: "KonkurrenzfÃ¤hige Farbsuche",
            connections: "Verbindungen",
            currency: "WÃ¤hrungseinstellungen",
            customData: "Benutzerdefinierte Daten",
            database: "Datenbank",
            databaseCheck: "Datenbank prÃ¼fen",
            databaseConnection: "Datenbankverbindung",
            defaultValues: "Standardwerte",
            devices: "GerÃ¤te",
            dispensingHistory: "Dosier-Historie",
            dispensingSettings: "Dosier-Einstellungen",
            driverSettings: "Treibereinstellungen",
            environment: "Anzeige",
            environmentConfiguration: "Anzeigeeinstellungen",
            environmentalSettings: "Umgebungseinstellungen",
            favorites: "Favoriten",
            fileTransfer: "File Transfer",
            formatting: "Formatierung",
            formula: "Formula",
            formulaData: "Rezepturdaten",
            formulaModification: "Formula modification",
            formulaPanels: "Rezepturfenster",
            formulaSettings: "Rezeptureinstellungen",
            formulaUnit: "Rezeptureinheit",
            generalSearch: "Allgemeine Suche",
            globalSettingsSearch: "Direktzugriff auf Einstellungen",
            helpItems: "Hilfe-Einstellung",
            importAndExport: "Import und Export",
            importAndExportData: "Import von eigenen Daten",
            importCustomData: "Datenimport",
            initialFormulaTab: "Standard-Tab",
            interfaceSettings: "Anzeige-Einstellungen",
            keyboardShortcuts: "Tastenkombinationen",
            language: "Sprache",
            languageSettings: "Sprach-Einstellungen",
            layout: "Layout",
            license: "Lizenz",
            licenseData: "Lizenz-Daten",
            licenseIdentification: "Lizenz-Identifikation",
            licenseStatus: "Lizenzstatus",
            licenseSupplier: "Lizenzgeber",
            licenseVersion: "Lizenz-Version",
            localData: "Lokale Daten",
            machine: "Maschineninfo",
            machineActions: "Maschinenaktionen",
            machineAndDevices: "Maschine & GerÃ¤te",
            machineManagement: "Maschinen-Management",
            machineSettings: "Maschinen-Einstellungen",
            mainSettings: "Haupt-Einstellungen",
            maintenance: "Machinen-Wartung",
            marginAndDiscount: "Marge und Rabatt",
            matchingSearchResult: "Ãbereinstimmende Suchergebnisse",
            matchingSettings: "Einstellungen fÃ¼r Matching",
            navigationItems: "Navigationselemente",
            newFormulaWindow: "Rezeptur",
            orderSearch: "Auftragssuche",
            orderSettings: "Order-Systemeinstellungen",
            packageSurcharge: "Gebinde-Aufschlag",
            popUps: "Pop-Up-Fenster",
            posInfo: "POS Information",
            price: "Preiseinstellungen",
            priceManagement: "Preisverwaltung",
            priceSettings: "Preis-Einstellungen",
            pricingOptions: "Optionen Preisgestaltung",
            printSettings: "Drucker-Einstellungen",
            productPricing: "Produktpreisgestaltung",
            qualityControlSettings: "QualitÃ¤tskontrolle-Einstellungen",
            quickTint: "Manuelle Dosierung",
            rccConfig: "RCC-Einstellungen",
            rccConnection: "RCC-Verbindung",
            rccSettings: "RCC-Einstellungen",
            refillSettings: "PastennachfÃ¼ll-Einstellungen",
            refillingLogic: "NachfÃ¼lllogik",
            registration: "Registrierung",
            searchSettings: "Sucheinstellungen",
            serverPlugins: "Server Plugins",
            serviceActions: "Serviceaktionen",
            settings: "Einstellungen",
            simplifiers: "Direkte AuswahlmÃ¶glichkeiten",
            singleActions: "Einzelne EinstellmÃ¶glichkeiten",
            smartPurgeRules: "Intelligente SpÃ¼lregeln",
            softwareOptions: "Software-Einstellungen",
            spectroSettings: "Spectroeinstellungen",
            statistics: "Statistik",
            switchToFrontdesk: "Zum Frontdesk wechseln",
            switchToFullRedlike: "Zum %{name} wechseln",
            switchToLight: "Zum %{name} wechseln",
            switchToMachine: "Zu der Maschine wechseln",
            tabs: "Tabs & Pop-Up-Fenster",
            testBarcodes: "Barcodes-Test",
            updateOptions: "Update-Einstellungen",
            userManagemenet: "Benutzer-Einstellungen",
            visibleUnits: "Sichtbare Anzeigen"
        },
        navBar: {
            barcode: "Barcode",
            help: "Hilfe",
            hideItems: "Anzeige von Produkten / FarbtonfÃ¤cher aktivieren oder deaktivieren"
        },
        notificationPanel: {
            noNotifications: "Keine neuen Benachrichtigungen"
        },
        tabBar: {
            closeActive: "Aktive Karte schlieÃen",
            closeAll: "Alle Karten schlieÃen",
            closeAllExceptActive: "Alle auÃer der Aktiven schlieÃen",
            customFormula: "Custom Formula",
            dispensingHistory: "Dispenshistorie",
            favorites: "Favoriten",
            formulaSearch: "Rezeptursuche",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Zuweisen",
        assignment: "Zuweisung",
        createdDate: "Erstelldatum",
        finishDispensing: "Dosierung beenden",
        foundInOrders: "In AuftrÃ¤gen gefunden",
        inactiveDatabase: "Die Rezeptur stammt aus einer inaktiven oder unbekannten Datenbank %{0}",
        inactiveUnknownDatabase: "Die Rezeptur stammt aus einer inaktiven oder unbekannten Datenbank",
        newOrderReceived: "Sie haben einen neuen Auftrag erhalten!",
        noOrderSelected: "Kein Auftrag ausgewÃ¤hlt",
        release: "Freigeben",
        status: {
            accepted: "Akzeptiert",
            canceled: "Abgebrochen",
            created: "Erstellt",
            done: "Fertig",
            partlyDone: "teilweise erledigt",
            preparing: "wird vorbereitet",
            unknown: "unbekannt"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion:
            "Teilweise Rezepturupdates kÃ¶nnen fÃ¼r diese Datenbank nicht benutzt werden. Bitte aktualisieren Sie die komplette Datenbank Ã¼ber die Update-Funktion im Helper.",
        newVersionWillBeInstalled:
            "Es wird die neue Datenbankversion einschlieÃlich aller verfÃ¼gbaren Teil-Rezepturupdates installiert.",
        noPartialUpdatesAvailable: "Keine teilweisen Rezepturupdates (Partial Updates) verfÃ¼gbar",
        outOfDate: "veraltet!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Teil-Rezepturupdates (Partial Updates) sind verfÃ¼gbar!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "SpÃ¤ter erneut erinnern (nach %{time} Minuten)",
        swOutOfDate: "Die aktuelle Version der Software lautet",
        updateAutomatically: "Wenn Sie nicht antworten, wird die Aktualisierung automatisch durchgefÃ¼hrt in: %{time} s",
        updateToNewVersion: "Update auf die neueste Version",
        updateWillTakeMoreTime: "Das Update wird mehr Zeit in Anspruch nehmen.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Update lÃ¤uft"
    },
    posInfo: {
        address: "Adresse",
        contactName: "Name des Kontakts",
        contactPerson: "Ansprechpartner",
        identification: "Identifikation",
        machineInformation: "Maschine-Information",
        pos: "Verkaufsstelle (POS)",
        secondAddress: "Alternative Adresse",
        shopIdentification: "Verkaufsstelle-Identifikation",
        shopName: "GeschÃ¤ftsname",
        url: "URL",
        zipCode: "Postleitzahl"
    },
    priceTypeList: {
        priceBasePurchase: "Kaufpreis Base",
        priceBaseSell: "Verkaufspreis der Base",
        priceBaseSellFull: "Kompletter Verkaufspreis der Base",
        priceCntPurchase: "Kaufpreis fÃ¼r Pigmente",
        priceCntPurchaseByColorantName: "Kaufpreis fÃ¼r Pigment %{0}",
        priceCntPurchaseByName: "Kaufpreis fÃ¼r Pigmente nach Name",
        priceCntSell: "Verkaufspreis fÃ¼r Pigmente",
        priceCntSellByColorantName: "Verkaufspreis fÃ¼r Pigment %{0}",
        priceCntSellByName: "Verkaufspreis fÃ¼r Pigmentes nach Name",
        priceCntSellFull: "Verkaufspreis fÃ¼r die Pasten",
        priceCntSellFullByColorantName: "Verkaufspreis fÃ¼r die %{0} Paste",
        priceCntSellFullByName: "Verkaufspreis fÃ¼r die Paste nach Name",
        priceGroupBarcode: "Barcode fÃ¼r Preisgruppen",
        priceMarginAll: "Marge fÃ¼r alle Gebinde",
        priceMarginPerPkg: "Marge fÃ¼r ein Gebinde",
        priceSellPriceAll: "Verkaufspreis fÃ¼r alle Gebinde",
        priceSellPricePerKg: "Verkaufspreis pro Kilogramm",
        priceSellPricePerL: "Verkaufspreis pro Liter",
        priceSellPricePerPkg: "Verkaufspreis fÃ¼r ein Gebinde",
        priceSurchargeAll: "Zuschlag fÃ¼r alle Gebinde",
        priceSurchargePerPkg: "Zuschlag fÃ¼r eine Gebinde",
        priceTintPurchaseAll: "TÃ¶nungskaufpreis fÃ¼r alle Gebinde",
        priceTintPurchasePerPkg: "TÃ¶nungskaufpreis fÃ¼r ein Gebinde",
        priceTintSellFullAll: "Verkaufspreis der Dosierung alller Gebinde",
        priceTintSellFullAllPerPackage: "Verkaufspreis der Dosierung pro Gebinde",
        priceTotalPurchaseAll: "Gesamtkaufpreis fÃ¼r alle Gebinde",
        priceTotalPurchasePerKg: "Gesamtkaufpreis pro Kilogramm",
        priceTotalPurchasePerL: "Gesamtkaufpreis pro Liter",
        priceTotalPurchasePerPkg: "Gesamtkaufspreis fÃ¼r ein Gebinde",
        priceTotalSellFullAll: "Voller Verkaufspreis fÃ¼r alle Gebinde",
        priceTotalSellFullPerKg: "Gesamtverkaufspreis pro Kilogramm",
        priceTotalSellFullPerLiter: "Gesamtverkaufspreis pro Liter",
        priceTotalSellFullPerPackage: "Gesamtverkaufspreis pro Gebinde"
    },
    pricing: {
        allBases: "Alle Basen",
        allPackages: "Alle Gebinde",
        backup: "Backup der Preise",
        basesOfProduct: "Base von %{productName}",
        colorantPricing: "Pigmentpreisaufschlag",
        export: "Export",
        import: "Import",
        packagePricing: "Gebindepreisgestaltung",
        packageSurcharge: "Gebindezuschlag",
        packages: "Gebinde",
        packagesOfProduct: "Gebinde von %{productName}",
        posCoeficient: "Preisaufschlag/Preisnachlass fÃ¼r POS ",
        priceGroupPricePerLiter: "Preisgruppe - Preis pro Liter",
        priceGroups: "Preisgruppen",
        pricePerLiter: "Preis pro Liter",
        productPricing: "Produktpreisgestaltung",
        purchasePrice: "Einkaufpreis",
        purchasePricePerLiter: "Einkaufpreis pro Liter",
        sellPrice: "Verkaufspreis",
        surcharge: "Zuschlag"
    },
    print: {
        adminRightsRequired: "Zum Bearbeiten oder Erstellen einer neuen Vorlage sind Administratorrechte erforderlich.",
        allowAutomaticPrint: "Automatischer Druck",
        allowPrintAfterDispensing: "Druck nach der Dosierung",
        allowPrintBeforeDispensing: "Druck vor der Dosierung",
        automaticPrint: "Automatisch drucken",
        choosePrinter: "Drucker auswÃ¤hlen",
        chooseSettings: "Einstellungen bearbeiten",
        chooseTemplate: "Druckvorlage auswÃ¤hlen",
        copies: "Kopien",
        createTemplate: "Vorlage erstellen",
        createTemplateHint:
            "Erstellen Sie eine komplett neue Vorlage. Speichern Sie diese im Vorlagenordner und starten Sie RCC neu.",
        defaultPrinter: "Standard-Drucker",
        defaultSettings: "Standard-Einstellungen",
        defaultTemplate: "Standard-Etikett",
        editTemplate: "Vorlage bearbeiten",
        editTemplateHint: "%{name} bearbeiten. Die Ãnderungen werden nach dem Neustart des RCC sichtbar.",
        noEditTemplate: "Keine Vorlage zu bearbeiten",
        noPrinterSelected: "Kein Drucker ausgewÃ¤hlt",
        noPrintersAvailable: "Kein Drucker verfÃ¼gbar",
        noTemplateSelected: "Keine Vorlage ausgewÃ¤hlt",
        noTemplatesAvailable: "Keine Vorlage verfÃ¼gbar",
        numberOfCopies: "Anzahl der Kopien",
        openTemplateEditor: "Etikett bearbeiten (Editor Ã¶ffnen)",
        printAfterDispensing: "Druck nach Dosierung",
        printAsImage: "Druck als Image",
        printBeforeDispensing: "Druck vor der Dosierung",
        printOnRequest: "Druck auf Anfrage",
        printOptions: "Druck-Optionen",
        printPagesAfterDispensing: "Anzahl der Kopien des Etiketts",
        printPagesBeforeDispensing: "Anzahl der Kopien des Etiketts",
        printPreview: "Druckvorschau",
        printSettings: "Druckeinstellungen",
        printTaskLinkVariable: "Link zu einer Variablen",
        printVariable: "Variable drucken",
        printerName: "Druckername",
        printerOptions: "DruckmÃ¶glichkeiten",
        printerSettings: "Druckeinstellungen",
        quickTintTemplate: "Druckvorlage fÃ¼r manuelle Dosierung",
        setDefaultPrinter: "Standarddrucker einstellen",
        setDefaultTemplate: "Standard Druckvorlage einstellen",
        setQuickTintTemplate: "Druckvorlage fÃ¼r manuelle Dosierung festlegen",
        showPreviewDialogBeforePrint: "Vorschaudialog vor dem Druck anzeigen",
        template: "Druckvorlage",
        templateName: "Name der Druckvorlage",
        templateSettings: "Einstellungen der Druckvorlage"
    },
    printTemplate: {
        baseCode: "Code der Base",
        baseName: "Name der Base",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Ort (Kunde)",
        customerEmail: "Mailadresse (Kunde)",
        customerName: "Name (Kunde)",
        customerPhone: "Telefonnummer (Kunde)",
        customerStreet: "StraÃe (Kunde)",
        customerZipCode: "PLZ (Kunde)",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS",
        orderQrCode: "QR-Code",
        packageOrderCount: "Anzahl der Gebinde",
        posAddress: "Adresse des POS",
        posAddressSecond: "Zusatz zur Adresse des POS",
        posCity: "Stadt des POS",
        posContact: "Kontakt im POS",
        posEmail: "Emailadresse des POS",
        posPhone: "Telefonnummer des POS",
        posUrl: "Internet-Adresse des POS",
        posZipCode: "PLZ des POS",
        priceBasePurchaseWithTax: "Einkaufspreis der Base (incl. MwSt.)",
        priceBaseSellWithTax: "Verkaufspreis der Base (incl. MwSt.)",
        priceCntPurchaseWithTax: "Einkaufpreis der Pigmente (incl. MwSt.)",
        priceCntTotalSellWithTax: "Verkaufspreis der Pigmente (incl. MwSt.)",
        priceMarginAllWithTax: "Marge fÃ¼r alle Gebinde (incl. MwSt.)",
        priceMarginPerPkgWithTax: "Marge pro Gebinde (incl. MwSt.)",
        priceSellPriceAllWithTax: "Verkaufspreis aller Gebinde (incl. MwSt.)",
        priceSellPricePerKgWithTax: "Verkaufspreis pro KG (incl. MwSt.)",
        priceSellPricePerLWithTax: "Verkaufspreis pro Liter (incl. MwSt.)",
        priceSellPricePerPkgWithTax: "Verkaufspreis pro Gebinde (incl. MwSt.)",
        priceSurchargeAllWithTax: "Aufpreis fÃ¼r alle Gebinde (incl. MwSt.)",
        priceSurchargePerPkgWithTax: "Aufpreis pro Gebinde (incl. MwSt.)",
        priceTintPurchaseAllWithTax: "Verkaufspreis der AbtÃ¶nung fÃ¼r alle Gebinde (incl. MwSt.)",
        priceTintPurchasePerPkgWithTax: "Verkaufspreis der AbtÃ¶nung pro Gebinde (incl. MwSt.)",
        priceTotalPurchaseAllWithTax: "Gesamtpreis fÃ¼r alle Gebinde (incl. MwSt.)",
        priceTotalPurchasePerKgWithTax: "Gesamtpreis pro KG (incl. MwSt.)",
        priceTotalPurchasePerLWithTax: "Gesamtpreis pro L (incl. MwSt.)",
        priceTotalPurchasePerPkgWithTax: "Gesamtpreis pro Gebinde (incl. MwSt.)",
        productAltName: "Alternativer Produktname",
        recipeInline: "Rezeptur"
    },
    products: {
        bases: "Basen",
        numberOfProducts: "Anzahl der Produkte",
        packagesFor: "fÃ¼r folgende Gebinde",
        sizeOfPackage: "GebindegrÃ¶Ãe"
    },
    purgeModal: {
        purgeAll: "Alle DÃ¼sen reinigen",
        purgeAllChannels: "Alle Kanister reinigen",
        purgeVolume: "Reinigungsvolumen",
        startPurge: "DÃ¼senreinigung starten"
    },
    qualityControl: {
        darker: "Dunkler",
        dispensedMeasuredFormula: "Dosierte (gemessene) Rezeptur",
        lighter: "Heller",
        measureDispensedFormula: "Messung der dosierten Rezeptur zur Berechnung des delta E",
        moreBlue: "Mehr blau",
        moreGreen: "Mehr grÃ¼n",
        moreRed: "Mehr rot",
        moreYellow: "Mehr gelb",
        pleaseContinueToFormulaCorrection: "Bitte fahren Sie fort mit der Rezeptur-Korrektur",
        qualityControlFailed: "QualitÃ¤tskontrolle fehlgeschlagen!",
        qualityControlPassed: "QualitÃ¤tskontrolle erfolgreich"
    },
    quickTint: {
        dispensingInProgress: "Maschine ist gerade am dosieren",
        dispensingIsNotAvailable: "Dosierung ist nicht mÃ¶glich",
        machineNotConnected: "Maschine ist nicht angeschlossen",
        noColorantsSelected: "Es wurden keine Pigmentkonzentrate ausgewÃ¤hlt",
        noPrinterAvailable: "Druck kann nicht ausgefÃ¼hrt werden, da kein Drucker zur VerfÃ¼gung steht.",
        noTemplateAvailable: "Druck kann nicht ausgefÃ¼hrt werden, da keine Vorlage zur VerfÃ¼gung steht.",
        overMaxCanisterSize: "Ein oder mehrere Pigmentkonzentratmengen sind ungÃ¼ltig"
    },
    quickTintSettings: {
        alphabetically: "Alphabetisch",
        byCanister: "Nach Kanister",
        closeAfterDispensing: "Nach der Dosierung schlieÃen",
        closeBeforeDispensing: "Vor der Dosierung schlieÃen",
        quickTintSettings: "Einstellungen fÃ¼r mauelle Dosierung",
        sorting: "Sortierung",
        windowClosingRules: "Regeln zum SchlieÃen der Fenster"
    },
    rccButtons: {
        abort: "abbrechen",
        all: "alle",
        cancel: "abbrechen",
        continue: "fortsetzen",
        help: "Hilfe",
        ignore: "ignorieren",
        no: "nein",
        noToAll: "nicht alle",
        ok: "ok",
        postpone: "verschieben",
        resume: "fortfahren",
        retry: "erneut versuchen",
        skip: "Ã¼berspringen",
        yes: "ja",
        yesToAll: "Ja zu allem"
    },
    rccDialog: {
        98: "Bitte bestÃ¤tigen Sie die Base %{0} mit dem Barcode.",
        99: "Bitte stellen Sie die Base %{0} unter und bestÃ¤tigen Sie mit OK",
        100: "An der Mischanlage sind Fehler aufgetreten. MÃ¶chten Sie diese Fehler nun zurÃ¼cksetzen?",
        101: "An der Mischanlage sind Fehler aufgetreten, daher kann diese Aktion nicht ausgefÃ¼hrt werden.",
        102: "Reset fehlgeschlagen, die Aktion kann nicht fortgesetzt werden",
        103: "Die Rezeptur enthÃ¤lt ungÃ¼ltiges Pigment: %{0}",
        104: "Die Rezeptur enthÃ¤lt ungÃ¼ltige Pigmente: %{0}",
        105: "Pigment: %{0} ist unter dem Warn-FÃ¼llstand",
        106: "Pigmente: %{0} sind unter dem Warn-FÃ¼llstand",
        107: "Pigment: %{0} ist unter kritischem FÃ¼llstand",
        108: "Pigmente: %{0} sind unter kritischem FÃ¼llstand",
        109: "Gebinde platzieren",
        110: "Bitte stellen Sie das Produkt %{0} unter um folgende Rezeptur zu dosieren: %{1}",
        111: "Bitte entfernen Sie das Gebinde.",
        112: "Gebinde stanzen?",
        113: "Fehler werden zurÃ¼ckgesetzt, bitte warten",
        114: "Der Gebindetisch bewegt sich, bitte warten Sie",
        115: "Das Gebinde wird gelocht, bitte warten Sie",
        116: "Die Rezeptur fÃ¼r den Farbton %{0} wird dosiert, bitte warten | Gebinde: %{1} von %{2} | Produkt: %{3} | Basis: %{4} | GebindegrÃ¶Ãe: %{5}",
        117: "Dosiert wird %{0}, bitte warten | Gebinde: %{1} von %{2} | Produkt: %{3} | Basis: %{4} | GebindegrÃ¶Ãe: %{5}",
        118: "Dosierung, bitte warten | Gebinde: %{0} von %{1}",
        119: "Dosierung, bitte warten | Gebinde: %{0} von %{1}",
        120: "Dosierung wurde abgebrochen, bitte warten",
        121: "BestÃ¤tigen Sie den Barcode des Gebindes",
        122: "BestÃ¤tigen Sie den Barcode von | Produkt: %{0} | Basis: %{1} | GebindegrÃ¶Ãe: %{2}",
        123: "Die Dosierung wurde abgebrochen. MÃ¶chten Sie die Dosierung fortsetzen?",
        124: "Dispenser-Fehler aufgetreten %{0}: %{1}. MÃ¶chten Sie den Dosiervorgang fortsetzen?",
        125: "Stellen Sie sicher, dass das zuvor verwendete Gebinde platziert ist",
        126: "Stellen Sie sicher, dass Sie ein neues Gebinde verwenden, da die komplette Dosierung von vorne beginnt.",
        127: "Pigment: %{0} ist unter der minimalen Dosiermenge. MÃ¶chten Sie trotz dieser Warnung mit der Dosierung fortfahren? ",
        128: "Pigmente: %{0} sind unter der minimalen Dosiermenge. MÃ¶chten Sie trotz dieser Warnung mit der Dosierung fortfahren?",
        129: "Die ausgewÃ¤hlte Rezeptur verhindert die ÃberfÃ¼llungsregel, Gesamtmenge der Pigmente: %{0} %{1}, maximal zulÃ¤ssige Mengen von Pigmente: %{2} %{3}. MÃ¶chten Sie trotz dieser Warnung mit der Dosierung fortfahren?",
        130: "Der Dispenser hat einen Fehler gemeldet, soll der Fehler zurÃ¼ckgesetz werden ?",
        131: "Der Dispenser hat einen Fehler gemeldet. Der Vorgang kann nicht fortgesetzt werden",
        132: "Reset fehlgeschlagen, die Aktion kann nicht fortgesetzt werden",
        133: "Reinigungsmenge zu niedrig - die Aktion kann nicht fortgesetzt werden",
        134: "Die Reinigungsmenge enthÃ¤lt Elemente, die nicht gereinigt werden kÃ¶nnen. MÃ¶chten Sie trotzdem fortfahren?",
        135: "Bitte platzieren Sie ein Gebinde zur Reinigung",
        136: "Gebinde nach Reinigung entfernen",
        137: "Fehler werden zurÃ¼ckgesetzt, bitte warten",
        138: "Der Gebindetisch bewegt sich, bitte warten",
        139: "DÃ¼senreinigung wird durchgefÃ¼hrt, bitte warten",
        140: "DÃ¼senreinigung wird durchgefÃ¼hrt, bitte warten",
        141: "Die Reinigung wird abgebrochen, bitte warten",
        142: "Gebinde fÃ¼r die Renigung wurde nicht erkannt - bitte prÃ¼fen Sie, ob die Dose richtig platziert ist.",
        143: "Die Reinigungsmenge enthÃ¤lt Elemente, die nicht gereinigt werden kÃ¶nnen. MÃ¶chten Sie trotzdem fortfahren?",
        144: "Gebinde fÃ¼r die DÃ¼senrenigung unterstellen",
        145: "Wird vorbereitet, bitte warten",
        146: "Wird beendet, bitte warten",
        150: "Reinigung lÃ¤uft, bitte warten Sie",
        151: "Reinigung lÃ¤uft, bitte warten Sie",
        152: "Reinigung abbrechen, bitte warten",
        160: "Rezirkulieren, bitte warten",
        161: "Rezirkulieren, bitte warten",
        162: "Rezirkulation abbrechen, bitte warten",
        170: "Pigmentkonzentrate werden gerÃ¼hrt, bitte warten",
        171: "Pigmentkonzentrate werden gerÃ¼hrt, bitte warten",
        172: "RÃ¼hren wird abgebrochen, bitte warten",
        180: "Die Verbindung zum Dispenser wird initialisiert, bitte warten",
        181: "Die Verbindung zum Dispenser kann nicht hergestellt werden %{0}: %{1}",
        182: "Es kann keine Verbindung zum Dispenser hergestellt werden. Weitere Informationen finden Sie in den Log-Files.",
        183: "Der Dispenser enthÃ¤lt kein Pigment: %{0}, das in der Datenbank definiert ist",
        184: "Der Dispenser enthÃ¤lt keine Pigmente: %{0}, die in der Datenbank definiert sind",
        185: "Die Verbindung zum Dispenser wird getrennt, bitte warten",
        190: "Um fortzufahren schlieÃen Sie bitte das Servicefenster",
        200: "Es wird ein Reset durchgefÃ¼hrt, bitte warten",
        201: "Hard Resetting, bitte warten",
        202: "Initialisierung, bitte warten",
        203: "Fehler werden zurÃ¼ckgesetzt, bitte warten",
        205: "Autocap wird geÃ¶ffnet, bitte warten",
        206: "Autocap wird geschlossen, bitte warten",
        207: "Autocap bewegt sich, bitte warten",
        210: "Die Dose wird gelocht, bitte warten",
        211: "AnschlieÃen, bitte warten",
        215: "Gebindetisch fÃ¤hrt nach oben, bitte warten",
        216: "Gebindetisch fÃ¤hrt herunter, bitte warten",
        217: "Gebindetisch bewegt sich, bitte warten",
        220: "Drehtisch bewegt sich zur NachfÃ¼llposition: %{0}, bitte warten",
        221: "Drehtisch bewegt sich zur Home-Position, bitte warten",
        222: "Drehtisch bewegt sich, bitte warten warten",
        230: "Der Dispenser ist beschÃ¤ftigt, bitte warten",
        240: "Bitte Kanister %{0} auffÃ¼llen",
        241: "Bitte Kanister nachfÃ¼llen %{0}",
        242: "Positionierung des Kanisters: %{0} (%{1}) zur NachfÃ¼llposition",
        243: "Bitte, fÃ¼llen Sie den Kanister %{0} mit der Hilfe des Barcodes auf",
        244: "Bitte, fÃ¼llen Sie den Kanister %{0} mit der Hilfe des Barcodes auf",
        250: "Entfernen Sie den BÃ¼rstenbehÃ¤lter, reinigen Sie ihn und fÃ¼llen Sie ihn mit Wasser gemÃ¤Ã den Anweisungen.",
        251: "BÃ¼rstenbehÃ¤lter wieder einsetzen",
        254: "Deckel wird geÃ¶ffnet",
        255: "Reinigen Sie den Deckel gemÃ¤Ã den Anweisungen.",
        256: "ÃberprÃ¼fen Sie, ob die Reinigung abgeschlossen ist und der Deckel wieder an ihrem Platz ist.",
        257: "Deckel wird geschlossen",
        260: "Schalterplatte entfernen und reinigen",
        261: "Schalterplatte wieder einsetzen",
        265: "Reinigen Sie die Maschine mit einem Tuch und entfernen Sie alle verschÃ¼tteten Pigmenten oder anderen FlÃ¼ssigkeiten.",
        266: "BestÃ¤tigen Sie, wenn Sie fertig sind",
        270: "FÃ¼llen Sie den WasserbehÃ¤lter des Befeuchters nach und bestÃ¤tigen Sie, wenn Sie fertig sind.",
        271: "FÃ¼llen Sie den WasserbehÃ¤lter des Befeuchters nach und bestÃ¤tigen Sie, wenn Sie fertig sind.",
        272: "Der Wasserstand ist noch immer niedrig, Ã¼berprÃ¼fen Sie ihn nochmals.",
        273: "Der Wasserstand ist noch immer niedrig, Ã¼berprÃ¼fen Sie ihn nochmals.",
        274: "ÃberprÃ¼fen Sie den Wasserstand im BehÃ¤lter des Befeuchters.",
        275: "Bitte warten",
        280: "Computer wird neugestartet",
        281: "Computer wird heruntergefahren",
        300: "Gebinde wird nicht erkannt. Bitte prÃ¼fen Sie, ob das Gebinde richtig platziert ist.",
        301: "Wird vorbereitet, bitte warten",
        302: "Wird beendet, bitte warten",
        303: "Diese Rezeptur kann nicht dosiert werden, da sie das Pigment enthÃ¤lt: %{0} und die Pigmentmenge Ã¼ber der fÃ¼r den Kanister definierte maximale Abgabemenge ist.",
        304: "Diese Rezeptur kann nicht dosiert werden, da sie die Pigmente enthÃ¤lt: %{0} und die Pigmentmengen Ã¼ber der fÃ¼r die Kanister definierten maximalen Abgabemengen ist.",
        305: "Das Pigment: %{0} kann nicht auf einmal dosiert werden, mÃ¶chten Sie die Rezeptur aufteilen?",
        306: "Die Pigmente: %{0} kÃ¶nnen nicht auf einmal dosiert werden, mÃ¶chten Sie die Rezeptur aufteilen?",
        307: "Das Pigment: %{0} kann nicht dosiert werden, mÃ¶chten Sie fortfahren und das Pigment manuell hinzufÃ¼gen?",
        308: "Die Pigmente: %{0} kÃ¶nnen nicht dosiert werden, mÃ¶chten Sie fortfahren und die Pigmente manuell hinzufÃ¼gen?",
        309: "Die ausgewÃ¤hlte Rezeptur enthÃ¤lt keine Pigmente, die Base kann so verwendet werden, wie sie ist.",
        310: "Es wird kein Pigment wird dosiert, bitte das Basengebinde fÃ¼r die manuelle zugabe vorbereiten.",
        311: "Basengebinde entfernen und die manuelle Pigmentzugabe vorbereiten.",
        312: "Bitte manuell die Menge %{0} %{1} von der Pigment: %{2} hinzufÃ¼gen und bestÃ¤tigen, wenn erledigt",
        313: "Rezeptur manuell dosieren",
        314: "Die ausgewÃ¤hlte Rezeptur verstÃ¶Ãt gegen die ÃberfÃ¼llungsregel. Die Gesamtmenge des Pigments: %{0} %{1}, maximal zulÃ¤ssige Menge der Pigmente: %{2} %{3}. MÃ¶chten Sie trotz dieser Warnung fortfahren?",
        315: "UFI-Code des Basengebindes scannen oder eingeben",
        316: "UFI-Code des Basengebindes scannen oder eingeben fÃ¼r Produkt: %{0}|Basis: %{1}|DosengrÃ¶Ãe: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatische Reinigung wird gestartet.",
        401: "Automatische Reinigung wird gestartet.",
        405: "Der BÃ¼rstenbehÃ¤lter muss gereinigt werden.",
        406: "Der BÃ¼rstenbehÃ¤lter muss gereinigt werden.",
        410: "Die automatische Reinigung des Cap wird gestartet.",
        411: "Die automatische Reinigung des Cap wird gestartet.",
        415: "Das Switch plate (die Schalterplatte) des Dispensers muss gereinigt werden",
        416: "Das Switch plate (die Schalterplatte) des Dispensers muss gereinigt werden",
        420: "Der Dispenser muss gereinigt werden.",
        421: "Der Dispenser muss gereinigt werden.",
        425: "Das NachfÃ¼llen der PastenbehÃ¤lter wird gestartet.",
        426: "Das NachfÃ¼llen der PastenbehÃ¤lter wird gestartet.",
        430: "Der Neustart des Computers wurde geplant.",
        431: "Der Neustart des Computers wurde geplant.",
        435: "Das Herunterfahren des Computers wurde geplant.",
        436: "Das Herunterfahren des Computers wurde geplant.",
        440: "Die Reinigung des Dispensers wurde geplant.",
        441: "Die Reinigung des Dispensers wurde geplant.",
        445: "Das Rezirkulieren des Dispensers wurde geplant.",
        446: "Das Rezirkulieren des Dispensers wurde geplant.",
        450: "Das RÃ¼hren der Kanister des Dispensers wurde geplant.",
        451: "Das RÃ¼hren der Kanister des Dispensers wurde geplant.",
        990: "Der Dispenser hat den Fehler gemeldet: %{0}: %{1}. MÃ¶chten Sie den Dosierauftrag wiederholen?",
        991: "Interner Fehler aufgetreten: %{0}",
        200000001: "Gebinde platzieren",
        200000002: "Gebinde entfernen",
        200000003: "FÃ¼llstand fÃ¼r '%{0}' unterhalb der Mindestdosiermenge, weiterdosieren auf eigenes Risiko?",
        200000004: "%{0} auffÃ¼llen"
    },
    rccDriverSettings: {
        databasePath: "Datenbankpfad",
        dispenser: "Dispenser",
        dispenserConfigurationFile: "Konfigurationsdatei des Dispensers",
        driverPath: "Pfad der Treiber",
        extensionPath: "Pfad der Erweiterungen",
        folder: "Ordner",
        formulaPath: "Pfade fÃ¼r Rezepturen",
        host: "Host",
        iddPath: "IDD-Konfigurationsdatei",
        italtintoPath: "Italtinto-Konfigurationsverzeichnis",
        lldPath: "HLD Hauptverzeichnis",
        machineType: "Maschinentyp",
        noMachineAvailable: "Keine Maschine verfÃ¼gbar",
        protocolVersion: "Protokoll-Version",
        rccDriverSettings: "Treibereinstellungen",
        resultPath: "Ergebnisverzeichnis",
        save: "Einstellungen speichern",
        saveSettingsWarning: "Warnung! Ãnderungen in diesem Abschnitt kÃ¶nnen zu Fehlfunktionen des Dispensers fÃ¼hren.",
        serviceSwPath: "Service-Pfad der Software",
        simulationPath: "Pfad der Simulationsdatei"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Manuelles HinzufÃ¼gen der Pigmente zulassen",
        ask: "Fragen",
        canHandlingOptions: "Optionen fÃ¼r die Handhabung von Gebinden",
        checkCanBeforeDispense: "Gebinde vor Dosierung prÃ¼fen",
        checkOverfill: "ÃberfÃ¼llung des Gebindes prÃ¼fen",
        colorantBatchNumbers: "Batchnummern des Pigments",
        colorantPackageValidation: "BestÃ¤tigung der Verpackungen der Pigmentkonzentrate",
        disable: "Deaktivieren",
        dispenseInvalidColorants: "UngÃ¼ltige Pigmente dosieren",
        dispensingOptions: "Dosier-MÃ¶glichkeiten",
        enable: "Aktivieren",
        enableUserIdentification: "Identifizierung des Maschinenbedieners",
        fullValidation: "VollstÃ¤ndige BestÃ¤tigung",
        machineAccuracyWarning: "Warnung zur Genauigkeit der Maschine",
        machineOptions: "Machinen-Optionen",
        machineUnit: "Maschineneinheit",
        minimalDispenseAmount: "Minimale Dosiermenge",
        placeCanSensor: "Gebindesensor aktivieren",
        placeCanSensorDelay: "VerzÃ¶gerung desGebindesensors",
        rccMachineSettings: "Maschineneinstellungen",
        refillBarcodeValidation: "Barcode beim NachfÃ¼llen bestÃ¤tigen",
        refillBarcodeValidationCanisterAndColorant: "Kanister und Pigmentkonzentrate bestÃ¤tigen",
        refillBarcodeValidationColorant: "Nur Pigmentkonzentrate bestÃ¤tigen",
        refillSettings: "Einstellungen zum NachfÃ¼llen",
        removeCanSensor: "Gebindesensor deaktivieren",
        removeCanSensorDelay: "Die VerzÃ¶gerung des Gebindesensors deaktivieren",
        save: "Einstellungen speichern",
        sec: "sek.",
        skipPlaceCanDialog: "Meldung fÃ¼r die Platzierung des Gebindes nicht anzeigen",
        skipRemoveCanDialog: "Meldung Gebinde entfernen nicht anzeigen",
        splitFormula: "Rezeptur aufteilen",
        tmcEnabled: "TMC aktivieren",
        ufiCode: "UFI-Code",
        validateBarcodeBaseCan: "Barcode des Gebindes bestÃ¤tigen",
        validateBarcodeRefill: "BestÃ¤tigung des Barcodes vor dem NachfÃ¼llen",
        validateColorantsDuringInit: "BestÃ¤tigung der Pigmente wÃ¤hrend der Initialisierung"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Es werden aktuell einige Aktionen auf der Maschine durchgefÃ¼hrt",
        addLevel: "Menge hinzufÃ¼gen",
        addManually: "Manuell hinzufÃ¼gen",
        barcodeNotSet: "Kanister %{colorantName} (%{canisterName}) hat keinen Barcode zugewiesen.",
        cancel: "Abbrechen",
        dispenseFormula: "Rezeptur dosieren",
        dispenserIdle: "Die Maschine ist bereit...",
        dispenserIsBusy: "Die Maschine ist beschÃ¤ftigt",
        dispenserIsIdle: "Die Maschine ist bereit...",
        dispenserIsReady: "Die Maschine ist bereit fÃ¼r weitere Aufgaben",
        dispensingFormula: "Rezeptur wird dosiert",
        errorCode: "Fehlercode",
        explanation: "ErlÃ¤uterung",
        fillToMax: "AuffÃ¼llen bis max",
        finished: "Beendet",
        inProgress: "In Arbeit",
        machineIsReady: "Maschine ist bereit",
        moveToFill: "Zum NachfÃ¼llen bewegen",
        noMachineDialog: "Es ist keine Maschine angeschlossen",
        of: "von",
        packageSize: "GebindegrÃ¶Ãe",
        placeBaseCan: "Gebinde platzieren",
        pleaseCheckYourMachineConnection: "Bitte Ã¼berprÃ¼fen Sie Ihren Maschinenanschluss.",
        pleaseRefill: "Bitte nachfÃ¼llen",
        solution: "LÃ¶sung",
        subErrors: "Teilweise Fehler",
        timeToEnd: "Zeit bis zum Ende",
        tintingFormula: "Dosierung der Rezeptur",
        tintingPleaseWait: "Dosierung, bitte warten Sie",
        validateBaseCan: "Gebinde bestÃ¤tigen",
        waiting: "Warten"
    },
    rccSettigns: {
        rccSettigns: "RCC-Verbindung",
        rccUrl: "RCC-URL"
    },
    rccSpectroDialog: {
        100: "Verbindung zu Ihrem GerÃ¤t Ã¼ber Bluetooth herstellen. ÃberprÃ¼fen Sie bitte, dass Bluetooth aktiviert ist und Ihr Instrument eingeschaltet ist.",
        101: "Instrument wurde nicht erkannt. MÃ¶chten Sie es erneut versuchen?",
        110: "Stellen Sie sicher, dass Nano angeschlossen ist, und drÃ¼cken Sie die Instrumententaste, um die Initialisierung zu starten",
        111: "Nano wurde nicht erkannt. MÃ¶chten Sie es erneut versuchen?",
        112: "Nano abschalten, 10 Sekunden warten, erneut anschlieÃen und fortfahren",
        120: "Verbindet sich mit Ihrem GerÃ¤t, bitte warten Sie.",
        121: "Das GerÃ¤t wurde nicht erkannt. MÃ¶chten Sie es noch einmal versuchen?",
        200: "Platzieren Sie das Spectrometer auf der schwarze Kalibrierkachel und fahren Sie fort oder drÃ¼cken Sie die Taste auf dem Spectrometer",
        201: "Legen Sie das Instrument auf eine schwarze Kalibrierkachel und fahren Sie fort",
        202: "Stellen Sie das Instrument auf eine schwarze Kalibrierkachel und drÃ¼cken Sie die Instrumententaste",
        205: "Stellen Sie das Instrument auf eine weiÃe Kalibrierkachel und fahren Sie fort oder drÃ¼cken Sie die Instrumententaste",
        206: "Legen Sie das Instrument auf eine weiÃe Kalibrierkachel und fahren Sie fort",
        207: "Stellen Sie das Instrument auf eine weiÃe Kalibrierkachel und drÃ¼cken Sie die Instrumententaste",
        210: "Legen Sie das Instrument auf die Diagnosekachel und fahren Sie fort oder drÃ¼cken Sie die Instrumententaste",
        211: "Legen Sie das Instrument auf die Diagnosekachel und fahren Sie fort",
        212: "Legen Sie das Instrument auf die Diagnosekachel und drÃ¼cken Sie die Instrumententaste",
        215: "SchlieÃen Sie die Abdeckung des Spectros und fahren Sie fort oder drÃ¼cken Sie die Taste auf dem Spectrometer",
        216: "SchlieÃen Sie die Instrumentenabdeckung und fahren Sie fort",
        217: "SchlieÃen Sie die Instrumentenabdeckung und drÃ¼cken Sie die Instrumententaste",
        220: "Stellen Sie das Instrument auf die Null-Kachel und fahren Sie fort oder drÃ¼cken Sie die Instrumententaste",
        221: "Stellen Sie das Instrument auf eine Null-Kachel und fahren Sie fort",
        222: "Stellen Sie das Instrument auf eine Null-kachel und drÃ¼cken Sie die Instrumententaste",
        224: "Setzen Sie das GerÃ¤t auf die Kalibrierungsunterlage und fahren Sie fort oder drÃ¼cken Sie die entsprechende Taste auf dem GerÃ¤t",
        225: "Legen Sie das GerÃ¤t auf die Kalibrierungsunterlage und fahren Sie fort",
        226: "Legen Sie das GerÃ¤t auf das Kalibrierungsunterlage und drÃ¼cken Sie die GerÃ¤tetaste",
        227: "Legen Sie das GerÃ¤t auf das Kalibrierungsunterlage und drÃ¼cken Sie die GerÃ¤tetaste",
        295: "Beenden Sie die Kalibrierung im Treiberfenster",
        296: "Das GerÃ¤t ist nicht angeschlossen. MÃ¶chten Sie die Verbindung zum GerÃ¤t herstellen?",
        297: "Kalibrierungsschritt wird vorbereitet, bitte warten",
        298: "Kalibrierung, bitte warten Sie",
        299: "Kalibrierungsschritt wird abgeschlossen, bitte warten",
        300: "Legen Sie das Instrument auf die Probe und fahren Sie fort oder drÃ¼cken Sie die Instrumententaste",
        301: "Legen Sie das Instrument auf Probe und fahren Sie fort",
        302: "Legen Sie das Instrument auf die Probe und drÃ¼cken Sie die Instrumententaste",
        303: "Das GerÃ¤t ist nicht kalibriert. MÃ¶chten Sie mit der Kalibrierung fortfahren?",
        304: "Das GerÃ¤t ist nicht angeschlossen. MÃ¶chten Sie die Verbindung zum GerÃ¤t herstellen?",
        390: "Messmethode auswÃ¤hlen",
        395: "Beenden Sie die Messung im Treiberfenster",
        397: "Vorbereitung zum Messen, bitte warten",
        398: "Messen, bitte warten Sie",
        399: "Messen abschlieÃen, bitte warten",
        498: "Herunterladen der Messung, bitte warten",
        499: "Herunterladen aller Messungen. Bitte warten Sie",
        900: "GerÃ¤tefehler aufgetreten %{0}: %{1}. MÃ¶chten Sie die Aufgabe wiederholen?",
        901: "Interner Fehler aufgetreten: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Der Computer muss Ã¼ber eine Bluetooth-Verbindung verfÃ¼gen. Das Spectro muss mit dem Computer gekoppelt werden. Windows 10 mit mindestens Stand 2018 erforderlich.",
        DatacolorSilent:
            "Im Silent-Modus werden die Datacolor-Fenster direkt in %{name} angezeigt. In diesen Fenstern kÃ¶nnen die Spektralparameter nicht geÃ¤ndert werden.",
        DatacolorUseDiagnosticTile: "Die Verwendung der Diagnosekacheln verbessert die QualitÃ¤t der Messungen.",
        comPort: "COM-Anschluss",
        diagnosticTile: "Datacolor-Diagnosekachel verwenden",
        measureModes: "Messmethoden",
        measureModesOrder: "Reihenfolge der Messmethoden",
        model: "Modell",
        noSpectroAvailable: "Es ist kein Spektrometer verfÃ¼gbar",
        rccSpectroSettings: "Spectrometer-Einstellungen",
        save: "Einstellungen speichern",
        silent: "Datacolor Matching ausblenden",
        simulationPath: "Simulationspfad",
        spectroType: "Spectro-Typ",
        useProfiledValues: "Verwenden Sie profilierte Werte"
    },
    recirculateChannels: {
        recirculateAllChannels: "Alle Kanister rezirkulieren",
        recirculateChannels: "Kanister rezirkulieren",
        recirculatingSpeed: "Rezirkulationsgeschwindigkeit",
        recirculatingTime: "Rezirkulationszeit",
        startRecirculating: "Rezirkulation starten"
    },
    redlikeLight: {
        finishPreviousSteps: "Bitte beenden Sie zuerst die vorherigen Schritteâ¦",
        searchBySpectro: "Nach einem Spectro suchen",
        searchFormula: "Rezeptur suchen",
        selectBase: "Base auswÃ¤hlen",
        selectColor: "Farbton auswÃ¤hlen",
        selectCustomer: "Kunde auswÃ¤hlen",
        selectFandeck: "Kollektion auswÃ¤hlen",
        selectPackage: "Gebinde auswÃ¤hlen",
        selectProduct: "Produkt auswÃ¤hlen",
        startSelectFandeck: "FarbtonfÃ¤cher auswÃ¤hlen",
        startSelectProduct: "Produkt auswÃ¤hlen",
        stepByStepProgress: "Sie kÃ¶nnen Schritt fÃ¼r Schritt vorgehen",
        typeHereToSearch: "Hier eingeben, um zu suchen",
        typeToFilter: "Eingeben, um zu filtern"
    },
    restartModal: {
        computerNeedsRestart: "Der Computer muss neu gestartet werden!",
        notCompletelyTranslated:
            "Nach dem Ãndern der Sprache muss die Software neu gestartet werden. Es wurden einige Ãnderungen in der Ãbersetzung vorgenommen, die erst nach einem Neustart im Programm angezeigt werden.",
        restartIsRequired: "Nach DurchfÃ¼hrung der Ãnderungen ist ein Neustart der Software erforderlich.",
        softwareNeedsRestart: "%{name} muss neu gestartet werden!"
    },
    searchPanel: {
        basePlaceholder: "Base eingeben oder auswÃ¤hlen",
        baseStartPlaceholder: "Name der Base eingeben oder auswÃ¤hlen",
        colorCodeNamePlaceholder: "Farbtonnummer/-name eingeben oder auswÃ¤hlen",
        colorCodeNameStartPlaceholder: "Farbtonnamen/-nummer eingeben oder auswÃ¤hlen",
        colorCodePlaceholder: "Farbtonnummer eingeben oder auswÃ¤hlen",
        colorCodeStartPlaceholder: "Farbtonnummer eingeben oder auswÃ¤hlen",
        colorNameCodePlaceholder: "Farbtonnamen/-nummer eingeben oder auswÃ¤hlen",
        colorNameCodeStartPlaceholder: "Farbtonnummer/-name eingeben oder auswÃ¤hlen",
        colorNamePlaceholder: "Farbtonnamen eingeben oder auswÃ¤hlen",
        colorNameStartPlaceholder: "Farbtonnamen eingeben oder auswÃ¤hlen",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "FarbtonfÃ¤cher eingeben oder auswÃ¤hlen",
        fandeckStartPlaceholder: "FarbtonfÃ¤cher eingeben oder auswÃ¤hlen",
        formulaByColor: "Rezeptur nach Farbton",
        noResultsFound: "Keine Rezepturen gefunden",
        packagePlaceholder: "Gebinde eingeben oder auswÃ¤hlen",
        packageStartPlaceholder: "Gebinde eingeben oder auswÃ¤hlen",
        productPlaceholder: "Produkt eingeben oder auswÃ¤hlen",
        productStartPlaceholder: "Produkt eingeben oder auswÃ¤hlen",
        standard: "Rezepturdatenbank",
        typeFandeckToFilter: "Bitte hier den Namen der Kollektion eingeben, um zu filtern",
        typeProductToFilter: "Bitte hier den Namen des Produkts eingeben, um zu filtern"
    },
    sendOrderModal: {
        customNote: "Individuelle Anmerkung",
        noCompatibleServers: "In Ihrem Netzwerk sind keine kompatiblen Server verfÃ¼gbar",
        orderOverview: "AuftragsÃ¼bersicht",
        selectTargetMachine: "Zielmaschine auswÃ¤hlen",
        sendOrder: "Auftrag senden",
        sendOrderTo: "Ihr Auftrag wird an %{serverName} gesendet",
        targetMachine: "Zielmaschine"
    },
    server: {
        computerId: "Computer ID",
        ip: "IP",
        selectServer: "Bitte wÃ¤hlen Sie einen der verfÃ¼gbaren Server aus",
        server: "Server"
    },
    serverDialog: {
        1: "Es liegt ein Fehler in der Softwaredefinition Ihrer Lizenz vor. Bitte Ã¼berprÃ¼fen Sie dies mit Ihrem Softwareanbieter.",
        2: "Konnte keine Daten verarbeiten fÃ¼r %{0}: %{1}",
        3: "UngÃ¼ltiger Netzwerk-Pfad",
        4: "UngÃ¼ltiger Pfad-Typ (nur %{0} und %{1} Typen sind mÃ¶glich)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Farbstoff mit Namen: '%{0}' in Zeile '%{1}' konnte nicht gefunden werden.",
        8: "GebindegrÃ¶Ãe mit dem Namen: '%{0}' in Zeile '%{1}' konnte nicht gefunden werden.",
        9: "Der Basenname fÃ¼r das Produkt: '%{0}' und die Base: '%{1}' in Zeile '%{2}' konnte nicht gefunden werden.",
        10: "Keine Base bei den GebindegrÃ¶Ãen des Produkts: '%{0}', Base: '%{1}' und GebindegrÃ¶Ãe: '%{2}' in der Zeile '%{3}'",
        11: "Preise konnten nicht analysiert werden: '%{0}' in der Zeile '%{1}' im Arbeitsblatt '%{2}'",
        12: "Die Datenstruktur hat sich geÃ¤ndert. Die Basen werden angepasst, bitte wartenâ¦",
        13: "Die Datenstruktur hat sich geÃ¤ndert. Die Basen des Produktes werden angepasst, bitte wartenâ¦",
        14: "Die Datenstruktur hat sich geÃ¤ndert. Die GebindegrÃ¶Ãen der Basen des Produktes werden angepasst, bitte wartenâ¦",
        15: "Die Datenstruktur hat sich geÃ¤ndert. Die Farbdaten werden angepasst, bitte wartenâ¦",
        16: "Die Datenstruktur hat sich geÃ¤ndert. Die Farben in den Kollektionen/FarbtonfÃ¤chern werden angepasst, bitte wartenâ¦",
        17: "Die Datenstruktur hat sich geÃ¤ndert. Die Kollektionen/FarbtonfÃ¤cher werden angepasst, bitte wartenâ¦",
        18: "Die Datenstruktur hat sich geÃ¤ndert. Die Daten fÃ¼r die globale Suche werden angepasst, bitte wartenâ¦",
        19: "Die Datenstruktur hat sich geÃ¤ndert. Die Daten der Produkte werden angepasst, bitte wartenâ¦",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Aktive Server-Plugins",
        currentlyActive: "Derzeit aktive Plugins",
        plugin: "Plugin",
        pluginName: "Name des Plugins",
        statusActive: "Aktiv",
        statusInactive: "Nicht aktiv"
    },
    serviceActionsSettings: {
        canisterLevel: "Kanister FÃ¼llstand",
        capClose: "SchlieÃen",
        capMiddle: "Mitte",
        capOpen: "Ãffnen",
        cleanAllChannels: "Alle DÃ¼sen reinigen",
        cleanChannels: "DÃ¼sen reinigen",
        computer: "Computer",
        computerReboot: "Computer-Neustart",
        computerShutdown: "Computer-Ausschalten",
        connectMachine: "Maschine anschlieÃen",
        general: "Allgemeines",
        initialize: "Initialisieren",
        noMachineIsConnected: "Es ist keine Maschine angeschlossen !",
        plug: "Einstecken",
        plugger: "Stecker",
        punch: "Stanzen",
        puncher: "Stanzer",
        purgeChannels: "Kanister spÃ¼len",
        recirculate: "Rezirkulieren",
        recirculateAllChannels: "Alle Kanister rezirkulieren",
        recirculateChannels: "Kanister rezirkulieren",
        serviceActions: "Serviceaktionen",
        setCanisterLevel: "Kanister FÃ¼llstand",
        shelfDown: "Hubtisch herunterfahren",
        shelfUp: "Gebindetisch nach oben",
        showServiceWindow: "Servicefenster anzeigen",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "FehlerrÃ¼cksetzung starten",
        startHardReset: "Hard Reset starten",
        startReset: "Reset starten",
        stirAllCanisters: "Alle Kanister rÃ¼hren",
        stirCanisters: "Kanister rÃ¼hren",
        stirCanistersMore: "Kanister rÃ¼hren"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Vergleichen Sie das Farbmuster mit der Glanzskala und wÃ¤hlen Sie die Glanzstufe",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibrieren",
        calibrateInstrument: "Instrument kalibrieren",
        connectDevice: "GerÃ¤t verbinden",
        connectedTo: "Verbunden mit",
        connectingDevice: "GerÃ¤t wird verbunden",
        deselectAll: "Alle abwÃ¤hlen",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "GerÃ¤t ist nicht kalibriert.",
        eraseResult: "LÃ¶schergebnis",
        filter: "Filter",
        foundInFormulas: "In Farbtonen gefunden:",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Ihr GerÃ¤t muss kalibriert werden.",
        manualInput: "Manuelle Eingabe",
        measure: "Messen",
        measurementResult: "Messergebnis",
        noFilters: "Keine Filter verfÃ¼gbar",
        noFormulas: "Keine FarbtÃ¶ne gefunden",
        noSelectedSpectro: "Kein Spektro ausgewÃ¤hlt.",
        notSelected: "Nicht ausgewÃ¤hlt",
        pressConnectButton:
            "Versichern Sie sich, dass Ihr GerÃ¤t angeschlossen ist und drÃ¼cken Sie die Verbindungstaste.",
        searchFormulas: "Rezepturen suchen",
        selectSpectro: "Spectro auswÃ¤hlen",
        showDetails: "Details anzeigen",
        skipCalibration: "Kalibrierung Ã¼berspringen",
        spectroIsConnected: "Spectro ist verbunden",
        spectroIsReady: "Spectro ist bereit",
        spectroReady: "GerÃ¤t ist bereit",
        startCalibrateNow: "Kalibrierung starten",
        startMeasureText: "Ihr GerÃ¤t wurde kalibriert und Sie kÃ¶nnen mit der Messung beginnen.",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) Toleranz"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Manuelle %{1} %{2}",
        deleteSelectedRecords: "AusgewÃ¤hlte DatensÃ¤tze lÃ¶schen",
        exportHistory: "Historie exportieren",
        finishFormula: "Rezeptur beenden",
        foundInFormulas: "In Rezepturen der aktuellen Datenbank gefunden",
        hideHiddenRecords: "Versteckte DatensÃ¤tze nicht anzeigen",
        hideSelectedRecord: "AusgewÃ¤hlten Datensatz verstecken",
        historicalFormula: "Historische Rezeptur",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "AusgewÃ¤hlten Datensatz wiederherstellen",
        showAllRecords: "Alle DatensÃ¤tze anzeigen",
        standardFormula: "Standardrezeptur",
        unknownFormula: "Unbekante Rezeptur"
    },
    stirCanisters: {
        selectCanisters: "Kanister auswÃ¤hlen",
        startStirring: "RÃ¼hren starten",
        stirAllCanisters: "Alle Kanister rÃ¼hren",
        stirCanisters: "Kanister rÃ¼hren",
        stirringSpeed: "RÃ¼hrgeschwindigkeit",
        stirringTime: "RÃ¼hrzeit"
    },
    stock: {
        addColorant: "Pigmentkonzentrat hinzufÃ¼gen",
        addColorantPackagesToStock: "Pigmentkonzentrate zum Bestand hinzufÃ¼gen",
        addPackagesToStock: "Gebinde zum Bestand hinzufÃ¼gen",
        addedToStock: "Zum Bestand hinzugefÃ¼gt",
        allDatabases: "Alle Datenbanken",
        checkStockPackageInventory:
            "Wenn Sie ein Gebinde aus dem Lagerbestand verwendet haben, Ã¼berprÃ¼fen Sie bitte, ob Ihr Lagerbestand noch korrekt ist.",
        clearAllItems: "Alle EintrÃ¤ge lÃ¶schen",
        colorantInventory: "Inventur der Pigmentkonzentrate",
        colorantsStockInventory: "Bestand der Pigmentkonzentrate",
        confirmSendingOrder: "Senden des Auftrags bestÃ¤tigen",
        consumptionPrediction: "Vorhersage des Verbrauchs der nÃ¤chsten %{weeks} Wochen",
        createOrder: "Auftrag erstellen (%{sum})",
        expirationDate: "Verfallsdatum",
        inDelivery: "Wird geliefert",
        manualOrder: "Manuelle Bestellung",
        manualOrderProgress: "Schritt %{step}/%{total}",
        noPackagesFoundInStockForColorant: "Von diesem Pigmentkonzentrat sind keine Einheiten auf Lager.",
        onStock: "Im Bestand",
        orderSummary: "Zusammenfassung der Bestellung",
        prediction: "Vorhersage",
        removePackageFromStock: "%{colorantName} Verpackung aus dem Bestand entfernen",
        removePackageNameFromStock: "MÃ¶chten Sie die %{packageName} Verpackung aus dem Bestand lÃ¶schen ?",
        scanBarcodeOrSelectColorant: "Scannen des Barcodes von der Verpackung oder das Pigmentkonzentrat auswÃ¤hlen",
        selectPackageToRemove: "Zu entfernende Verpackung auswÃ¤hlen",
        sendConfirmed: "BestÃ¤tigung senden",
        setAmountsByPrediction: "Anzahl fÃ¼r Vorhersage festlegen",
        sortByColorantName: "Sortierung nach Name des Pigmentkonzentrats",
        sortByOrderNeed: "Sortierung nach Bedarf des Pigmentkonzentrats",
        sortByStockLevel: "Sortierung nach Bestand des Pigmentkonzentrats",
        toOrder: "Zu bestellen"
    },
    testBarcode: {
        noItemAssigned: "Dem Barcode %{code} ist kein Artikel zugeordnet.",
        pleaseScanBarcode:
            "Zum Testen scannen Sie bitte einen Barcodeâ¦ (eines Gebindes, Produkts, Verpackung oder sonstiges)",
        testBarcodes: "Barcodes testen"
    },
    ticketing: {
        answer: "Antwort",
        answered: "Beantworted",
        chooseType: "Ticketart auswÃ¤hlen",
        closeRequest: "Ticketanfrage schlieÃen",
        comment: "Kommentar",
        create: "Ticket erstellt",
        createNewTicket: "Neues Ticket erstellen",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Rezepturanforderung",
        formulaRequest: "Rezepturanfrage",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound:
            "POS-Information (Name, Ort) nicht gefunden. Bitte tragen Sie diese Informationen in den Einstellungen ein.",
        noTicketSelected: "Kein ticket ausgewÃ¤hlt",
        openTicket: "Open ticket",
        posName: "POS Name",
        posted: "Ticket gesendet",
        request: "Ticketanfrage",
        requestDate: "Anfragedatum",
        requestId: "Anfrage-ID",
        resolvedBy: "Ticket gelÃ¶st durch",
        responseDate: "Antwortdatum",
        saveToCustomFormula: "Rezeptur des Tickets als Eigenrezeptur abspeichern",
        sending: "Ticket wird gesendetâ¦",
        service: "Service",
        successfulCreation: "Ticket erfolgreich erstellt. Das Ticket wird nun gesendetâ¦",
        ticketAnswered: "Ein Ticket wurde beantwortet.",
        ticketDelivered: "Das Ticket wurde zugestellt.",
        ticketId: "Ticket ID",
        ticketType: "Ticket-Art auswÃ¤hlen",
        waitingForAnswer: "Warten auf die Antwort des Ticketsâ¦"
    },
    tutorial: {
        last: "Zur letzten Anleitung",
        next: "Zur nÃ¤chsten Anleitung"
    },
    ufiCodeModal: {
        currentStatus: "Aktueller Status",
        detailedInfoForColorant: "Detaillierte Informationen zum Pigment %{colorantName}",
        userSetUfiCode: "Vom Benutzer eingestellter UFI-Code, aktueller Wert"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "UFI-Code-Validierung der Base",
        confirmColorantRefilling: "NachfÃ¼llen des Pigmentkonzentrats bestÃ¤tigen",
        enableUfiCodes: "UFI codes aktivieren",
        printUfiCode: "Drucken, wenn die Menge des Pigments zu hoch ist",
        printUfiCodePercentage: "% der ÃberfÃ¼llung ausdrucken, wenn die Menge des Pigments zu hoch ist",
        scanOrTypeUfiCode: "UFI-Code scannen oder eingeben",
        scanOrTypeUfiCodeOfBase: "UFI-Code des Gebinde scannen oder eingeben",
        ufiCodesByPercentage: "UFI-Codes prozentual verwenden",
        ufiCodesFromDatabase: "UFI-Codes aus der Datenbank verwenden",
        ufiCodesFromLastFilling: "UFI-Codes von der letzten BefÃ¼llung verwenden"
    },
    userSettings: {
        addUser: "Benutzer hinzufÃ¼gen",
        assignedUserGroups: "Zugeordnete Benutzergruppen",
        availableUserGroups: "VerfÃ¼gbare Benutzergruppen",
        barcode: "Barcode",
        confirmNewPassword: "Passwort bestÃ¤tigen",
        editPassword: "Passwort bearbeiten",
        editUser: "Benutzer bearbeiten",
        enableAutoLogin: "Autologin erlauben",
        newPassword: "Neues Passwort",
        noChange: "Es gibt keine Ãnderungen, die gespeichert werden mÃ¼ssen.",
        oldPassword: "Altes Passwort",
        password: "Passwort",
        passwordsDoNotMatch: "Passwort stimmt nicht",
        restoreUser: "Dieser Benutzer wurde gelÃ¶scht. MÃ¶chten Sie den Benutzers wiederherstellen?",
        userGroup: "User Group",
        userGroups: "Benutzergruppen",
        userManagement: "Benutzerverwaltung",
        userSettings: "Benutzereinstellungen",
        username: "Benutzername",
        usernameIsMissing: "Benutzername fehlt"
    },
    warningMissingDataModal: {
        continue: "Es fehlen dieselben Daten, wollen Sie fortfahren?",
        notFoundBase:
            "Diese Produktbase ist nicht verfÃ¼gbar. BestÃ¤tigen Sie und achten Sie darauf eine kompatible Produktbase aus dem Regal zu bekommen oder stornieren Sie diese Bestellung.",
        notFoundProduct:
            "Dieses Produkt ist nicht verfÃ¼gbar. BestÃ¤tigen Sie und achten Sie darauf, ein kompatibles Produkt aus dem Regal zu bekommen oder stornieren Sie diese Bestellung."
    },
    weekdays: {
        friday: "Freitag",
        monday: "Montag",
        saturday: "Samstag",
        sunday: "Sontag",
        thursday: "Donnerstag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch"
    },
    welcome: {
        availableDatabase:
            "Der Server kann sich nicht mit der Datenbank verbinden. Bitte Ã¼berprÃ¼fen Sie Ihre Datenbankkonfiguration.",
        availableDatabaseLocalError:
            "Fehler beim Verbinden mit der lokalen Datenbank (falsche Datei, ungÃ¼ltiges Passwort)",
        availableDatabaseLocalMissing: "Lokale Datenbankdatei fehlt",
        availableDatabaseLocalUpdate: "Die lokale Datenbank muss auf die neue Version aktualisiert werden",
        availableDatabaseMainAndLocalError:
            "Fehler beim Verbinden mit der Haupt- und der lokalen Datenbank (falsche Datei oder ungÃ¼ltiges Passwort)",
        availableDatabaseMainAndLocalMissing: "Haupt- und lokale Datenbankdateien fehlen (Main and local db)",
        availableDatabaseMainAndLocalUpdate:
            "Sowohl die Hauptdatenbank als auch die lokale Datenbank mÃ¼ssen auf die neue Version aktualisiert werden",
        availableDatabaseMainError:
            "Fehler beim Verbinden mit der Hauptdatenbank (falsche Datei oder ungÃ¼ltiges Passwort)",
        availableDatabaseMainMissing: "Die Hauptdatenbankdatei (Main DB) fehlt",
        availableDatabaseMainPartialUpdate:
            "Die Hauptdatenbank muss Ã¼ber eine Teilaktualisierung auf die neuere Version aktualisiert werden.",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Die Haupt- und die lokale Datenbank muss Ã¼ber eine Teilaktualisierung auf die neuere Version aktualisiert werden.",
        availableDatabaseMainUpdate: "Die Hauptdatenbank muss auf die neue Version aktualisiert werden.",
        closing: "Das Programm wird geschlossen",
        compatibility:
            "Bitte Ã¼berprÃ¼fen Sie die Version Ihres Servers. Ihr Client ist nur mit der Serverversion %{0} oder hÃ¶her kompatibel.",
        compatibilityCheck: "KompatibilitÃ¤tsprÃ¼fung wird gerade durchgefÃ¼hrt",
        compatibilityDatabase:
            "Ihre Datenbank ist nicht mit dem Server kompatibel. Bitte Ã¼berprÃ¼fen Sie Ihre Datenbankkonfiguration.",
        connectingServer: "Verbindung zum Server %{ip}",
        databaseCompatibility: "Ihre Datenbank ist mit der aktuellen Softwareversion nicht kompatibel.",
        databasesCompatibility: "Ihre Datenbanken sind mit der aktuellen Softwareversion nicht kompatibel.",
        licenseVerification: "LizenzÃ¼berprÃ¼fung lÃ¤uft",
        loading: "Wird geladen",
        lostConnection: "Die Verbindung zum Server wurde unterbrochen",
        moduleMessage:
            "Achten Sie auf die Auswahl des Moduls, da kÃ¼nftige Ãnderungen des Moduls nur fÃ¼r privilegierte Benutzer verfÃ¼gbar sein werden.",
        refresh: "Aktualisieren",
        restoring: "Verbindung wird wiederhergestellt",
        selectModule: "Bitte wÃ¤hlen Sie eines der verfÃ¼gbaren Module aus.",
        stopUpdate: "Update beenden",
        updateDatabase: "Update der Datenbankâ¦",
        updatingDatabase: "Update der Datenbank lÃ¤uftâ¦",
        updatingDatabases: "Update der Datenbanken lÃ¤uftâ¦",
        updatingWarning: "Bitte warten Sie wÃ¤hrend die Datenbankstruktur auf die neue Version upgedated wird.",
        updatingWarningInfo:
            "Unterbrechen Sie diesen Updatevorgang nicht. Bei einem Abbruch mÃ¼sste das komplette Update erneut durchgefÃ¼hrt werden."
    }
};
